var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _button, _pes, _liveVitalStats, _loadControl, _offline;

var mobile = {
  "nav": {
    "today": "Status",
    "history": "Energie",
    "layout": "Serie",
    "menu": "Menu"
  },
  "button": (_button = {
    "cancel": "Annuleren",
    "done": "Klaar",
    "login": "Aanmelden",
    "today": "Vandaag",
    "submit": "Indienen",
    "ok": "Oke",
    "choose_file": "Kies bestand",
    "refresh": "Vernieuwen",
    "send": "Sturen",
    "skip": "Overspringen",
    "clickHere": "Klik hier",
    "confirm": "Bevestigen",
    "reset": "Opnieuw instellen",
    "edit": "Bewerken",
    "setNow": "Nu instellen",
    "update": "Update",
    "next": "Volgende",
    "save": "Bewaar",
    "no": "Nee",
    "yes": "Ja",
    "enable": "Inschakelen"
  }, _defineProperty(_button, "setNow", "Nu instellen"), _defineProperty(_button, "gotIt", "Begrepen"), _defineProperty(_button, "okGotIt", "OK, ik begrijp het"), _defineProperty(_button, "continue", "Doorgaan"), _defineProperty(_button, "knowMore", "Meer weten"), _defineProperty(_button, "noExportCredit", "Ik krijg geen Exportkrediet"), _defineProperty(_button, "tryLater", "Probeer later"), _defineProperty(_button, "otherNetworks", "Andere netwerken"), _button),
  "form": {
    "topic": "Onderwerp",
    "contactSupport": {
      "success": {
        "message": "Bedankt dat u contact met ons opneemt.",
        "description": "We helpen u graag met oplossen van uw probleem. Een Enphase-expert neemt spoedig contact met u op.",
        "email_notify": "Rapport wordt binnenkort verstuurd naar %{email}."
      },
      "error": {
        "message": "Opgeslagen",
        "description": "Probeer het opnieuw",
        "reset_password": "Wachtwoord vervallen. Gelieve het wachtwoord opnieuw in te stellen."
      }
    },
    "default": {
      "success": "Met Succes Opgeslagen",
      "error": "Probeer het opnieuw",
      "pleaseEnterAValue": "Voer alstublieft een waarde in",
      "permissionDenied": "Toestemming Geweigerd",
      "activeBatteryProfile": "U hebt een actief batterijprofielverzoek. Wacht op bevestiging of annuleer het verzoek om door te gaan."
    },
    "search": "Zoeken"
  },
  "common": {
    "please": "Neem",
    "contactSupport": "contact op met klantenservice",
    "forHelp": "voor hulp.",
    "videos": "Video's",
    "articles": "Artikelen",
    "new": "Nieuw",
    "startDate": "Start Datum",
    "endDate": "Einddatum",
    "clearedDate": "Goedgekeurde Datum",
    "startTime": "Start Tijd",
    "endTime": "Eind Tijd",
    "duration": "Duur"
  },
  "errors": {
    "error": "Fout",
    "errors": "Fouten",
    "warning": "Warning",
    "retry": "Opnieuw proberen",
    "email": "Voer uw e-mailadres in",
    "password": "Voer uw wachtwoord in",
    "login": "Het e-mailadres en/of het wachtwoord dat u hebt ingevoerd, komt niet overeen met onze gegevens.",
    "accInactive": "Account is inactief. Neem contact op met uw installateur en probeer het opnieuw zodra uw systeem volledig actief is.",
    "expired": "Uw aanmelding is verlopen.",
    "loggedout": "U bent afgemeld.",
    "report": "Er is een fout opgetreden.",
    "offline": "Gelieve uw internetverbinding te controleren en opnieuw te proberen.",
    "noInternet": "Geen Internet",
    "message": "Bericht",
    "tryagain": "Opnieuw proberen",
    "resetNow": "Nu Opnieuw Instellen",
    "resetPassword": "Uw wachtwoord is vervallen. Gelieve deze opnieuw in te stellen om het rapport te bekijken",
    "validEmail": "Vul alstublieft een geldig e-mailadres in",
    "validPhone": "Voer een geldig telefoonnummer in",
    "fileError": "Bedrijfslogo moet liggen tussen 0,05 kb en 4 MB.",
    "400": "Ongeldig verzoek",
    "401": "Ongeautoriseerde toegang",
    "403": "Verboden toegang",
    "404": "Bron niet gevonden",
    "422": "Entiteit kan niet worden verwerkt",
    "500": "Fout in interne server.",
    "502": "Slechte gateway.",
    "503": "Service niet beschikbaar.",
    "504": "Gateway time-out.",
    "default": "Serverfout.",
    "400_text": "Ongeldig verzoek",
    "401_text": "Ongeautoriseerde toegang",
    "403_text": "Verboden toegang",
    "404_text": "Bron niet gevonden",
    "422_text": "Entiteit kan niet worden verwerkt",
    "500_text": "Fout in interne server. Probeer het later opnieuw.",
    "502_text": "Slechte gateway. Probeer het later opnieuw.",
    "503_text": "Service niet beschikbaar. Probeer het later opnieuw.",
    "504_text": "Gateway time-out. Probeer het later opnieuw.",
    "default_text": "Serverfout. Probeer het later opnieuw.",
    "noDeviceFound": "Geen apparaat gevonden",
    "noBackupHistoryFound": "Geen backupgeschiedenis gevonden",
    "noWiFiNetworkFound": "Geen Wi-Fi-netwerk gevonden",
    "noResultFound": "geen resultaat gevonden",
    "allSites": "Alle Sites",
    "favorites": "Favorieten",
    "changesNotSaved": "Wijzigingen worden niet opgeslagen",
    "wantToExit": "Wilt u afsluiten zonder op te slaan?",
    "rateNotFound": "Percentage niet gevonden"
  },
  "login": {
    "forgot": "Wachtwoord vergeten",
    "signup": "Nieuw account",
    "header": "Aanmelden bij Enphase",
    "intro_content": "Vul in uw emailadres. U krijgt van Enphase een email met een link om uw wachtwoord te resetten.",
    "remember_me": "Mij onthouden",
    "forgot_password": "Wachtwoord vergeten?",
    "forgot_password_success": "Als u zich reeds heeft geregistreerd bij Enphase, controleer uw e-mail voor reset-instructies.",
    "caps_lock_warning": "Caps Lock is ingeschakeld.",
    "welcome_back": "Welkom terug, %{user_name}. ",
    "en_us_installer_html": "Welkom %{user_name}. Ga naar onze <a href='http://go.enphase.com/gettingstarted' target='_blank'>site voor nieuwe gebruikers</a> om alles te leren dat u moet weten over het ontwerpen, installeren en inrichten van Enphase-systemen. ",
    "en_aunz_installer_html": "Welkom %{user_name}. Ga naar onze <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>site voor nieuwe gebruikers</a> om alles te leren dat u moet weten over het ontwerpen, installeren en inrichten van Enphase-systemen. ",
    "provide_email_password": "Geef een gebruikersnaam en wachtwoord op.",
    "request_account": "Een account aanvragen",
    "subheader": {
      "new_user": "Bent u nieuw bij Enphase?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "Producten van Enphase Energy verbeteren de prestaties van zonne-energiesystemen aanzienlijk. Met de Enphase-micro-omvormers verhogen eigenaars en exploitanten de productiviteit en betrouwbaarheid van hun zonne-energiesysteem.<br/><br/>U kunt Enphase in actie zien <a href='%{systems_list_link}'>door een kijkje te nemen bij de installaties van onze klanten.</a>",
    "public_system_content_html": "Wilt u Enphase in actie zien? <a href='%{systems_list_link}'>Bekijk openbare systemen</a>.",
    "register_new_user_html": "Uw eerste Enphase systeem installeren? <a href='%{register_user_link}'>Aanmelden voor Enphase</a>",
    "recommended_browsers": "De Enphase-app is compatibel met de volgende browsers: Chrome 5 of hoger, Firefox 3.6 of hoger, Internet Explorer 10 of hoger, Microsoft Edge voor Windows, Safari 4 of hoger. Voor de Enphase-app moet u beschikken over Adobe Flash Player 10.",
    "recommended_browsers_3x": "De Enphase-app is compatibel met de volgende browsers: Chrome 44 of hoger, Firefox 41 of hoger, Internet Explorer 11, Microsoft Edge voor Windows, Safari 8 of hoger.",
    "cookies_required": "Cookies moeten zijn toegestaan.",
    "no_community": "Deze community is bestemd voor technische discussies voor Enphase-installateurs. U kunt deelnemen aan de discussies op onze <a href='https://www.facebook.com/EnphaseEnergy'>Facebook-pagina</a>.",
    "required": "U moet zich aanmelden om toegang te krijgen tot die pagina.",
    "findInstaller": "Zoek een installateur",
    "sizeYourSystem": "De grootte van uw systeem",
    "getEnphase": "Verkrijg Enphase",
    "experienceTheApp": "Ervarings-app",
    "viewStorageSystem": "Bekijk de video",
    "meetEnphase": "Maak kennis met Enphase",
    "enphaseSolar": "Enphase Zonne-energie",
    "enphaseStorage": "Enphase Opslag"
  },
  "logout": {
    "confirm_logout": "U bent afgemeld. Bedankt voor uw bezoek."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Account activeren",
      "link": "Activeer nu uw account"
    },
    "header": "Wachtwoord opnieuw instellen",
    "intro_content": "Om uw wachtwoord opnieuw te laten instellen, voert u hieronder uw e-mailadres in en klikt u op 'Versturen'. U ontvangt een e-mail met instructies over de manier waarop u uw wachtwoord opnieuw kunt instellen.",
    "login": "Aanmelden",
    "try_again": "Probeer het opnieuw.",
    "sent_message_html": "Indien u zich al hebt geregistreerd bij Enlighten, bekijk dan uw e-mail voor instructeis voor opnieuw instellen. <span style='color:red'>Als u de e-mail niet heeft ontvangen, controleer dan uw ongewenste/spam e-mail map.</span>",
    "invalid_request": "Ongeldig verzoek",
    "invalid_link": "Wachtwoord opnieuw instellen niet mogelijk. De koppeling voor het opnieuw instellen van een wachtwoord is 7 dagen geldig. Probeer het opnieuw.",
    "success": "Wachtwoord opnieuw ingesteld.",
    "failed_password_reset": "Er is een probleem opgetreden. Probeer het opnieuw.",
    "password_requirements": "Uw wachtwoord moet minstens zes tekens lang zijn, minstens één cijfer of speciaal teken bevatten en mag niet hetzelfde zijn als uw e-mailadres.",
    "note": "Wachtwoord ",
    "OK": "Oke",
    "sent_email": "We hebben een e-mail gestuurd naar",
    "rest_pwd": "Klik op de link in de e-mail om uw wachtwoord opnieuw in te stellen."
  },
  "users": {
    "new": "Registratie nieuwe gebruiker",
    "company_details": "Bedrijfsgegevens",
    "edit": "Gebruiker bewerken",
    "site_accesses": "Systeemtoegang",
    "login": "Aanmelden",
    "logged_in_as": "%{admin}, u bent aangemeld als %{user}",
    "logout_as": "Stop",
    "reset_password": "Wachtwoord opnieuw instellen",
    "preview_marketing_description": "Uitsluitend voorbeeldweergave. De wijzigingen zijn nog niet opgeslagen.",
    "preview_custom_welcome_message": "Uitsluitend voorbeeldweergave. De wijzigingen zijn nog niet opgeslagen.",
    "reset_password_confirm_html": "<b>Weet u zeker dat u het wachtwoord voor deze gebruiker opnieuw wilt instellen?</b><p>Hiermee wordt de gebruiker ingesteld op actief, wordt een nieuw wachtwoord gegenereerd en wordt een welkomste-mail naar de gebruiker verstuurd.</p>",
    "reset_password_success": "Wachtwoord opnieuw instellen geslaagd. Er wordt een welkomste-mail verzonden naar %{email} waarin het aanmeldproces wordt toegelicht.",
    "reset_password_failed": "Wachtwoord opnieuw instellen mislukt.",
    "enlighten_manager_access": "Deze gebruiker beschikt over Enlighten Manager met gegevenstoegang op moduleniveau.",
    "myenlighten_access_note": "(alleen voor gebruikers die NIET zijn gekoppeld aan een bedrijf)",
    "module_level_access_note": "(met gegevenstoegang op moduleniveau)",
    "complimentary_note": "OPMERKING: Door een gebruiker over te schakelen van MyEnlighten naar Enlighten Manager geeft u een software-activering weg ter waarde van %{price}. Deze transactie wordt gelogd en gerapporteerd aan de afdeling Financiën.",
    "purchase_note": "De software-activering is gekocht door %{email} voor %{price} op %{date}.",
    "enlighten_version_title": "Enphase app versie",
    "unlock_account": "Account ontgrendelen",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "Ik installeer Enphase-producten zelf op mijn eigen huis of bedrijf.",
    "self_installer_false": "Ik ben een professional op het gebied van zonnesystemen en registreer namens mijn bedrijf.",
    "self_register_independent": "Overig",
    "opt_in": "Ik ga akkoord met het ontvangen van nieuwsbrieven, promoties en enquêtes over producten en services van Enphase.",
    "opt_in_info": "U kunt uw toestemming op elk gewenst moment intrekken. Raadpleeg voor meer informatie het <a href='%{privacy_url}' target='_blank'>privacybeleid</a> van Enphase <a href='%{contact_url}' target='_blank'> of neem contact met ons op</a>",
    "personal_details": "Persoonlijke gegevens",
    "enable_camera": "Schakel toegang tot de camera voor uw app in via het tabblad Instellingen",
    "dont_allow": "Niet toestaan",
    "cameraText": "Hiermee kunt u de afbeelding selecteren die u wilt uploaden als uw bedrijfslogo."
  },
  "company": {
    "id": "Bedrijfs-id",
    "active_users": "Actieve gebruikers",
    "address1": "Adres",
    "optional": "Facultatief",
    "address2": "Adres 2",
    "address_id": "Locatie",
    "branch_name": "Filiaalnaam",
    "branch_of": "Filiaal van",
    "city": "Stad",
    "companies": "Filialen",
    "country": "Land",
    "duplicate_of": "Vervangen door",
    "latitude": "Lengtegraad",
    "logo_img": "Bedrijfslogo",
    "file_type_size": "Moet een jpeg-, gif- of png-bestand zijn van maximaal 4 MB.",
    "file_recommendation": "Voor de beste resultaten raden we een vierkante afbeelding aan met een doorzichtige achtergrond van minstens 400px breed en 400px hoog.",
    "logo_img_file_size": "Bedrijfslogo",
    "logo_img_content_type": "Bedrijfslogo",
    "longitude": "Breedtegraad",
    "long_name": "Bedrijfsnaam",
    "marketing_description": "Beschrijving van bedrijf",
    "custom_welcome_message": "Welkomstbericht voor klanten",
    "show_logo_in_welcome_email": "Geef het logo van het bedrijf weer in het welkomstbericht voor de klanten",
    "name": "Naam",
    "parent": "Moederbedrijf",
    "phone": "Telefoon",
    "role": "Rol",
    "roles": {
      "admin": "Help-/callcentrum",
      "installer": "Installateur",
      "distributor": "Distributeur",
      "third_party_owner": "Derde eigenaar"
    },
    "state": "Staat/provincie",
    "support_email": "E-mail klantenservice",
    "support_phone": "Telefoon klantenservice",
    "timezone": "Tijdzone",
    "url": "Website-URL",
    "zip": "Postcode",
    "is_installer": "Dit bedrijf installeert Enphase-systemen",
    "errors": {
      "name_not_found": "Bedrijfsnaam niet gevonden"
    },
    "success": {
      "msg": "Je account is aangemaakt. Controleer uw e-mail voor instructies over hoe u kunt inloggen."
    }
  },
  "forecast": {
    "nodata": "Verwachte gegevens zijn niet beschikbaar!",
    "nodata5": "We hebben minimaal 5 dagen aan productiegegevens nodig om de productiegegevens nauwkeurig te voorspellen.",
    "nodata10": "We hebben minimaal 5 dagen aan productiegegevens van de afgelopen 15 dagen nodig om uw prognose weer te geven.",
    "apifail": "De voorspelde gegevens kunnen niet worden weergegeven!",
    "apifailSub": "Fout bij het weergeven van voorspelde gegevens vanwege technische problemen. Controleer het na enige tijd.",
    "weatherErr": "Fout bij het weergeven van voorspelde gegevens vanwege het niet beschikbaar zijn van weergegevens.",
    "weatherProdErr": "Fout bij het weergeven van voorspelde gegevens vanwege het niet beschikbaar zijn van productie- of weergegevens.",
    "genErr": "Fout bij het weergeven van voorspelde gegevens vanwege technische problemen.",
    "envoyErr1": "Productiegegevens zijn niet beschikbaar omdat uw gateway niet rapporteert aan de cloud.",
    "envoyErr2": "Productiegegevens worden niet bijgewerkt omdat uw gateway niet rapporteert aan de cloud.",
    "microErr1": "Productiegegevens zijn niet beschikbaar omdat geen van de micro-omvormers rapporteert",
    "microErr2": "PProductiegegevens worden niet bijgewerkt omdat geen van de micro-omvormers rapporteert",
    "accCTA": "Waarom wijkt uw werkelijke productie af van de prognose?",
    "ctainfo": "Forecast is alleen een voorspellingen om u te helpen uw energiebehoefte te plannen. Merk op dat uw productiewaarden kunnen verschillen van de voorspelling.",
    "ctainfoRes": "Mogelijke redenen voor verschillen tussen de daadwerkelijke productie en de verwachting",
    "ctainfoRes1": "Frequente weersveranderingen in uw omgeving",
    "ctainfoRes2": "Enkele micro-omvormers rapporteren niet",
    "ctainfoRes3": "Uw systeem heeft al langer als een dag niet gerapporteert",
    "today": "Vandaag",
    "forecast": "Forecast",
    "actual": "Werkelijk",
    "timeFrom": "Toont 12:00",
    "actualProd": "Actual Production",
    "sunrise": "Zonsopgang",
    "sunset": "Zonsondergang",
    "clearDay": "Voornamelijk zonnig",
    "clearNight": "Mostly clear",
    "rain": "Voornamelijk regenachtig",
    "snow": "Voornamelijk sneeuw",
    "sleet": "Voornamelijk ijzel",
    "wind": "Voornamelijk winderig",
    "fog": "Voornamelijk mistig",
    "cloudy": "Bewolkt",
    "partlycloudy": "Gedeeltelijk bewolkt",
    "unknown": "Unknown",
    "at12": "Om 12:00",
    "title": "Ken uw productieprognose",
    "infoIconPopup": "De productieprognose is de voorspelling van hoeveel energie uw panelen vandaag en voor de komende 5 dagen zouden produceren. De prognose wordt berekend op basis van uw energieproductie in het verleden en de weersverwachting in uw regio.",
    "fiveday": "Prognose voor 5 dagen",
    "tomo": "Morgen"
  },
  "user": {
    "id": "Gebruikers-id",
    "api_key": "API-sleutel",
    "company": "Bedrijf",
    "company_id": "Bedrijfs-id",
    "consumer": "MyEnlighten",
    "country": "Land",
    "email": "E-mail adres",
    "email_confirm": "E-mail bevestigen",
    "password": "Wachtwoord",
    "first_name": "Voornaam",
    "last_name": "Achternaam",
    "sfdc_email": "E-mail",
    "sfdc_subject": "Onderwerp",
    "sfdc_message": "Bericht",
    "sfdc_siteId": "Enphase site-ID",
    "created_at": "Gemaakt om",
    "name": "Naam",
    "updated_at": "Bijgewerkt om",
    "status": "Status",
    "phone": "Telefoon",
    "locale": "Voorkeurslocatie",
    "preferred_metric": "Eenheden",
    "preferred_alert_level": "Standaard waarschuwingsniveau",
    "preferred_array_builder": "Kan series bouwen",
    "preferred_show_dashboard_help": "Voorkeur voor dashboardhelp",
    "preferred_new_look": "Enlighten 3.0 bekijken",
    "preferences": "Voorkeuren",
    "role": "Rol",
    "roles_mask": "Rollen masker",
    "sales_demo": "Verkoopdemo",
    "sees_modules": "Kan modulegegevens zien",
    "notes": "Opmerkingen",
    "prefers_monthly_email": "Aanmelden voor maandelijkse e-mail",
    "preferred_enphase_email": "Aanmelden voor e-mails van Enphase",
    "prefers_privacy_policy_assent": "Geaccepteerd privacybeleid",
    "active": "Actief",
    "inactive": "Inactief",
    "add_user": "Gebruiker toevoegen",
    "self_installer": "Zelfinstallateur",
    "site_access_id": "Locatie-id",
    "user_access_id": "Gebruikers-id",
    "with_company": "Bedrijfsdetails opnemen in mijn registratie",
    "last_login": "Laatst aangemeld",
    "acknowledge": "Ik erken dat ik Enphase heb gelezen en ermee akkoord ga",
    "privacy_url": "Privacybeleid",
    "terms_url": "Gebruiksvoorwaarden",
    "acknowledgementHead": "Ik heb de/het van Enphase gelezen",
    "acknowledgementBody": "ik heb de/het gelezen en ga hiermee akkoord"
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Ons privacybeleid is gewijzigd met ingang van %{policy_date}",
      "link_body": "<a href='%{privacy_url}' target='_blank'>Privacybeleid weergeven</a>",
      "acknowledgement": "Ik verklaar dat ik het <a href='%{privacy_url}' target='_blank'>privacybeleid</a> van Enphase heb gelezen en hiermee akkoord ga.",
      "continue_button": "Doorgaan",
      "privacy_settings_button": "Doorgaan naar Privacyinstellingen",
      "privacy_policy_agreement_required": "Ik verklaar dat ik het <a target='_blank' href='%{privacy_url}'>privacybeleid</a>\nen de <a target='_blank' href='%{terms_url}'>gebruiksvoorwaarden</a> van Enphase heb gelezen en hiermee akkoord ga.\n"
    }
  },
  "jquery_validate": {
    "messages": {
      "required": "Dit veld is verplicht."
    }
  },
  "validate": {
    "privacy_policy_accept": "Als u niet akkoord gaat met de voorwaarden van het privacy beleid en servicevoorwaarden van Enphase, mag u zich niet registreren voor de Enphase app."
  },
  "period": {
    "hours": "Dag",
    "days": "Maand",
    "week": "Week",
    "months": "Jaar",
    "years": "Levensduur",
    "custom": "Aangepaste"
  },
  "history": {
    "totals": "Totalen",
    "graph": "Startpagina",
    "production": "Geproduceerd",
    "consumption": "Verbruikt",
    "grid": "Elektriciteitsleverancier",
    "export": "Geëxporteerd",
    "import": "Geïmporteerd",
    "netExported": "Netto Geëxporteerd",
    "netImported": "Netto Geïmporteerd",
    "battery": "Batterij",
    "charge": "Geladen",
    "discharge": "Ontladen",
    "soc": "Batterij",
    "hours": "",
    "months": "",
    "today": "Vandaag",
    "battery_status": "Opladen",
    "bulbs": "Peer 100 W",
    "last_updated": "Geüpdatet",
    "power": "Vermogen",
    "solar_produced": "Solar Geproduceerd",
    "solar_consumed": "Zonne-Energie Consumptie",
    "saved": "Opgeslagen",
    "emission_saved": "CO2-uitstoot bespaard",
    "refrigerator": "Koelkast",
    "produced_today": "Geproduceerd vandaag",
    "produced_yesterday": "Geproduceerd gisteren",
    "this_week": "Deze week",
    "last_week": "Vorige week",
    "this_month": "Deze maand",
    "last_month": "Vorige maand",
    "this_year": "Dit jaar",
    "last_year": "Vorig jaar",
    "selected_day": "Geselecteerde Dag",
    "previous_day": "Vorige Dag",
    "selected_week": "Geselecteerde Week",
    "previous_week": "Vorige Week",
    "selected_month": "Geselecteerde Maa",
    "previous_month": "Vorige Maand",
    "selected_year": "Geselecteerd Jaar",
    "previous_year": "Vorig Jaar",
    "produced_this_week": "Geproduceerd deze week",
    "produced_last_week": "Geproduceerd vorige week",
    "produced_this_year": "Geproduceerd dit jaar",
    "produced_last_year": "Geproduceerd vorig jaar",
    "produced_this_month": "Geproduceerd deze maand",
    "produced_last_month": "Geproduceerd vorige maand",
    "produced_lifetime": "Geproduceerde levensduur",
    "imported-exported": "Geïmporteerd/Geëxporteerd",
    "yesterday": {
      "hours": "Gisteren",
      "days": "Vorige maand",
      "months": "Vorig jaar",
      "years": "Geproduceerd"
    },
    "lastyear": {
      "hours": "Vorig jaar",
      "days": "Vorig jaar",
      "months": "Vorig jaar",
      "years": "Geproduceerd"
    },
    "generator": "Generador"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Kies data frequentie",
      "daily": "Dagelijks",
      "weekly": "Wekelijks",
      "monthly": "Maandelijks",
      "yearly": "Jaarlijks",
      "generateReport": "We hebben minimaal een week gegevens nodig om het rapport te genereren"
    }
  },
  "calendar": {
    "select": "Selecteer een datum",
    "scale": {
      "production": "Productie",
      "consumption": "Consumptie"
    },
    "weekDays": {
      "monday": "maandag",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "vrijdag",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "months": {
      "january": "Januari",
      "february": "Februari",
      "march": "Maart",
      "april": "April",
      "may": "Mei",
      "june": "Juni",
      "july": "Juli",
      "august": "Augustus",
      "september": "September",
      "october": "Oktober",
      "november": "November",
      "december": "December",
      "jan": "jan.",
      "feb": "feb.",
      "mar": "maart",
      "apr": "apr.",
      "jun": "juni",
      "jul": "juli",
      "aug": "aug.",
      "sep": "sept.",
      "oct": "oct.",
      "nov": "nov.",
      "dec": "dec."
    },
    "time": {
      "hour": "uur",
      "hours": "uren",
      "minute": "minuut",
      "minutes": "minuten",
      "second": "tweede",
      "seconds": "seconden",
      "millisecond": "millisecond",
      "milliseconds": "milliseconds",
      "day": "dag",
      "h": "u",
      "min": "min"
    }
  },
  "status": {
    "nameChangeNormal": "Normaal",
    "nameChangeError": 'Fout',
    "nameChangeWarning": 'Waarschuwing',
    "dayTitle": "Status van vandaag",
    "dayAltTitle": "Nieuwste status",
    "monthTitle": "De status van deze maand",
    "monthAltTitle": "Nieuwste maandelijkse status",
    "yearTitle": "De status van dit jaar",
    "yearAltTitle": "Nieuwste jaarlijkse status",
    "lifetimeTitle": "Status van de gehele levensduur",
    "lifetime": "Levensduur",
    "system_normal": "Systeem Normaal",
    "system_error": "Systeemfout",
    "energyConsumed": "Geconsumeerd Energie",
    "energyProduced": "Geproduceerd Energie",
    "powerProduced": "Geproduceerd Vermogen",
    "powerConsumed": "Verbruikt Vermogen",
    "moreDetails": "Meer Details",
    "latest_power": "Nieuwste Vermogen",
    "latest_power_text": "Nieuwste Zonne Energie is het laatst gerapporteerde vermogen van uw PV-systeem",
    "peak_power": "Piekvermogen",
    "peak_power_text": "tPiekvermogen is het maximale vermogen van uw PV-systeem voor de gekozen periode.",
    "addEnphaseStorage": "Enphase-batterij toevoegen",
    "getAQuote": "Vraag een offerte aan",
    "production": {
      "title": "Zonne-energie",
      "label": "Geproduceerd",
      "section": "Energiebestemmingen"
    },
    "consumption": {
      "title": "Verbruik",
      "label": "Verbruikt",
      "section": "Energiebronnen"
    },
    "grid": {
      "title": "Netto-energie",
      "export": "Geëxporteerd",
      "import": "Geïmporteerd",
      "label": "Netto-energie met geïmporteerde/geëxporteerde",
      "section": "Energiebronnen",
      "progressbarTitle": "Netto-energie van grid"
    },
    "breakdown": {
      "consumption": "Woning",
      "battery": "Opslag",
      "production": "Zonne-energie",
      "grid": "Elektriciteitsleverancier",
      "export": "Geëxporteerd",
      "import": "Geïmporteerd",
      "soc": "Opgeslagen",
      "total": "Totaal",
      "peak": "Piekvermogen",
      "latest": "Meest recente vermogen",
      "next": "Volgende Rapport"
    },
    "battery": {
      "title": "Opslag",
      "label": {
        "none": "Inactief",
        "positive": "Opladen",
        "negative": "Ontladen"
      },
      "section": "Beschikbare energie"
    },
    "charge": "Opladen",
    "stormAlertOn": "Storm alarm: Aan",
    "batteryProfile": "batterijprofiel",
    "batteryInfo1": "Gebaseerd op het verbruik van de laatste 24 uur (%{consumption}) uw Enphase-systeem zal ongeveer werken ",
    "batteryInfo2": " zonder net- of zonne-energie.",
    "batteryInfoWOSolar": " zonder net- .",
    "batteryErrorInfo": "We hebben niet genoeg gegevens om uw batterijback-uptijd te kunnen schatten.",
    "to": "tot",
    "batteryZeroErrorInfo": "U hebt nul uur back-up omdat uw batterijen leeg zijn.",
    "hours": "uur",
    "minutes": "minuut",
    "gridControls": {
      "verifyOtp": "Code verifiëren",
      "verificationCode": "Verificatiecode",
      "offGridContent": "U zult de verbinding met het Rooster verliezen. Het voor verbruik beschikbare vermogen wordt beperkt.",
      "tryAgainContent": "Er kan geen verbinding met de Gateway worden gemaakt.",
      "verifyOtpEmail": "Voer de 4-cijferige code in die naar uw geregistreerde e-mailadres is verzonden.",
      "verifyOtpEmailMobile": "Voer de 4-cijferige code in die naar uw geregistreerde e-mailadres en het mobiele nummer is verzonden.",
      "verifyOtpUpdateMobile": "De 4-cijferige code wordt naar uw geregistreerde e-mailadres verzonden.",
      "onGridContent": "Wilt u uw systeem nu weer op het Rooster aansluiten?",
      "pleaseTryAgain": "Probeer het opnieuw",
      "enterValidOtp": "Voer een geldige code in",
      "didntReceiveOtp": "Hebt u geen code ontvangen?",
      "goOffGrid": "Ga van het Rooster af",
      "goOnGrid": "Ga op het Rooster",
      "tryAgain": "opnieuw proberen",
      "resend": "Opnieuw verzenden",
      "alert": "De toegang tot het netbeheer is uitgeschakeld omdat er een update voor uw systeem wordt uitgevoerd. Deze update kan tot 24 uur duren. Wacht tot de update is voltooid.",
      "sendCode": "Code verzenden",
      "mobileStatus": "om de code als sms te ontvangen.",
      "myInfoButton": "Werk uw mobiele nummer bij",
      "wpc1l1": "Uw huidige gebruiksniveau is hoger dan de beschikbare productie van zonne-energie  Verminder uw gebruikt om te voorkomen dat het systeem uitvalt tijdens de transitie.",
      "wpc1l2": "U kunt uw huidige productie van zonne-energie en essentieel ladingverbruik bekijken in %{liveStatus}.",
      "wpc2l1": "Uw gemiddelde gebruik in de afgelopen 15 minuten is groter dan de gemiddelde productie van zonne-energie. Zorg dat de huidige productie van zonne-energie voldoende is voor uw verbruiksbehoefte om te voorkomen dat het systeem uitvalt als u van het net afgaat.",
      "wpcOnGrid": "Uw systeem wordt momenteel aangedreven door een generator. Overschakelen naar op het net kan leiden tot een tijdelijke stroomstoring als uw verbruik erg hoog is. Verlaag uw verbruik om deze storing te voorkomen.",
      "wpcOnGrid2": "U kunt uw huidige verbruik bekijken in %{liveStatus}."
    },
    "viewDetails": "Bekijk de Details",
    "socMessageError1": "Het totale opslagpercentage ",
    "socMessageError2": " is exclusief de opslagpercentages van ",
    "socMessageError3": "Batterij(en)",
    "socMessageThreshold": "De batterijlading is onbekend aangezien geen van de batterijen gegevens hebben gerapporteerd sinds de laatste rapporteringscyclus"
  },
  "menu": {
    "supportHistory": "Support geschiedenis",
    "supportHistorySearch": "",
    "connectedAppliances": "Verbonden apparaten",
    "connectedAppliancesSubtitle": "Bewaak en beheer uw slimme apparaten",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Bewaak en bedien uw Home Connect apparaten",
    "appTutorial1": "U kunt op elk moment alle systeemhandleidingen raadplegen door te navigeren naar",
    "appTutorial2": "Ken uw systeem aanwezig",
    "appTutorial": "Ken uw systeem aanwezig",
    "appTutorial3": "onder",
    "appTutorial4": "Systeem",
    "viewallsystutorial": "Alle systeemhandleidingen bekijken",
    "voiceAssistant": "Stemassistent",
    "voiceAssistantSubtitle": "Stel stemcontrole is voor Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Productieprognose",
    "dryContactLoads": "Ladingen",
    "generator": "Generador",
    "generatorDevice": "Generador",
    "loadControl": "Laadregeling",
    "loadControlSubtitle": "Controleer de stroom naar uw ladingen",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Meldingen",
    "newNotices": "Meldingen",
    "reports": "Rapporten",
    "exploreEnphase": "Ontdek Enphase",
    "exploreEnphaseNewMenu": "Ontdek",
    "details": "Details",
    "detailSite": "SITEGEGEVENS",
    "advanceSettings": "Geavanceerde instellingen",
    "advanceBatterySettings": "Geavanceerde instellingen",
    "advancedBatterySettings2": "Geavanceerde Instellingen",
    "detailsInstaller": "DETAILS VAN DE INSTALLATEUR",
    "systemDescription": "Systeem Omschrijving",
    "systemStatistics": "Systeemstatistieken",
    "settings": "instellingen",
    "account": "Account",
    "support": "Ondersteuning",
    "supportFaq": "FAQs",
    "emergencySupport": "bel ons nu",
    "contactUs": "Contacteer ons",
    "contactSupport": "Schrijf ons",
    "devices": "Apparaten",
    "addStorage": "Opslag toevoegen",
    "devicesOld": "Apparaten",
    "configure": "Configureren",
    "batteryStorage": "Batterij opslag",
    "batteryStorageNewMenu": "Batterij",
    "connectivity": "Connectiviteit",
    "connectGateway": "Connectiviteit",
    "batteryReserve": "Batterij reserve",
    "eventsHistory": "Gebeurtenissen Geschiedenis",
    "backupHistory": "Backup Geschiedenis",
    "outageHistory": "Stroomuitval geschiedenis",
    "event": "Evenementen",
    "events": "Evenementen",
    "totalEvents": "Totaal evenementen",
    "totalBackup": "Back-up van de batterij",
    "backupDuration": "Backup Looptijd",
    "hours": "uur",
    "minutes": "notulen",
    "siteDetails": "Sitegegevens",
    "envoy": "Gateway",
    "liveVitals": "Live Stats",
    "envoyNotReport": "Gateway rapporteert niet",
    "microInverterNotReporting": "Micro-omvormers rapporteren niet",
    "enpowerNotReporting": "Systeemcontroller rapporteert niet",
    "enchargeNotReporting": "Batterij rapporteert niet",
    "enchargeError": "Batterijstoring",
    "enpowerError": "Storing in de systeemcontroller",
    "microinverters": "Microinverters",
    "stringInverters": "String Inverter",
    "storage": "Batterij",
    "reconnectToEnvoy": "Connectiviteit",
    "configureWiFi": "Wifi Configureren",
    "envoyInternetConnection": "Om de interconnectiviteit van de Gateway te wijzigen",
    "enpower": "Systeemcontroller",
    "theme": "Thema",
    "darkmode": "Donkere modus",
    "devmode": "Developer Mode",
    "appUpdate": "App Update",
    "wifi": "Verbindingstype",
    "feedback": "Feedback",
    "logout": "Afmelden",
    "help": "Help",
    "siteid": "Locatie-id",
    "visitTommorrowForReport": "Kom morgen terug. Enphase cloud heeft niet de benodigde gegevens verzameld om rapporten te maken.",
    "email_report": "E-mailrapport",
    "will_send": "Wordt verzonden naar",
    "batterySubtitle": "Optimaliseer uw batterij op basis van gebruik en tarief",
    "batteryEmeaSubtitle": "Optimaliseer uw batterij op basis van gebruik",
    "connectivitySubtitle": "De interconnectiviteit van de Gateway wijzigen",
    "eventsHistorySubtitle": "Bekijk het logboek van de belangrijkste gebeurtenissen in het systeem",
    "backupHistorySubtitle": "Bekijk de geschiedenis van de stroomuitval",
    "accountSubtitle": "Persoonlijke gegevens, Taal, Privacy instellingen",
    "wifiSubtitle": "Standaard bandbreedte, Rapporteert gegevens om de 15 minuten",
    "liveVitalsSubtitle": "Bekijk de live status van het systeem",
    "themeSubtitleOn": "De donkere modus is uitgeschakeld",
    "themeSubtitle": "De donkere modus is uitgeschakeld",
    "devmodeSubtitle": "Opties Ontwikkelaarsmodus",
    "appUpdateSubtitle": "Versie-informatie voor de laatste updates en changelog",
    "appUpdateSuccessSubtitle": "App is up-to-date",
    "requestReplacement": "Verzoek om vervanging",
    "changeShippingAddress": "Wijzig verzendadres",
    "tariffEditor": "Elektriciteitstarief",
    "tariffEditorNewMenu": "Elektriciteitstarief",
    "currencyConversion": "Valuta Equivalent",
    "currencyConversionNewMenu": "Valuta",
    "currencySubtitle": "Energiegegevens worden omgerekend in equivalente wisselkoersen.",
    "showCurrency": "Toon Valuta Equivalent",
    "showCurrencySubtitle": "Zet aan om conversie widget te tonen",
    "passwordReset": "Wachtwoord Opnieuw Instellen",
    "tariffAdded": "Bekijk en bewerk uw tarief",
    "showCurrencySubtitleOff": "Schakel uit om valuta widget te verbergen",
    "tariffNotAdded": "Elektriciteit invoersnelheid structuur is niet toegevoegd",
    "enlightenManager": "Bekijk in Enlighten Manager",
    "sgipIncentive": "Opslag stimulans (SGIP)",
    "gridServices": "Grid Services",
    "enphaseHome": "Net verhuisd naar een huis dat Enphase heeft",
    "systemAccess": "Alles is opgezet, maar heeft toegang tot het systeem nodig",
    "woSiteSystemAccess": "Systeemtoegang",
    "enphaseProducts": "Meer weten over Enphase producten",
    "enphaseTeam": "Krijg hulp van het Enphase team",
    "gridSwitch": "Rooster controle",
    "onGrid": "Netgekoppeld",
    "chatWithUs": "chat met ons",
    "referFriends": "Verwijs een vriend",
    "referralTnC": "Algemene Voorwaarden",
    "hello": "Hallo",
    "homeControls": "Home Controls",
    "systemDetails": "Systeem",
    "pesDetails": "System",
    "community": "Gemeenschappelijke",
    "settingsMenu": "instellingen",
    "enphaseStore": "Enphase Store",
    "upgrades": "Upgrades",
    "services": "Diensten",
    "generatorSubtitle2": "Configureer uw generator op basis van slimme profielen",
    "devicesSubtitle": "Bekijk alle apparaten en de status ervan",
    "siteDetailsSubtitle": "Bekijk de details van de locatie en de installateur",
    "reportsSubtitle": "Genereren en verzenden van rapporten",
    "appSettings": "App instellingen",
    "accountSettings": "Accountinstellingen",
    "addStorageSubtitle": "Voeg opslag toe om storingen te voorkomen",
    "addSolarPanels": "Voeg zonnepanelen toe",
    "addSolarPanelsSubtitle": "Verhoog het eigen verbruik",
    "sgipIncentiveSubtitle": "SGIP-stimulering aanvragen",
    "gridServicesSubtitle": "Verdien voordelen door het net te helpen met IQ Battery",
    "incentives": "Voordelen",
    "accountMenu": "Account",
    "myInformation": "Mijn informatie",
    "myNotificationPreferences": "Mijn notificaties",
    "myPrivacy": "Mijn privacy",
    "myAccessControl": "Mijn toegangscontrole",
    "myInformationSubtitle": "Werk persoonlijke en systeemgegevens bij",
    "myNotificationPreferencesSubtitle": "Beheer mijn meldingen",
    "myPrivacySubtitle": "Bepaal hoe Enphase systeeminformatie gebruikt",
    "myAccessControlSubtitle": "Beheer de toegang tot systeemgegevens",
    "systemSettings": "Systeem instellingen",
    "deviceSettings": "Apparaatinstellingen",
    "wirelessRangeExtender": "Verlenger draadloos bereik",
    "cacheAction": "Wis de lokale cache",
    "cacheResult": "Energiegegevens van browser gewist",
    "noActiveNotices": "Er zijn geen actieve beoordelingen voor u",
    "appInfo": "App-informatie",
    "whatsNew": "Wat is er nieuw?",
    "privacyPolicy": "Privacybeleid",
    "tos": "Servicevoorwaarden",
    "rateUs": "Beoordeel ons",
    "gridToggle": {
      "infoPopupTitle": "Backupsysteem zonlicht",
      "infoPopupContentP1": "Uw systeem heeft een backupsysteem zonlicht en het overschakelen naar Zonder Netwerk is niet aanbevolen buiten zonuren.",
      "pIt1": "Als het systeem overschakelt naar Zonder Netwerk worden niet-essentiële ladingen afgekoppeld van de stroom.",
      "pIt2": "Overschakelen op Zonder Netwerk is alleen mogelijk tijdens de uren waarop essentiële ladingen zijn gepland om ingeschakeld te zijn in %{scheduledMode}.",
      "pIt3": "Uw systeem kan een uitval ondervinden bij Zonder Netwerk als er niet genoeg zonlicht is.",
      "scheduledMode​": "Geplande modus​",
      "infoPopupContentP2": "Als het systeem overschakelt naar Zonder Netwerk worden ladingen afgekoppeld van de stroombron, behalve de essentiële.. Het overschakelen naar Zonder Netwerk is niet toegestaan buiten de geplande uren. Uw systeem kan een uitval ondervinden bij Zonder Netwerk als er niet genoeg zonlicht is."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Get to know your device",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Neem uw stroom mee. Energiezekerheid en stroom onderweg.",
      "enphasePESConnectDevice": "Een apparaat verbinden",
      "enphasePESLearnMore": "Meer informatie",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Register your device",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Make sure your phone’s Bluetooth is turned on.",
      "registerStep1": "Inloggen / Aanmelden voor Enphase account",
      "registerStep2": "Pair your device and phone via Bluetooth​",
      "registerStep3": "Give your device a name​",
      "registerStep4": "Connect it to the Wi-Fi network​",
      "register": "Register",
      "start": "Start",
      "later": "Later",
      "fserialNumber": "Enter Serial No.",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Name Your Device",
      "enterBoxName": "Device Name",
      "connectToWiFi": "Connect your device to Wi%{nbh}Fi",
      "connectToWiFiNotice": "Select your preferred Wi-Fi network and enter password.",
      "takeFewMinutes": "This may take a few minutes",
      "connectingToWifi": "Connecting to Wi-Fi",
      "pleaseContactSupport": "Please contact support for help",
      "unableToCompleteConnect": "Unable to complete the connect",
      "incomplete": "Incomplete",
      "congratulations": "Congratulations!",
      "incorrectPasswordTryAgain": "Incorrect password. Please try again",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "is registered",
      "startMonitoring": "Start Monitoring",
      "turnOnBluetoothOnNotice": "Your mobile bluetooth seems to be switched off. Please turn it on to connect to Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy Systems Around",
      "noOjasDevicesFound": "No Portable Energy System found",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Incorrect Code",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Capturing Device Details",
      "capturedDeviceDetails": "Device details captured",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Registration Error",
      "registrationErrorNotice": "Please retry registration. If problem persist, ",
      "deviceAlreadyRegistered": "Device already registered",
      "deviceAlreadyRegisteredNotice": "Dit draagbare energiesysteem is reeds geregistreerd bij een andere Enphase account.",
      "proceed": "Proceed",
      "rename": "Rename",
      "nameAlreadyExist": "Name already exist",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Bluetooth connection eshtablished!",
      "enter4DigitCode": "Enter 4 digit code",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Resend code",
      "connWithOJASBLE": "Connect with Portable Energy System via Bluetooth",
      "noBLEDevicesFound": "No bluetooth devices found",
      "backupTime": "Backup Time",
      "timeToCharge": "Time to Charge",
      "powerSaving": "Power Saving",
      "poweredOn": "Powered On",
      "powerOn": "Power On",
      "powerOff": "Power Off",
      "close": "Sluiten",
      "powerSavingHeader": "Device is Power Saving",
      "powerOnHeader": "Device is Powered On",
      "powerSavingSubHeader": "(AC output disabled)",
      "powerSavingContent": "You can remotely power on and enable AC output or shut down the device and disable all the input and output power supply.",
      "powerOnContent": "You can remotely shut down the device and disable all the input and output power supply.",
      "shuttingDown": "Shutting down in",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "Apparaat is niet verbonden met de Enphase app!",
        "1_description": "Please ensure your device is turned on and connected to Wi-Fi. If you are nearby your device, you can pair your phone with the device using Bluetooth.",
        "1_action": "Connect using Bluetooth",
        "3_title": "Bluetooth not supported!",
        "3_description": "Bluetooth not supported in your device, please make sure device has Bluetooth and Location options.",
        "4_title": "Turn On Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Scanning for Bluetooth devices...",
        "7_title": "Bluetooth devices",
        "8_title_success": "No bluetooth devices found.",
        "8_title_error": "Problem persisted while scanning.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Eshtablish Bluetooth connection...",
        "10_title": "Enter proof of possession PIN for",
        "10_subTitle": "Proof of Possession PIN",
        "11_title": "Bluetooth connection established!",
        "11_description_1": "Bluetooth connection with your Portable Energy System:",
        "11_description_2": " is successfully eshtablished.",
        "12_title": "Bluetooth Not-Connected.",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " is failed, Please try again.",
        "13_title": "Searching for Wi-Fi networks...",
        "14_title": "Connect PES to Wi-Fi",
        "14_description": "Select your preferred Wi-Fi network and enter password.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "No Wi-Fi network found.",
        "15_title_error": "Problem persisted while scanning.",
        "15_description": "No Wi-Fi network found. Reboot your Wi-Fi router and try again.",
        "18_title_1": "Sending Wi-Fi credentials",
        "18_title_2": "Applying Wi-Fi connection",
        "18_description": "provisioned successfully,",
        "19_title": "Incomplete!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Device ID",
      "ojasSettings": {
        "profile": "Profielen",
        "acPorts": "AC-poorten",
        "dcPorts": "DC-poorten",
        "on": "Ingeschakeld",
        "off": "Uitgeschakeld",
        "brightnesSettings": {
          "brightness": "Helderheid",
          "customBrightness": "Aangepaste helderheid",
          "auto": "Automatisch aanpassen helderheid"
        },
        "lightSettings": {
          "light": "Licht",
          "on": "Altijd aan",
          "off": "Altijd aan",
          "auto": "Automatisch",
          "onMsg": "Blijft aan",
          "autoMsg": "Wordt ingeschakeld als iemand in de buurt is",
          "offMsg": "Blijft uit"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Stroom aan",
          "powerOff": "Stroom uit",
          "powerSave": "Energiebesparing"
        },
        "ojasModes": {
          "on": "Alle uitgaande AC- en DC-poorten staan aan. Laat het apparaat in deze modus als u tools of apparaten aangesloten hebt op de AC-poort.",
          "save": "Alleen DC-poorten zijn ingeschakeld om elektronische apparaten van stroom te voorzien. Deze modes bespaart stroom omdat de AC-poorten uitgeschakeld zijn.",
          "off": "Alle ingaande en uitgaande stroombronnen worden uitgeschakeld."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Besparingen",
    "appTutorialPage": {
      'all-topics-empty': 'Geen onderwerpen beschikbaar',
      'videos-empty': "Geen video's beschikbaar",
      'articles-empty': 'Geen artikelen beschikbaar',
      'noResults': "Geen resultaten voor \"%{searchValue}\""
    }
  },
  "environmentCard": {
    "title": "Omgeving",
    "label": "Milieu-impact",
    "rightText": "Bron: epa.gov",
    "equivalent": "Equivalent",
    "planted": "GEPLANT",
    "carbon_offset": "KOOLSTOFCOMPENSATIE",
    "charged": "OPGELADEN",
    "trees": {
      "zero": "bomen",
      "one": "boom",
      "other": "bomen"
    },
    "phone": {
      "one": "telefoon",
      "other": "telefoons"
    },
    "tonne": {
      "one": "ton",
      "other": "ton"
    },
    "lb": {
      "one": "lb",
      "other": "lb"
    },
    "ton": {
      "one": "ton",
      "other": "ton"
    }
  },
  "connectionType": {
    "wifi": "Wifi",
    "cellular": "Mobiele modem",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Rapporteer gegevens om de 15 minuten",
    "reportsAt6Hrs": "Rapporteer gegevens om de 6 uren",
    "idle": "Inactief",
    "notAvailable": "Niet Beschikbaar",
    "configureWiFiSettings": "Draadloze Instellingen Configureren",
    "configureWiFiSettings2": "Configureren",
    "switchToWiFi": "Overschakelen naar Wifi",
    "connectToWiFi": "Verbinden met Wifi"
  },
  "details": {
    "connection_type": "Verbindingstype",
    "description": "Systeembeschrijving",
    "installer": "Geïnstalleerd door",
    "maintainer": "Onderhoudsmonteur systeem",
    "micros": {
      "one": "Micro-omvormer",
      "other": "Micro-omvormers"
    },
    "acbs": {
      "one": "Batterij",
      "other": "Batterijen"
    },
    "arrays": {
      "one": "Serie",
      "other": "Series"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% meer dan deze tijd gisteren",
    "less_yesterday": "% minder dan deze tijd gisteren",
    "same_yesterday": "Ongeveer hetzelfde als deze tijd gisteren",
    "more_last_year": "% meer dan deze tijd vorig jaar",
    "less_last_year": "% minder dan deze tijd vorig jaar",
    "same_last_year": "Ongeveer hetzelfde als deze tijd vorig jaar",
    "more_yesterday_prev": "% meer dan de vorige dag rond deze tijd",
    "less_yesterday_prev": "% minder dan deze tijd vorige dag",
    "same_yesterday_prev": "Ongeveer hetzelfde als de vorige dag rond deze tijd",
    "more_last_year_prev": "% meer dan vorig jaar rond deze tijd",
    "less_last_year_prev": "% minder dan vorig jaar rond deze tijd",
    "same_last_year_prev": "Ongeveer hetzelfde als dit vorig jaar",
    "system": "Systeem",
    "emptyArray": "Geen serielay-out beschikbaar",
    "storageArray": "Opslag array",
    "solarArray": "Zonnepaneel",
    "contactInstForpersonalizedLayout": "Neem contact op met uw installateur voor een gepersonaliseerde weergave van uw opslagmatrix.",
    "cntcInstPopP1": "De opslagmatrix toont het beeld van de opslageenheden die zijn geïnstalleerd in uw huis samen met hun laadniveaus.",
    "cntcInstPopP2": "Neem contact op met uw installateur om de opslagmatrix in de Installer Tool Kit-app of de Enlighten Manager-app in te bouwen voor een meer gepersonaliseerde weergave."
  },
  "support": {
    "enphase": "Enphase-ondersteuning",
    "enphaseLink": "Enphase-ondersteuning",
    "maintainer": "Systeemondersteuning en -onderhoud",
    "maintainerLink": "Neem contact op met uw onderhoudsmonteur",
    "contactEnphase": "Contact Enphase",
    "enphaseSupport": "Enphase Support",
    "ensembleSupport": "Bel Ensemble Support",
    "writeToUs": "Schrijf ons",
    "visitSupport": "Bezoek support",
    "talkToUs": "Praat met ons",
    "talkToUsAnytime": "Praat altijd met ons",
    "customerSupport24by7": "24/7 klantenondersteuning",
    "needHelpTitle": "Heeft u hulp nodig bij",
    "microinvertersNotReporting": "Micro-omvormers rapporteren niet",
    "productionIssue": "Productie probleem",
    "envoyNotReporting": "Systeem of Gateway rapporteert niet",
    "needMoreHelpTitle": "Meer hulp nodig",
    "contactUs": "Contacteer ons",
    "productionDifference": "Verschil in productie per paneel",
    "askEnphaseCommunity": "Vraag het aan Enphase Community",
    "browseTopics": "Blader door alle hulp onderwerpen",
    "chatWithUs": "chat met ons",
    "helpTopics": "Hulp Onderwerpen",
    "brwsAllFaqs": "Bekijk alle FAQ's",
    "askEnphaseCommunitySubtitle": "Neem contact op met de adnere Enphase-klanten om u heen",
    "systemOwnerGuide": "Raadpleeg de handleiding van de systeemeigenaar",
    "faq": {
      "usingManualOverride": "Gebruik van handmatige overschrijding",
      "understandingEnpower": "IQ System Controller begrijpen",
      "understandingEncharge": "IQ Battery begrijpen",
      "understandIQCombiner": "IQ Combiner, Gateway, Comms Kit en Cell Modem begrijpen",
      "stormGaurdFeatureDetails": "Storm Guard Functie Details",
      "settingElectricityRateStructure": "Tariefstructuur van de elektriciteit instellen",
      "recoverShutdownLL": "Herstellen van uitschakeling als gevolg van grote ladingen",
      "recoverShutdownCF": "Herstellen van de uitschakeling als gevolg van een communicatiestoring",
      "recoverShutdownBD": "Herstellen na uitschakeling vanwege lege batterij",
      "PowerHomeInBCK": "Thuisbelastingen opladen in Backup",
      "partialHomeBCK": "Gedeeltelijke Back-up configuratie voor thuis",
      "monitorUrSys": "Bewaking van uw systeem",
      "mngLgApplianceBck": "Beheer van grote apparaten in de back-up",
      "incentivesAvlbTou": "Stimulansen voor u beschikbaar",
      "grdTrnxToOffGrd": "Roosterovergang naar buiten het rooster",
      "allHomeBck": "Volledige Back-up configuratie voor thuis",
      "envLEDstatus": "Status van de LED van de Gateway",
      "dsgnUrSys": "Het ontwerpen van uw systeem",
      "cntctCustSupp": "Contact opnemen met de klantenservice",
      "batSmrtPrfSel": "Selecteer het slimme batterijprofiel",
      "accsEnchrgDcswtch": "Toegang tot de gelijkstroomschakelaar van de batterij",
      "mcrInvNtReprt": "Micro-omvormer rapporteert niet",
      "sysEnvNtReprt": "Gateway rapporteert niet",
      "hwUrSysWrk": "Hoe uw systeem werkt",
      "enchrLedStatus": "Status van de LED van de batterij",
      "noPwNebDo": "Mijn huis heeft geen elektriciteit maar mijn buren wel",
      "consBatDurGridOut": "Bespaar de levensduur van de batterij tijdens een stroomstoring",
      "emgSupCallSteps": " Kies 2 voor klantenservice en 1 voor de systeemeigenaar. Selecteer 2 in het submenu voor opslagsystemen.",
      "preLoginCallSteps": "Selecteer 2 voor klantenondersteuning of selecteer 4 voor verkoop.",
      "sysProdIssue": "Systeemproductieprobleem",
      "diffInPerPanProd": "Productieverschil per plaat",
      "installCellModem": "Installatiehandleiding voor mobiele modem",
      "whatIsEI": "Energieonafhankelijkheidscore",
      "howEnHomeEngSysWork": "Hoe werkt het Enphase-energiesysteem voor huizen?",
      "understandEnv": "De Gateway begrijpen",
      "findEnv": "Mijn Gateway vinden",
      "": "De Envoy is vervangen",
      "rebootEnv": "De Gateway opnieuw opstarten",
      "hwChangeEmail": "Hoe verander ik mijn e-mailadres?",
      "hwResetPasswd": "Hoe kan ik mijn wachtwoord resetten?",
      "accessEnvLocalIntf": "Toegang verkrijgen tot de lokale interface van de Gateway",
      "envLocIntfLogCred": "Aanmeldgegevens van de lokale interface van de Gateway",
      "hwDisbaleNotification": "Hoe schakel ik maandelijkse rapporten en andere e-mailmeldingen in en uit?",
      "MontEngProd": "Volg mijn energieproductie",
      "whyNotSeeConsumption": "Waarom kan ik mijn verbruik niet zien?",
      "hwMonConsumpt": "Hoe kan ik het verbruik van mijn huis controleren?",
      "calEngUsageWoConsumptionMonitoring": "Bereken mijn energieverbruik zonder het verbruik te monitoren",
      "undersNetEng": "Begrijp de netto-energie",
      "understTrueUpStmt": "Begrijp een True-up verklaring",
      "diffPaidENLMvsPerpanelDataaoffering": "Verschil tussen de betaalde Enlighten Manager en het aanbod van gratis energiedata per paneel",
      "blkInPerpanMon": "Zwart veld in het gezichtsveld",
      "gryorBlnkInPerpanMon": "Grijs (leeg) veld in de paneelweergave",
      "hwToMovePnl": "Hoe verplaats ik een paneel?",
      "hwfindInst": "Hoe vind ik een nieuwe installateur?",
      "whtdoIfonePanelNotreproduc": "Wat moet ik doen als een van de panelen weinig of geen productie heeft?",
      "haveaSelfPoweredHome": "Wat betekent het om een zelf-aangedreven huis te hebben?",
      "yourSystemPaysForItself": "Hoe lang duurt het voordat het systeem zichzelf terug betaald heeft?",
      "enphaseSystemsAreSafe": "Waarom Enphase-systemen veilig zijn?"
    },
    "webBackButton": "Indietro",
    "supportHistory": "Support geschiedenis"
  },
  "evse": {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data",
    "errprodcons": "Unable to suggest charging schedule because of insufficient consumption and production data",
    "addev": "Voeg een Elektrisch Voertuig toe",
    "addevSub": "Laat ons weten of u uw Enphase-systeem gebruikt om uw EV te laden zodat we inzichten en optimale tijdlijnen kunnen aanbevelen om uw voertuig efficiënt op te laden.",
    "haveEv": "Ik heb een EV.",
    "qbrand": "Wat is het merk van uw EV?",
    "qbrandErr": "*The above field is mandatory",
    "qmodel": "Wat is de modelnaam van uw EV?",
    "diffcharger": "Ik laad mijn EV thuis met een oplader van een ander bedrijf",
    "qcharger": "Wat is het merk van uw oplader?",
    "qcapacity": "Wat is de batterijcapaciteit van uw EV (in kWh)?",
    "notcompulsory": "*deze vraag is niet verplicht. U kunt deze overslaan als u het niet weet.",
    "qtime": "Wanneer laadt u uw voertuig op?",
    "morning": "Ochtend",
    "afternoon": "Middag",
    "evening": "Avond",
    "night": "Nacht",
    "other": "Anders (specificeer)",
    "qmiles": "Hoeveel kilometer rijdt u gewoonlijk op een dag?",
    "brand": "Merkgegevens",
    "tech": "Technische gegevens",
    "operational": "Operationele gegevens",
    "ev": "Elektrisch Voertuig:",
    "suggsch": "Aanbevolen schema",
    "suggschInfo": "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate.",
    "charge": "To charge your electric vehicle",
    "weekday": "For Mon, Tue, Wed, Thur & Fri",
    "weekend": "For Sun & Sat",
    "everyday": "Everyday",
    "removeEV": "Verwijder Elektrisch Voertuig",
    "userfail": "Unable to display Electric Vehicle details!",
    "userfailDesc": "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."
  },
  "storage": {
    "stormGuardEnablePopUpHeader": "Stormbewaking inschakelen",
    "stormGuardEnablePopUpFooter": "Wilt u stormbewaking inschakelen?",
    "stormGuardDisablePopUpHeader": "Stormbewaking uitschakelen",
    "stormGuardDisablePopUpFooter": "Wilt u stormbewaking toch uitschakelen?",
    "backupTime": "Back-up tijd",
    "encharge_battery": "Selecteer een slim profiel om uw batterij te regelen",
    "encharge_battery_emea": "Slim profiel om je batterij te bedienen",
    "savings": "Energiespaarmodus",
    "expert": "Expertmodus",
    "self-consumption": "Eigen Gebruik",
    "battery_bkup": "Volledige Back-Up",
    "savings_text": "Gebruik wanneer je energiekosten variëren tijdens de dag. Batterij wordt opgeladen tijdens daluren en gebruikt tijdens piekuren na zonsondergang.",
    "savings_mode_notSet": "Maximaliseert uw besparingen op basis van elektriciteitstarieven",
    "savings_mode_dc_tou": "Zonne-energie en batterij worden tijdens piekuren gebruikt om de import vanuit het elektriciteitsnetwerk te minimaliseren.",
    "savings_mode_dc_all_day": "Tijdens piekuren wordt zonne-energie naar het elektriciteitsnet geëxporteerd. De batterij voorziet uw huis van stroom totdat de gereserveerde lading is bereikt.",
    "viewElectricityRate": "Bekijk elektriciteitstarieven",
    "optForDC": "Geoptimaliseerd voor besparing vermogensvergoeding",
    "optForIncExport": "Geoptimaliseerd om export te verhogen",
    "consumption_text": "Gebruik opgeslagen zonne-energie om energie te verkrijgen na zonsondergang. Batterij wordt gebruikt wanneer zonne-energie niet beschikbaar is.",
    "consumption_text_pv_yield": "Laad de batterij op tijdens piekproductie-uren om de PV-productie te optimaliseren. Batterij wordt gebruikt wanneer zonne-energie niet beschikbaar is.",
    "bkup_text": "100% van de batterij wordt gereserveerd als back-up.",
    "reserve": "Reserve",
    "optimization": "Optimalisatie gebaseerd op",
    "utility_rates": "Energietarieven",
    "increase_consumtion": "Verhoog Eigen Gebruik naar",
    "max_consumption": "Maximaliseer Energie-Onafhankelijkheid",
    "optimize_pv_production": "PV-productie optimaliseren",
    "activate": "Activeer",
    "active": "Activeer",
    "save": "Bewaar",
    "edit": "BEWERKEN",
    "error": "Niet in staat om opslaginstellingen te bewaren.",
    "requestTakingLonger": "Het verzoek duurt langer dan verwacht. Probeer het later opnieuw",
    "batterySettingsTakingLonger": "Het bijwerken van de batterijinstelling duurt langer dan verwacht. Probeer het later opnieuw",
    "completed": "De instellingen van de batterij zijn met succes bijgewerkt.",
    "completedAdvance": "De geavanceerde instellingen van de batterij zijn met succes bijgewerkt.",
    "requestPending": "Aanvraag in behandeling. Wachten op bevestiging van de gateway. Probeer het later opnieuw.",
    "editRequest": "U heeft een actief verzoek. Gelieve te wachten op bevestiging of dit verzoek te annuleren voor verder te gaan met de selectie.",
    "editRequestVls": "U heeft een actief verzoek in de geavanceerde instellingen van de batterij. Gelieve te wachten op bevestiging of dit verzoek annuleren om verder te gaan met de selectie.",
    "cancelRequest": "Uw verzoek werd geannuleerd.",
    "updatedSuccesfully": "Succesvol geüpdatet",
    "pendingRequestText": "Verzoek in Behandeling",
    "cancelRequestText": "Verzoek annuleren",
    "pendingText": "In Behandeling",
    "processingText": "Verwerken",
    "battery_reserve": "van de opgeslagen energie zal bewaard worden als back-up",
    "cancelFailed": "Annuleren van taak mislukt.",
    "noPendingTask": "Systeem heeft geen taken in afwachting die geannuleerd kunnen worden.",
    "noEncharges": "Systeem heeft geen batterijen",
    "severeWeatherText": "Noodweer Controle",
    "disabled": "Uitschakelen",
    "enabled": "Inschakelen",
    "weatherWatchDescription": "Zet uw batterijprofiel in de modus Volle Back-up wanneer er een waarschuwing voor zware weersomstandigheden wordt gegeven voor uw locatie.",
    "disabledModeInfo": "Enphase communiceert met de {%s} wanneer ingeschakeld, dit voor het detecteren van noodweer waarschuwingen en stelt uw batterij profiel in op volledige back-up modus voor het leveren van een back-up tijdens de gebeurtenis. Wanneer de gebeurtenis voorbij is, zal het batterij profiel terugkeren naar zijn vorige instelling.",
    "enabledModeInfo": "Enphase zal communiceren met de {%s} wanneer ingeschakeld, dit voor het detecteren van noodweer waarschuwingen en stelt uw batterij profiel in op volledige back-up modus. Het batterij profiel zal terugkeren naar zijn vorige instelling na de gebeurtenis.",
    "activeModeInfo": "Enphase detecteerde een noodweer waarschuwing van de {%s} en uw batterij wordt ingesteld op volledige back-up modus. Na de eindtijd van de gebeurtenis, zal het batterij profiel terugkeren naar zijn vorige instelling.",
    "stormGuardModeInfo": "Wanneer %{status}, bewaakt de Storm Guard-functie de waarschuwingen voor zware weersomstandigheden die door %{nws} worden afgegeven. Het overschrijft uw batterijprofiel naar de 'Volledige Back-Up' modus als er een waarschuwing wordt gegeven voor uw locatie. Hierdoor kan uw volledige batterijcapaciteit worden gereserveerd voor gebruik tijdens een mogelijke stroomonderbreking.%{nl}Als er een waarschuwing wordt afgegeven voor uw locatie dan wordt 'Storm Alert: On' weergegeven onder 'batterijprofiel' op de Statuspagina en Live Statuspagina.%{nl}Na het einde van de waarschuwing keert het batterijprofiel terug naar de vorige instellingen.",
    "editActiveWeatherAlert": "Noodweer Controle is Actief. Gelieve te wachten tot de gebeurtenis voorbij is (aanbevolen) of schakel de noodweer controle om verder te gaan met de selectie.",
    "enabledToActiveAlert": "Enphase heeft een noodweer waarschuwing gedetecteerd via de nationale weerdienst en uw batterij profiel wordt ingesteld op volledige back-up modus. Na de eindtijd van de gebeurtenis, zal het batterij profiel terugkeren naar zijn vorige instelling.",
    "activeToEnabledAlert": "Het noodweer is voorbij en uw batterij profiel werd ingesteld volgens zijn vorige instellingen.",
    "okayText": "OKÉ, Begrepen!",
    "disclaimerText": "De noodweer controle feature gebruikt informatie van de V.S. Nationale Oceanische en Atmosferische administratie/nationale weerdienst zoals (zonder beperking) noodweer waarschuwingen, deze informatie is toegankelijk voor het publiek en niet onderhevig aan copyright bescherming. Enphase bezit of controleert dergelijke informatie niet. U gaat er uitdrukkelijk mee akkoord dat het gebruik van deze feature op uw eigen risico is. En u draagt het volledige risico gerelateerd tot het inschakelen van deze feature en zijn toekomstig gebruik. Enphase levert dergelijke informatie via de noodweer controle feature “zoals deze is”, en wijst daarom alle aansprakelijke van garanties, uitdrukkelijk of aangewezen, inclusief (zonder beperking) aangewezen garanties van verkoop of gebruik voor specifieke doeleinden af. Enphase zal geen verantwoordelijkheid dragen t.o.v. U of een derde partij voor directe, indirecte, incidentele, navolgende, speciale of voorbeeldige schade of verlies als gevolg van het gebruik of misbruik van deze informatie.",
    "disclaimer": "Disclaimer",
    "agreeText": "Akkoord & verdergaan",
    "disagreeText": "Niet Akkoord",
    "nationalWeather": "Nationale Weerdienst (NWS)",
    "dataNotAvailable": "NA",
    "errorTitle": "Fout",
    "errorCode": "Foutcode",
    "thresholdError": "Reporting Error",
    "PopupError": "Serienummer van uw batterij",
    "thresholdPopupError": "Heeft niet gerapporteerd tijdens de laatste rapportagecyclus? Daarom is het geaggregeerde opslagpercentage exclusief het opslagpercentage voor deze batterij. De batterij moet beginnen rapporteren tijdens de volgende rapportagecyclus. Neem contact op met ondersteuning als het probleem blijft aanhouden.",
    "errorPopup1": "heeft een probleem (Fout bes:",
    "errorPopup2": ", Fout code:",
    "errorPopup3": "). Deze foutgebeurtenis zorgt ervoor dat het gemelde opslagpercentage van deze batterij onbetrouwbaar is. Daarom is het geaggregeerde opslagpercentage hierboven exclusief het opslagpercentage voor deze batterij. Neem contact op met ondersteuning als het probleem blijft aanhouden.",
    "contactSupport": "Contacteer Klantenservice",
    "errorSubmitButton": "Oké, Begrepen",
    "microinvertorError": "Micro-omvormer van de batterij is niet actief",
    "microinvertorsError": "Micro-omvormers van de batterij zijn niet actief",
    "touAlert": "De spaarstand werkt alleen als uw invoersnelheid voor van elektriciteit varieert met de gebruiksduur. Werk uw invoersnelheid van elektriciteit bij om deze modus in te schakelen.",
    "touAlert2": "Stel uw elektriciteitsimporttarief in op ToU en Exporttarief als NEM om de bespaarmodus in te schakelen.%{nl}Besparingsmodus werkt alleen als u Net Energy Metering (NEM) heeft en uw elektriciteitsgebruik varieert met de Time-of-Use (ToU).",
    "touAlert3": "Stel uw elektriciteitsimportratief in op ToU om de bespaarmodus in te schakelen",
    "touAlert4": "Stel uw elektriciteitsexportschema in om de besparingsmodus in te schakelen",
    "updateElectricityRate": "Elektriciteit invoersnelheid bijwerken",
    "batteryChangeAlert": "Uw batterijprofiel is gewijzigd in de modus voor eigen verbruik, omdat de spaarstand alleen werkt als uw stroom invoersnelheid varieert met de duur van het gebruik.",
    "batteryChangeAlert2": "Uw batterijprofiel is gewijzigd naar zelfverbruiksmodus omdat de Besparingsmodus alleen werkt als u Net Energy Metering (NEM) heeft en uw elektriciteitsgebruik varieert met de Time-of-Use (ToU).",
    "viewDetails": "Bekijk de Details",
    "ok": "Ok",
    "systemRequest": "Systeem gegenereerde verzoeken kunnen niet worden geannuleerd.",
    "featureDetailsButton": "Storm Guard Feature Details",
    "stormGuardEnablePopUp": "Als u stormbewaking inschakelt, kunt u de volledige batterijcapaciteit reserveren voor gebruik bij een potentiële stroomstoring, door het batterijprofiel bij ernstige weeralarmen te overschrijven met 'Volledige back-up'.",
    "stormGuardDisablePopUp": "Het uitschakelen van stormbewaking wordt afgeraden. Deze helpt u te beschermen tegen ernstige stroomstoringen door zware weersomstandigheden waarvoor ernstige weeralarmen worden gegeven.",
    "batterySmartProfile": {
      "title": "Selecteer het slimme batterijprofiel",
      "description": "Meer informatie over het kiezen van het juiste profiel voor uw batterijsysteem",
      "viewDetails": "Bekijk de Details"
    },
    "reserveDisclaimer": "De batterijreserve kan niet lager dan  %{minSoc}% worden ingesteld. Een minimum van  %{minSoc}% energie wordt opgeslagen in de batterij om uw kritieke thuislading te voeden tijdens een stroomonderbreking.",
    "eIpopDesc": "%{enabled}: Uw batterij wordt ontladen om geld te besparen tijdens piekuren als de elektriciteitsprijzen hoog zijn. Zodra dat is gebeurd, krijgt Energy Independence prioriteit. Dit zal uw zelfvoorziening op het gebied van energie vergroten totdat u de back-uplading van de batterij bereikt. Uw accu wordt 's ochtends opgeladen met zonne-energie om u voor te bereiden op de volgende piekperiode.%{nl}%{disabled}: Uw batterij zal alleen ontladen tijdens piekuren wanneer het elektriciteitstarief hoog is. Op andere momenten is uw batterij inactief of wordt hij 's ochtends opgeladen door middel van zonne-energie om u voor te bereiden op de volgende piekperiode.",
    "errActiveCostSave": "Activeer de Zuinige modus om deze functie te gebruiken",
    "eiDescreption": "Energieonafhankelijkheid na piekuren",
    "advSetting": {
      "cfg": {
        "title": "Laad de batterij op via het elektriciteitsnet",
        "descrDisable": "Uw batterij wordt opgeladen door Solar.",
        "descrEnabled": "De batterij wordt opgeladen via zonne-energie. Het kan ook worden opgeladen via het lichtnet wanneer de batterij zich in de volledige back-upmodus bevindt of wanneer de batterijlading lager is dan de reservecapaciteit in zuinige of eigen verbruiksmodi.",
        "descrEnabledFR": "Uw batterij wordt in het geplande interval opgeladen via het net. Deze wordt tijdens deze periode niet ontladen.",
        "popUpDescrFR": "%{enabled}: Uw batterij wordt in het geplande interval opgeladen via het net. Deze wordt tijdens deze periode niet ontladen. %{nl}%{disabled}: Uw batterij laadt op door zonne-energie.",
        "popUpDescr": "%{enabled}: De batterij wordt opgeladen via zonne-energie. Het kan ook worden opgeladen via het lichtnet wanneer de batterij zich in de volledige back-upmodus bevindt of wanneer de batterijlading lager is dan de reservecapaciteit in zuinige of eigen verbruiksmodi.%{nl}%{disabled}: Uw batterij wordt opgeladen door Solar.",
        "disclaimer": "Het gebruik van een niet-hernieuwbare energiebron om uw Enphase-opslagsysteem op te laden, kan van invloed zijn op uw geschiktheid om ITC te gebruiken. Neem voor meer informatie contact op met uw belastingadviseur.",
        "dlgTitle": "Opladen via het net?",
        "dlgInfo": "Eenmaal ingeschakeld, wordt uw batterij in het geplande interval opgeladen via het net. Deze wordt tijdens deze periode niet ontladen. Controleer de voorschriften van de nutsvoorziening voordat u deze optie inschakelt.",
        "selfDeclrFR": "Ik begrijp dat net opladen tegen de voorschriften van nutsbedrijven kan zijn.",
        "selectSchedule": "Selecteer het schema om uw batterij van het net op te laden.",
        "titleFR": "Plan het opladen van het grid",
        "saveSch": "Schema opslaan",
        "chargeSch": "Oplaadschema",
        "selfDeclr": "Ik begrijp dat mijn recht op de investeringsaftrek in het gedrang kan komen.​",
        "disclaimer_itk": "Het gebruik van een niet-hernieuwbare energiebron om het Enphase-opslagsysteem te wijzigen, kan van invloed zijn op de geschiktheid van een ITC-claim. Raadpleeg de eigenaar voor goedkeuring.",
        "selfDeclr_itk": "De eigenaar erkent dat de mogelijkheid om aanspraak te maken op het investeringsbelastingkrediet kan worden aangetast.",
        "activeStormAlert": "Stormwaarschuwing is ingeschakeld voor uw systeem. Wacht tot de waarschuwing is beëindigd om deze instelling bij te weken."
      }
    },
    "exM": {
      "title": "Expertmodus",
      "subTitle1": "Schema batterijprofielen",
      "subTitle2": "Geplande batterijprofielen",
      "schedule": "Schema",
      "tariffNotSetDlgtitle": "Elektriciteitstarief niet ingesteld",
      "tariffNotSetDlgContent": "Stel uw elektriciteitstarief in om de spaarmodus in te schakelen. %{nl}Enphase heeft uw tariefgegevens nodig om het beste schema voor uw batterij te bepalen.",
      "setRate": "Stel tarief in",
      "tariffUpdateDlgtitle": "Werk elektriciteitstarief bij",
      "tariffUpdateDlgContent": "De zuinige modus werkt alleen indien u netto-energiemeting (NEM) hebt en uw elektriciteitstarief varieert door de gebruiksduur (Time-of-Use, ToU).",
      "updateRate": "Werk tarief bij",
      "setNemDlgTitle": "Electricity Export Rate Not Set",
      "setNemDlgContent": "Stel uw invoertarief elektriciteit in als NEM om deze modus in te schakelen.",
      "setNemCta": "Stel in als NEM",
      "preview": "Voorbeeld",
      "addBatProfile": "Batterijprofiel toevoegen",
      "pViewPop": {
        "l1": "De grafiek vertegenwoordigt de geplande batterijprofielen voor een periode van 24 uur.",
        "l2": "De batterijreserve is alleen van toepassing op de eigen verbruik- en zuinige modus. In volledige back-up is uw batterijreserve 100%.",
        "l3": "Maximaliseert uw energieonafhankelijkheid",
        "l4": "Maximaliseert uw besparingen op basis van elektriciteitstarieven",
        "l5": "Bespaart 100% batterij-energie voor back-up",
        "batteryProfiles": "Batterijprofielen"
      },
      "batReserveDisclaimer": "De batterijreserve is alleen van toepassing op de eigen verbruik- en zuinige modus. In volledige back-up is uw batterijreserve 100%."
    },
    "prfAssist": {
      "t0": "Al in aanbevolen profiel",
      "t1": "Onze aanbevelingen",
      "t2": "Zuinige modus met een lage batterijreserve en energieonafhankelijkheid ingeschakeld.",
      "t3": "Zuinige modus met een lage batterijreserve en energieonafhankelijkheid uitgeschakeld.",
      "t4": "Modus Eigen verbruik met een lage batterijreserve.",
      "t5": "Modus Eigen verbruik met een gemiddelde batterijreserve.",
      "t6": "Volledige back-upmodus.",
      "t7": "Zuinige modus met een hoge batterijreserve en energieonafhankelijkheid uitgeschakeld.",
      "t8": "Modus Eigen verbruik met een hoge batterijreserve.",
      "batResText": "Batterijreserve tussen",
      "learnHowEmea": "Meer informatie over het batterijprofiel",
      "learnHow": "Ontdek hoe batterijprofielen werken",
      "editPref": "Voorkeuren bewerken",
      "c1": "Geld besparen",
      "c1Sub": "Maximaal besparen op de maandelijkse rekening",
      "c2": "Energieonafhankelijkheid",
      "c2Sub": "Milieuvriendelijk leven door zelf uw woning van stroom te voorzien",
      "c3": "Back-up",
      "c3Sub": "Back-up tijdens stroomonderbrekingen",
      "p1": "Eerste prioriteit",
      "p2": "Tweede prioriteit",
      "optional": "Optioneel",
      "ques": "Wat zijn uw verwachtingen van het Enphase-systeem?",
      "priority": "Klik en sleep de doelen op volgorde van meest naar minst belangrijk.",
      "ftrpTutorialText": "Selecteer en sleep de kaarten naar boven en beneden om volgens uw prioriteit in te delen. De eerste kaart van boven heeft de hoogste prioriteit.",
      "updateBatteryProfile": "Batterijprofiel bijwerken",
      "activatedSavingsMode": "Uw batterij staat momenteel in de zuinige modus met een reserve van %{soc}% en de energieonafhankelijkheid na piekuren bedraagt %{eiStatus}.",
      "activatedSelfConsumptionMode": "Uw batterij staat momenteel in de modus Eigen verbruik met een reserve van %{soc}%.",
      "activatedFullBackupMode": "Uw huidige batterijprofiel is Volledige back-up.",
      "activatedSavingsModeWithoutSoc": "Uw batterij staat op dit moment in de besparingsmodes en energie-onafhankelijkheid na piekuren is %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "Uw batterij staat op dit moment in zelfverbruikmodus.",
      "activateProfile": "Wilt u het aanbevolen profiel activeren?"
    }
  },
  "envoy": {
    "all": "Alle gateways",
    "pvAll": "Allemaal",
    "dropDwnHelper": "Toon gegevens van",
    "envSN": "Gateway SN:",
    "reconnect": "Verbind uw gateway opnieuw.",
    "extraContent": "In de tussentijd kunt u, als u zich in de buurt van uw systeem bevindt, lokaal verbinding maken met de Gateway om de huidige status te bekijken.",
    "btnText": "Leer hoe u een verbinding kunt maken met de Wifi van de gateway",
    "getHelp": "Zorg dat uw Gateway verbonden raakt met uw Wi-Fi thuis",
    "envoyConfirmation": "Maak verbinding met de Gateway voor de AP-modus om verder te gaan.",
    "title": "We hebben gezien dat u Envoy-S of IQ Gateway gebruikt samen met Wi-Fi.",
    "steps": "Volg de stappen om de Gateway te verbinden met het Wi-Fi-netwerk",
    "steps_ap": "Volg de stappen om verbinding te maken met het Gateway-netwerk",
    "ap_button": "Druk op de AP-modusknop",
    "ap_modeDescription": "Druk kortstondig (niet vasthouden) op de menutoets van de Gateway onder het telefoonpictogram. Dit zal de AP-modus op uw Gateway inschakelen zodat er een draadloos netwerk wordt gecreëerd waarmee u met uw telefoon kunt verbinden.",
    "disable_data": "Mobiele data uitschakelen",
    "disable_dataDescription": "Zet de mobiele data uit (cellulaire data) in de instellingen van uw mobiele apparaat. Ga naar Instellingen > Mobiele Data en zet het uit.",
    "envoy_network": "Verbinden met het netwerk van de Gateway",
    "envoy_description": "Maak verbinding met het netwerk van de Gateway via de Wi-Fi-instellingen van uw telefoon. Envoy_029655 is de naam van het mininetwerk waarmee u verbinding moet maken, waarbij “029655” de laatste zes cijfers zijn van het serienummer van uw Gateway.",
    "home_wifi": "De Gateway verbinden met de Wi-Fi thuis",
    "wifi_description": "Tik op de Home Wifi configureren knop, selecteer uw thuisnetwerk en voer het Wifi wachtwoord in.",
    "configure_wifi": "Configureer thuis Wifi",
    "cancel": "Annuleren",
    "stickyNotification": "Tik niet op de knop 'Terug' of sluit de app niet af (u kunt deze minimaliseren) terwijl opnieuw verbinding wordt gemaakt met uw Gateway.",
    "enter_password": "Voer wachtwoord in voor",
    "password": "Wachtwoord",
    "incorrect_password": "Onjuist wachtwoord",
    "wifi_failureMsg": "Gateway kan niet verbinden met uw Wi-Fi-netwerk",
    "wifi_successMsg": "Gateway is succesvol verbonden met Wi-Fi",
    "envoyConnectToCellular": "U kunt nu uw mobiele apparaat loskoppelen van uw Gateway-netwerk en verbinding maken met uw Wi-Fi-netwerk of uw mobiele data inschakelen.",
    "envoyToastMessage": "Uw Gateway is succesvol verbonden. Maar het kan tot 30 minuten duren voordat de status van uw Gateway wordt bijgewerkt.",
    "wifi_congratsMsg": "Gefeliciteerd! U bent weer online. Nu kunt u uw mobiele telefoon opnieuw aansluiten op het wifi netwerk thuis.",
    "tryagain": "Probeer het opnieuw",
    "okay": "Oké, begrepen",
    "failedToFetchWiFiNetworks": "Problemen met het ophalen van Wifi netwerken. Probeer het na een tijdje nog eens.",
    "noWifiNetworkFound": "Geen Wifi netwerk gevonden. Herstart uw Wifi-router en probeer het opnieuw.",
    "option2": "Als de bovenstaande stappen niet werken, leer hoe u dit handmatig kunt doen",
    "learnhow": "Dowiedz się, jak",
    "ensureOn": "Zorg ervoor dat de Gateway is ingeschakeld",
    "connectToPower": "Zorg ervoor dat uw Gateway verbonden is met een stroombron"
  },
  "whatsnews": {
    "monitorTitle": "Controleren",
    "monitorContent": "Bekijk uw systeemstatus in een oogopslag met de belangrijkste gegevens op één scherm",
    "trackTitle": "Bijhouden",
    "trackContent": "Houd uw energieproductie- en energieverbruikstrends bij en bekijk ze in een dagelijkse, maandelijkse, jaarlijkse of levenslange weergave",
    "reportTitle": "Rapport",
    "reportContent": "Voer rapporten van energieproductie en -gebruik uit vanuit de app in een dagelijkse, wekelijkse, maandelijkse of aangepaste periode"
  },
  "theme": {
    "instructions": "Huidig kleurenschema",
    "night": "Nacht",
    "day": "Dag"
  },
  "devices": {
    "model": "Model",
    "dryContactLoads": "Ladingen",
    "generator": "Generador",
    "noDeviceFound": "Geen apparaat gevonden",
    "searchMicroinverters": "Zoeken naar Micro-inverters SN",
    "serialNumber": "SN",
    "configure": "Configureren",
    "connect": "Verbinden",
    "envoy": "Gateway",
    "microinverters": "Microinverters",
    "microinverter": "Microinverter",
    "stringInverters": "String Inverter",
    "storage": "Batterij",
    "enpower": "Systeemcontroller",
    "skuNumber": "SKU",
    "firmwareVersion": "Firmware",
    "cycleCount": "Aantal cycli",
    "cycleCountInfo": "Het aantal cycli voor een batterij is het totale aantal cycli volledig opladen en ontladen. Het wordt berekend als de totale bij elkaar opgetelde energie gedeeld door de bruikbare capaciteit van de batterij. Het cijfer dat hier wordt weergegeven, vertegenwoordigt de voltooide cyclus.",
    "status": "Staat",
    "array": "reeks",
    "help": "Helpen",
    "not_reporting": "Rapporteert niet",
    "not_reporting_lowercase": "rapporteert niet",
    "normal": "Normaal",
    "home": "Huis",
    "no_microinverters": "Geen micro-omvormer gevonden",
    "no_storage": "Geen opslag gevonden",
    "no_envoy": "Geen Gateway gevonden",
    "no_enpower": "Geen systeemcontroller gevonden",
    "wirelessRangeExtender": "Verlenger draadloos bereik",
    "no_wirelessRangeExtender": "Geen verlenger draadloos bereik gevonden",
    "lastReported": "Laatst gemeld",
    "manufacturer": "Naam fabrikant",
    "startType": "Starttype",
    "fuelType": "Type brandstof",
    "modelNumber": "Model Nummer",
    "onOffCycles": "Totaal aan/uit-cycli",
    "maintainenceInfo": "Onderhoudsinformatie",
    "maintainenceSub": "Update deze gegevens om meldingen te krijgen over het generatoronderhoud en brandstofeisen",
    "lastMaintainenceDate": "Datum laatste onderhoud",
    "lastRefuellingDate": "Datum laatste bijvulling",
    "lastRefuellingTime": "Tijd laatste bijvulling",
    "lastMaintainenceTime": "Tijd laatste onderhoud",
    "litresOfFuel": "Liters of fuel filled",
    "additionalInfo": "Voor aanvullende informatie",
    "statistics": "Uw statistieken sinds het laatste onderhoud:",
    "timeElapsed": "Tijd verstreken:",
    "cycles": "Aan/uit cycli:",
    "runningHours": "Looptijd:",
    "Days": "dagen",
    "update": "Update",
    "clickHere": "klik hier",
    "savedSuccessfully": "Uw instellingen zijn succesvol opgeslagen.",
    "loads": {
      "status": "Status",
      "smartControl": "Smart Control",
      "auxillaryContact": "Hulpcontact"
    },
    "devicegenerator": {
      "on": "Aan",
      "off": "Uit"
    },
    "connected": {
      "true": "Verbonden met de Enphase cloud",
      "false": "Niet verbonden met de Enphase cloud"
    },
    "envoyConnected": {
      "wait": "Zoeken naar Gateway...",
      "true": "Gateway is succesvol gedetecteerd.",
      "false": "Gateway niet gedetecteerd."
    },
    "stepOne": "Maak eerst rechtstreeks verbinding met de Gateway. Druk eerst op de verbindingsknop op de Gateway om dit te doen.",
    "stepTwo": "Ga vervolgens naar uw Wi-Fi-instellingen en maak verbinding met het netwerk van de Gateway:",
    "stepThree": "Zodra er verbinding is gemaakt, keert u terug naar dit scherm. Uw verbinding met internet wordt tijdelijk verbroken.",
    "connectLocally": "Lokaal verbinden",
    "connectEnvoy": "Maak verbinding met de Gateway door gebruik te maken van",
    "connectEnvoyUser": "Gebruikersnaam",
    "connectEnvoyPassword": "Wachtwoord",
    "notAllowAPMode": "De Gateway ondersteunt geen lokale connectiviteit.",
    "localEnvoyConnected": {
      "true": "Gateway is succesvol gedetecteerd",
      "false": "Geen Gateway gevonden op het lokale netwerk",
      "wait": "Wachten..."
    },
    "envoyPwd": {
      "urenvPwd": "Wachtwoord van uw Gateway",
      "retrivePwd": "Om het wachtwoord van uw Gateway op te halen:",
      "infoTitle": "Wachtwoord van uw Gateway",
      "infoDescription": "U hebt dit wachtwoord nodig om uw Gateway opnieuw te verbinden met uw Wi-Fi. Dit gebeurt normaal gesproken wanneer het Wi-Fi-wachtwoord wijzigt of de serviceprovider is gewijzigd.",
      "infoLearnMore": "Klik hier om meer te leren"
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Zet de Bluetooth van uw telefoon aan om verbinding te maken met uw IQ gateway",
      "tryApMode": "Probeer AP modus",
      "gatewayNotFound": "IQ gateway kan niet gevonden worden. Zorg ervoor dat uw IQ gateway zich in de buurt bevindt en aanstaat.",
      "bleNotSupported": "Bluetooth wordt niet ondersteund",
      "bleNotSupportedDesc": "Bluetooth wordt niet ondersteund door uw apparaat, zorg ervoor dat het apparaat Bluetooth- en locatie-opties heeft.",
      "bleConnected": "Verbonden met Bluetooth",
      "scanningGateway": "Scannen op IQ Gateway",
      "fewMints": "Dit kan enkele minuten duren",
      "noWifi": "Geen Wifi-apparaten gevonden",
      "password": "Wachtwoord",
      "gatewayConnected": "IQ gateway is met succes verbonden met Wifi.",
      "okGotIt": "Ok, ik begrijp het",
      "noGateway": "IQ gateway niet gevonden",
      "gatewayNearByWarning": "Zorg ervoor dat gateway zich in de buurt bevindt en aanstaat.",
      "noNetwork": "Geen netwerk",
      "wifiRouterWarning": "Laat de Wifi-router aanstaan en zorg ervoor dat uw IQ gateway zich binnen het Wifi-bereik bevindt.",
      "connectionError": "Verbindingsfout",
      "turnOn": "Aanzetten",
      "failedWifiConnect_1": "Het is niet gelukt om een verbinding met het Wifi-netwerk te maken. Gelieve ",
      "failedWifiConnect_2": "Contact opnemen met support",
      "failedWifiConnect_3": " voor hulp.",
      "failedIQConnect_1": "Het is niet gelukt om een verbinding met de IQ gateway te maken. Gelieve ",
      "failedIQConnect_2": "Contact opnemen met support",
      "failedIQConnect_3": " voor hulp.",
      "bleDevices": "Bluetooth-apparaten",
      "wifiNetworks": "Wi-Fi-netwerken",
      "connectBle": "Maak verbinding met Bluetooth",
      "gatewayToWifi": "IQ Gateway verbinden met Wi-Fi...",
      "bleStatus": "Bluetooth-status controleren...",
      "searchingWifi": "Ricerca di reti Wi-Fi in corso...",
      "connectingBle": "Verbinding maken met Bluetooth",
      "turnOnBle": "Bluetooth aanzetten",
      "tryAgain": "Probeer het opnieuw",
      "wifiSsIdConfigFailedDesc": "Er is een onbekende fout opgetreden tijdens het verbinden met het wifi-netwerk. Probeer het later opnieuw of maak verbinding met een ander netwerk.",
      "wifiCommunicationError": "Wi-Fi-communicatiefout",
      "wifiCommunicationErrorDesc": "Kan geen verbinding maken met de BLE-module van IQ Gateway. Probeer het later alstublieft.",
      "networkNotFound": "Netwerk niet gevonden",
      "networkNotFoundDesc": "Het netwerk waarmee u verbinding probeert te maken, is niet gevonden. Zorg ervoor dat de wifi-router is ingeschakeld of probeer een ander netwerk."
    }
  },
  "notification": {
    "offline": "Offline",
    "apmode": "AP-modus"
  },
  "siteempty": {
    "nosystemassociated": "Uw account is momenteel niet gekoppeld aan een systeem.",
    "systemowner": "Bent u de eigenaar van een Enphase-systeem?",
    "contactyourinstaller": "Neem contact op met uw installateur om het account dat aan uw systeem is gekoppeld, te verifiëren.",
    "interestedonsystem": "Bent u geïnteresseerd in een Enphase-systeem?",
    "initiatetransferofwarranty": "Start de garantieoverdracht als u iets hebt gekocht met een Enphase-systeem.",
    "applytransferownership": "Vraag hier een overdracht van eigendom aan.",
    "ownershiptransfer": "Overdracht van eigendom",
    "visita": "Bezoek een",
    "publicsystempage": "openbare systeempagina",
    "monitoringexperience": "om de Enphase monitorervaring te bekijken."
  },
  "recaptcha": {
    "verification_failed": "reCAPTCHA-verificatie mislukt. Probeer het opnieuw.",
    "recaptcha_unreachable": "We hebben uw reCAPTCHA-invoer niet kunnen valideren. Probeer het opnieuw."
  },
  "mobile_app_rating": {
    "enjoying_app": "Geniet u van de Enphase-app?",
    "rate_on_play_store": "Beoordeel uw ervaring",
    "rate_on_play_store2": "In de Play store",
    "rate_us": "Beoordeel ons nu",
    "may_be_next": "Misschien de volgende keer"
  },
  "consumptionMtr": {
    "btnText": "Verbruiksmeter toevoegen",
    "infoText": "De verbruiksmeter helpt u uw totale energieverbruik bij te houden"
  },
  "replacement": {
    "microinverter_not_reporting": "Micro-omvormers rapporteren niet.",
    "batteryWarning": 'Dit kan gebeuren als de draadloze communicatie tussen uw gateway en de batterij niet robuust is. Dit kan een tijdelijke storing zijn en zou snel moeten zijn opgelost. Als het probleem zich blijft voordoen, neem dan contact op met uw beheerder voor hulp.',
    "controllerWarning": 'Dit kan gebeuren als de draadloze communicatie tussen uw gateway en de systeemcontroller niet robuust is. Dit kan een tijdelijke storing zijn en zou snel moeten zijn opgelost. Als het probleem zich blijft voordoen, neem dan contact op met uw beheerder voor hulp.',
    "batteryError": 'Batterij rapporteert geen gegevens.',
    "controllerError": 'Systeemcontroller rapporteert niet.',
    "contactMaintainer": 'Neem contact op met uw onderhoudsmonteur voor hulp.',
    "systemWarning": 'systeem waarschuwing',
    "array_details": "Array Gegevens",
    "replacement_warranty1": "",
    "replacement_warranty": "Micro-inverters vallen onder de garantie en komen in aanmerking voor vervanging.",
    "shipping_address": "Verzendadres",
    "site_address": "Adres van de site",
    "change": "WIJZIGEN",
    "select_microinverters": "SELECTEER MICRO-OMVORMERS",
    "serial_number": "Zoeken op serienummer",
    "status": "Status",
    "normal": "Normaal",
    "not_reporting": "Geen rapportage",
    "submit_request": "Aanvraag indienen",
    "dear": "Beste",
    "replacement_message1": "Misschien moet u contact opnemen met uw installateur",
    "replacement_message2": "om de vervanging te laten uitvoeren zodra het vervangende apparaat is verzonden. Er kunnen vervangingskosten in rekening worden gebracht door uw installateur.",
    "request_submitted": "Uw retouraanvraag is succesvol ingediend.",
    "response_message": "Gebruik de aanvraag ID om de status van de vervanging bij te houden wanneer u contact opneemt met de klantenservice.",
    "request_id": "Aanvraag ID",
    "ok": "Oké, begrepen",
    "replacement_delivery": "Vervanging zal worden geleverd aan uw site",
    "replacement_delivery_installer": "Vervanging zal worden geleverd aan uw lokale installateur",
    "installer_address": "INSTALLATEUR ADRES",
    "understand": "Ik begrijp het",
    "continue_button": "Doorgaan",
    "error_message": "Kan de aanvraag-ID niet genereren.",
    "failed_to_fetch": "Mislukt om micro-omvormers op te halen. Probeer het opnieuw",
    "change_address": "Wijzig verzendadres"
  },
  "tariff": {
    "tariff": "tarief",
    "tariffNotAdded": "Geen tarief toegevoegd",
    "tariffNotSet": "Tarief niet ingesteld",
    "tariffType": "Tarief Type",
    "buying": "Kopen",
    "selling": "Verkopen",
    "flat": "Vast Tarief",
    "tou": "Tijdstip van gebruik",
    "tiered": "Gefaseerd",
    "copyFromBuyingTariff": "Kopieer van het Koop Tarief",
    "copyFromSellingTariff": "Kopieer van het Verkoop Tarief",
    "dayBasedTariff": "Verschilt uw tarief per dag?Verschilt uw tarief in de loop van de dag?",
    "unitsBasedTariff": "Verschilt uw tarief afhankelijk van de verbruikte eenheden?",
    "seasonalTariff": "Verschilt uw tarief per seizoen?",
    "weekendTariff": "Verschilt uw tarief in het weekend?",
    "baseRateTariff": "Wat is het basistarief?",
    "flatLabel": "De energiekosten worden de hele dag door vastgesteld.",
    "touLabel": "Energiekosten variëren tijdens piekuren.",
    "tieredLabel": "Energiekosten kunnen variëren wanneer de energieconsumptie van de unit toeneemt.",
    "rate": "Tarief",
    "addSeason": "Voeg Seizoen Toe",
    "season": "Seizoen",
    "next": "Volgende",
    "noSeasonWeekend": "Tarief varieert niet volgens de seizoenen of tijdens het weekend.",
    "weekendOnly": "Tarief varieert alleen tijdens het weekend.",
    "seasonAndWeekend": "Tarief varieert volgens de seizoenen en tijdens het weekend.",
    "seasonOnly": "Tarief varieert alleen volgens de seizoenen.",
    "infoText": "info",
    "baseRate": "Basistarief",
    "remove": "Verwijderen",
    "from": "Van",
    "to": "Tot",
    "addPeak": "Voeg Piek Toe",
    "tariffDetails": "Tariefgegevens",
    "off-peak": "Daluren",
    "above": "Boven",
    "below": "hieronder",
    "between": "Tussen",
    "and": "en",
    "weekdays": "weekdagen",
    "weekend": "weekend",
    "winter": "Winter",
    "summer": "zomer",
    "fall": "Herfst",
    "spring": "Lente",
    "confirmAndSave": "Bevestigen & Opslaan",
    "buyingTariff": "Koop Tarief",
    "sellingTariff": "Verkoop Tarief",
    "edit": "Bewerken",
    "offPeak": "Daluren",
    "peak": "Piekuren",
    "period": "Piekuren",
    "addTier": "Voeg Niveau Toe",
    "tier": "Niveau",
    "yesLabel": "Ja",
    "noLabel": "Nee",
    "manualConfiguration": "Handmatige configuratie",
    "added": "toegevoegd",
    "modified": "aangepast",
    "successfully": "succes",
    "alreadySelected": "werd al geselecteerd",
    "alreadyAdded": "werd al toegevoegd",
    "buyingTariffAdded": "Tarief Aankoop succesvol toegevoegd",
    "sellingTariffAdded": "Tarief Verkoop succesvol toegevoegd",
    "buyingTariffModified": "Tarief Aankoop succesvol aangepast",
    "sellingTariffModified": "Tarief Verkoop succesvol aangepast",
    "buyingTariffReset": "Tarief Aankoop opnieuw ingesteld",
    "sellingTariffReset": "Tarief Verkoop opnieuw ingesteld",
    "reset": "Opnieuw Instellen",
    "resetConfirmationText": "Weet u zeker dat u de tariefgegevens opnieuw wil instellen?",
    "resetErrorText": "Het is niet mogelijk om de tariefgegevens opnieuw in te stellen",
    "updateErrorText": "Het is niet mogelijk om de tariefgegevens up te daten",
    "tariffErrorText": "Ongeldige invoer. Deze waarde bestaat al in Niveau ",
    "tierInvalidEntry": "Ongeldige invoer. De waarde moet hoger zijn dan \"Niveau 1\"",
    "timeInvalidEntry": "Ongeldige invoer. De waarde moet hoger zijn dan \"Van\"",
    "invalidValue": "Waarde moet hoger zijn dan 0"
  },
  "currency": {
    "currencyEquivalent": "Zie het valuta-equivalent van de energiewaarden.",
    "currencyConversion": "Valuta conversiefactor instellen",
    "currencyInfo": "De gerapporteerde monetaire waarde is een gemiddelde schatting, omdat deze geen rekening houdt met de belastingen, vergoedingen, gestaffelde prijzen, de vraag of het tijdstip van gebruik.",
    "currencyFactor": "Valuta Conversie Factor",
    "currencyFactorSubtitle": "De energiegegevens worden omgerekend naar hun valuta-equivalent door ze te vermenigvuldigen met de valuta conversiefactor.",
    "currencyNote": "Let op: De gerapporteerde monetaire waarde is een gemiddelde schatting, omdat deze geen rekening houdt met de belastingen, vergoedingen, gestaffelde prijzen, de vraag of het tijdstip van gebruik.",
    "conversionFactor": "Conversie Factor",
    "currencyEquivalentHeader": "Valuta Equivalent",
    "energyImported": "Energie Geïmporteerd",
    "energyExported": "Energie Geëxporteerd",
    "netEnergyImported": "Netto Geïmporteerde Energie",
    "netEnergyExported": "Netto Geëxporteerde Energie",
    "currencyConversionHeader": "Valuta Conversie",
    "confirmationMessage": "Wilt u verdergaan zonder de wijzigingen op te slaan?",
    "confirmationYes": "Ja",
    "confirmationNo": "Nee",
    "invalidInput": "Ongeldige invoer"
  },
  "demo": {
    "appDemo": "App Demo",
    "message": "Dit is een demo-applicatie",
    "enphaseInstaller": "Enphase-installer",
    "mainHeader": "Alles in één slim energiesysteem",
    "subHeader": "Krijg Zonne-Energie en Opslag",
    "getStarted": "Beginnen",
    "appDemoDesc": "Tik om te zien hoe een systeem werkt",
    "loginDesc": "Voor geregistreerde gebruikers",
    "selectLanguage": "Selecteer Taal"
  },
  "connectionBandwidth": {
    "low": "Lage bandbreedte. Rapporteert gegevens om de 6 uur",
    "high": "Standard-bandbreedte. Rapporteert gegevens elke 15 minuten"
  },
  "release_notes": {
    "appUpdateHeading": "Nieuwe update voor uw Enphase-app",
    "appUpdateSuccessHeading": "Uw Enphase-app is bijgewerkt.",
    "later": "Later",
    "updateNow": "Update nu",
    "update": "Update",
    "whatsNew": "Hier is wat er nieuw is",
    "askWhatsNew": "Wat is nieuw?",
    "new": "Nieuw",
    "version": "Versie",
    "readMore": "Lees Meer"
  },
  "storageCapacity": {
    "availableEnergy": "Beschikbare Energie",
    "totalStorage": "Totale Capaciteit",
    "encharge": "IQ Battery",
    "acBattery": "AC Batterij",
    "of": "van",
    "availablePower": "Beschikbaar vermogen",
    "activeMicroinverters": "Actieve Micro-omvormers(s)",
    "activeEncharge": "Actieve batterij(en)",
    "microinverters": "Micro-omvormer(s)"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Upload een site-afbeelding naar keuze",
    "selectImage": "Selecteer Afbeelding",
    "imageSizeError": "*Afbeeldingsgrootte moet kleiner zijn dan 5 MB",
    "hide": "Verbergen",
    "apply": "Toepassen",
    "hideSiteImage": "Site-afbeelding verbergen",
    "hideSiteImageDesc1": "Site-afbeelding wordt niet weergegeven op de statuspagina. U kunt de voorkeur wijzigen door naar Menu -> Systeem -> Sitedetails te gaan.",
    "hideSiteImageDesc2": "Wil je doorgaan?",
    "uploadSuccessToast": "Uw site-image is succesvol bijgewerkt",
    "maxImageLimit": "U kunt maximaal vier afbeeldingen voor uw site uploaden. Verwijder een afbeelding om een ​​nieuwe toe te voegen.",
    "okGotIt": "Oké, ik begrijp het!",
    "imageSIzeErrorSiteDetails": "De afbeeldingsgrootte moet kleiner zijn dan 5 MB. Upload een andere afbeelding.",
    "apiError": "Kan het verzoek niet voltooien. Probeer het later opnieuw",
    "displayOnStatusPage": "Weergave op statuspagina",
    "displayOnStatusPageWarning": "Weet u zeker dat u de afbeelding op de statuspagina wilt bijwerken?",
    "displayOnStatusPageNote": "Opmerking: de afbeelding wordt automatisch aangepast om weer te geven. Je kunt het altijd opnieuw aanpassen op de Statuspagina",
    "deleteSiteImage": "Verwijder afbeelding",
    "deleteSiteImageWarning": "Weet je zeker dat je de afbeelding wilt verwijderen?",
    "imageDeleteSuccess": "Afbeelding is succesvol verwijderd",
    "imageUploadSuccess": "Afbeelding is succesvol geüpload",
    "imageUploadSuccessStatusPage": "Afbeelding succesvol bijgewerkt op statuspagina",
    "displayedOnStatusPage": "Weergegeven op statuspagina",
    "uploadImage": "Afbeelding uploaden",
    "imagePreferenceSaved": "Uw site-afbeeldingsvoorkeur is opgeslagen",
    "siteImage": "Site-afbeelding",
    "statusPageMaxImagePopUpDesc1": "U kunt maximaal vier afbeeldingen voor uw site uploaden. Verwijder een afbeelding van ",
    "statusPageMaxImagePopUpDesc2": " om hier een nieuwe toe te voegen",
    "addSiteImage": "SITE-AFBEELDING TOEVOEGEN",
    "wrongFileType": "Upload alleen een JPEG- of PNG-afbeelding"
  },
  "nps": {
    "question": "Hoe is uw ervaring met ons?",
    "description": "Op basis van uw recente ervaring met Enphase, hoe waarschijnlijk is het dat u Enphase aan een vriend of collega gaat aanbevelen?",
    "dontAskAgain": "Vraag me niet opnieuw",
    "notNow": "Nu niet",
    "notLikely": "Onwaarschijnlijk",
    "mostLikely": "Heel Waarschijnlijk",
    "confirmationHeader": "Bedankt voor uw antwoord! Help ons om uw antwoord beter te begrijpen.",
    "surveyButton": "Doe een enquête van ongeveer 2 minuten",
    "notInterested": "Geen interesse",
    "survey": "Enquête",
    "internetError": "Gelieve uw internetverbinding te controleren en opnieuw te proberen.",
    "rateEnphaseTitle": "Beoordeel Enphase",
    "rateEnphaseDescription": "Hoe waarschijnlijk is het dat u Enphase aan een vriend of collega zult aanbevelen?",
    "rateInstallerTitle": "Beoordeel Uw Installateur",
    "rateInstallerDescription1": "Hoe waarschijnlijk is het dat u",
    "rateInstallerDescription2": "aan een vriend of collega zult aanbevelen?",
    "feedbackSuccess": "Bedankt voor uw waardevolle feedback.",
    "ratingSuccess": "Bedankt voor je feedback.",
    "feedbackEnphaseTitle": "Uw Enphase-beoordeling",
    "feedbackInstallerTitle": "Uw installateursclassificatie",
    "detractors": "Wat kunnen we beter doen?",
    "passive": "Wat kunnen we doen om uw ervaring te verbeteren?",
    "promoters": "Help ons door uw score uit te leggen?",
    "legalDisclaimer": "Uw naam en feedback/commentaar zullen met de installateurs worden gedeeld."
  },
  "liveStatus": {
    "title": "Live Status",
    "subTitle": "Bekijk het vermogen in real-time",
    "offlineMsg": "Use LIVE STATUS when Offline",
    "streamingLocally": "Lokaal vanuit de Gateway streamen",
    "closingMinutes": "Dichterbij",
    "cfgMsg": "Batterijen kunnen worden opgeladen via het elektriciteitsnet omdat u de instelling %{cfglink} heeft ingeschakeld.",
    "learn": "Leren",
    "pvOnlyCta": "%{learn} hoe u uw energieverbruik kunt optimaliseren en volgen met behulp van verbruiksmeting",
    "cfgFiller": "Laad de batterij op via het elektriciteitsnet",
    "cfgVls": "Batterijen kunnen via het net worden opgeladen omdat het niveau van uw batterij lager is dan het uitschakelniveau.",
    "solar": {
      "title": "Zonne-energie",
      "producing": "Geproduceerd",
      "energyProducing": "Energieproductie"
    },
    "home": {
      "title": "Woning",
      "consuming": "Consumptie",
      "energyConsuming": "Energieconsumptie"
    },
    "grid": {
      "title": "Netwerk",
      "gridConnectivity": "Netwerk connectiviteit",
      "waiting": "Esperando información",
      "unknown": "Netwerkstatus onbekend",
      "notAvailable": "Netwerk is niet beschikbaar",
      "systemConnected": "Systeem is op het Rooster",
      "notSystemConnected": "Systeem is niet op het Rooster",
      "outage": "Grid Outage",
      "updating": "Netwerkstatus Updaten",
      "exporting": "Exporteren",
      "importing": "Importeren",
      "notConnected": "Niet Verbonden",
      "offGrid": "UIT Rooster",
      "onGrid": "Netgekoppeld",
      "goOnGrid": "Ga op het Rooster",
      "goOffGridDisabled": "Zonder netwerk niet toegestaan",
      "goOffGrid": "Ga van het Rooster af",
      "gridUpdatingMessage": "De bevestiging van de grid status duurt langer dan verwacht. Gelieve later opnieuw te controleren.",
      "gridConnectedMessage": "uw systeem is nu verbonden met het rooster.",
      "gridDisconnectedMessage": "uw systeem is nu losgekoppeld van het rooster.",
      "disconnectingGrid": "Loskoppelen van het grid...",
      "connectingGrid": "Verbinding maken met grid...",
      "unableToConnect": "Kan geen verbinding maken met de Gateway",
      "initialisingOnGrid": "Initialisatie van de rooster controle...",
      "gridOutage": "Systeem in niet op het net vanwege stroomstoring",
      "gridOutageToastAuto": "U kunt niet op het net gaan vanwege een stroomstoring. Wanneer de stroomvoorziening is hersteld, maakt het systeem opnieuw verbinding met het net",
      "gridOutageToastUser": "U kunt niet op het net gaan vanwege een stroomstoring. U kunt de netaansluiting regelen zodra het elektriciteitsnet beschikbaar is"
    },
    "generator": {
      "title": "Generador",
      "onGenerator": "Generator aan",
      "offGenerator": "Generator uit",
      "unknown": "Generator status onbekend",
      "notConnected": "Niet Verbonden",
      "genDisconnecting": "Disconnecting...",
      "waiting": "Wachten",
      "updating": "Updaten"
    },
    "fuelCell": {
      "title": "Brandstofcel",
      "on": "Brandstofcel aan",
      "off": "Brandstofcel uit",
      "warmingUp": "Brandstofcel opwarmen",
      "coolDown": "Brandstofcel afkoelen",
      "unknown": "Status brandstofcel onbekend",
      "notConnected": "Niet verbonden",
      "genDisconnecting": "Ontkoppelen...",
      "waiting": "Wachten",
      "updating": "Bijwerken"
    },
    "systemNotReporting": {
      "title": "Systeemcontroller rapporteert niet",
      "subTitle": "We kunnen de live gegevens niet weergeven omdat uw systeemcontroller niet rapporteert aan de gateway. Dit kan een tijdelijke storing zijn en zou snel moeten zijn opgelost."
    },
    "envoy": {
      "connecting": "Bezig met verbinden met de Gateway...",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "Niet in staat om verbinding te maken",
      "notAbleToConnectMultiEnv": "Kan geen verbinding maken met gateway SN:",
      "negativeConsumptionTitle": "Communicatiefout",
      "negativeConsumptionDesc": "We kunnen de volledige live status niet tonen vanwege communicatieverlies tussen uw apparaten. Dit is een tijdelijke fout die snel hersteld zal worden"
    },
    "onDifferentNetwork": "Uw Gateway en dit apparaat zitten op verschillende netwerken",
    "connectOnSameNetworkorAPMode": "Verbind uw Gateway en apparaat met hetzelfde netwerk of schakel de AP-modus op uw Gateway in om dit apparaat te verbinden met het Wi-Fi-netwerk %{ssid}",
    "connectOnSameNetwork": "Verbind dit toestel met het Wi-Fi-netwerk %{ssid} en probeer opnieuw om de live status in offlinemodus te bekijken.",
    "apModeTutorial": "Ap-modus instructies",
    "apMT1": "De AP-modusknop indrukken en loslaten ",
    "apMT2": "Ap-modusknop",
    "apMT3": " tot de AP-modus LED (",
    "apMT4": ") continu groen brandt. De Gateway blijft acht uur lang in AP-modus."
  },
  "desktop": {
    "status": {
      "power": "Vermogen",
      "energy": "Energie",
      "solarEquivalent": "Zonne-energie equivalent",
      "dataUnavailable": "Data is niet beschikbaar"
    },
    "array": {
      "title": "Reeks",
      "totalProduced": "Totaal Geproduceerd",
      "totalConsumed": "Totaal Gebruikt",
      "lifetimeProduced": "Geproduceerd Over Levensduur",
      "lifetimeConsumed": "Consumptie Over Levensduur",
      "status": "Status",
      "azimuth": "Azimuth",
      "tilt": "Helling",
      "microinverter": "Micro-omvormer"
    },
    "energy": {
      "totalEnergy": "Totaal Energie",
      "graphControls": "Grafiek Besturing"
    },
    "header": {
      "switchToClassic": "Ga naar het klassieke overzicht"
    },
    "footer": {
      "change": "Wijzigen",
      "changeSite": "Wijzig site",
      "copyRightsText": "©2008-%{currYear} Enphase Energy Inc. Alle rechten voorbehouden.",
      "privacyText": "Privacy",
      "termsText": "Termen",
      "weatherCompany": "The Weather Company",
      "weatherDataText": "Weergegevens verstrekt door"
    }
  },
  "customPeriod": {
    "dialogLabel": "Overzicht Op Basis Van",
    "billingCycle": "Factureringscyclus",
    "billingLabel": "Vergelijk de energiegrafiek met uw factureringscyclus",
    "billingLabelStatusPage": "Tijdsperiode vanaf een geselecteerde begindatum voor de geselecteerde duur",
    "startDate": "Facturering Startdatum",
    "frequency": "Facturering Frequentie",
    "months": "Maanden",
    "days": "Dagen",
    "every": "Elke",
    "customDate": "Aangepast Datumbereik",
    "customDateLabel": "Selecteer een aangepast datumbereik om het te bekijken op de energiegrafiek",
    "customRange": "Gelieve een databereik tussen 1 en 100 dagen te selecteren"
  },
  "systemEstimator": {
    "heading": "Systeemschatter",
    "exitConfirmation": "Weet u zeker dat u de stroom Opslag toevoegen wilt sluiten?",
    "resumeButton": "Hervat",
    "systemAccess": "Krijg systeemtoegang",
    "statusAddStorage": "to avoid blackouts",
    "addStorageLeadInfo": "bekijk de status",
    "postLoginWoSiteTitle": "Maak kennis met het enige alles-in-één zonne- en opslagsysteem",
    "videoCTABtn": "Bekijk de video",
    "addStorageTitle": "Koop een nieuw Enphase-systeem",
    "orderNowBtn": "Bestel nu"
  },
  "sgipIncentive": {
    "gotItButton": "Begrepen",
    "exitButton": "Afsluiten",
    "dontExitButton": "Niet afsluiten",
    "sgipPaymentNotDone": "Uw SGIP-applicatie is onvolledig. Wilt u vertrekken zonder uw aanvraag in te vullen?",
    "sgipPaymentDone": "U kunt op elk moment terugkomen om de status van uw SGIP-applicatie te controleren.",
    "sgipApplyAlert": "SGIP-stimuli gelden alleen voor systemen die in Californië worden geïnstalleerd. Als u al een systeemactivering in uitvoering hebt in Californië, vraag uw installateur dan om het 'site creation proces' in hun Enphase-applicatie te starten.",
    "sgipGetStorage": "Schaf een nieuw Enphase-opslagsysteem aan"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "Rasterstatus gewijzigd in",
    "gridOn": "On Grid",
    "gridOff": "Off Grid",
    "batteryChangeDesc": "Batterijprofiel gewijzigd in",
    "costSavings": "Kostenbesparingen",
    "selfConsumption": "Eigen verbruik",
    "savingsMode": "Spaarmodus",
    "backupOnly": "Alleen back-up",
    "stormGuardDesc": "Stormbewaking is",
    "alertIssued": " alarm uitgegeven",
    "alertHasEnded": " alarm is beëindigd"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normaal",
    "unknown": "Onbekend",
    "undefined": "Ongedefinieerd",
    "loads": "Laadregeling",
    "loadsInfoPart1": "De ladingen worden in kaart gebracht bij ",
    "loadsInfoPart2": "Hulpcontacten van systeemcontroller",
    "loadsInfoPart3": " door uw installateur. U kunt deze ladingen configureren bij uw ",
    "loadsInfoPart4": "Systeeminstellingen.",
    "powered": "Aangedreven",
    "invalidState": "Ongeldige staat",
    "viewMore": "Bekijk meer",
    "viewLess": "Bekijk minder",
    "ECA_BAT_IDLE": "Inactief",
    "ECA_BAT_CHARGING": "Opladen",
    "ECA_BAT_DISCHARGING": "Uitvoering",
    "MAX_ECA_BAT_STATE": "Onbekend",
    "systemIsOnGrid": "Systeem is op het Rooster",
    "systemIsOffGrid": "Systeem is niet op het Rooster",
    "infoIsOnGrid": "Het systeem werkt in de rooster gekoppelde modus.",
    "infoIsOffGrid": "Het systeem werkt in microrooster modus.",
    "wiredCANConn": "Bedrade CAN-verbinding",
    "infoWiredCAN": "De IQ Systeemcontroller communiceert via een bekabelde verbinding met de IQ gateway. Het pictogram geeft aan of deze al dan niet is verbonden en communiceert met de gateway.",
    "infoIsOffGridAvailable": "Het systeem werkt in microrooster modus. Het rooster is echter wel beschikbaar en u kunt er altijd voor kiezen om op het rooster te gaan.",
    "voltageL1": {
      "val": "Spanning L1",
      "info": "De spanning tussen lijn 1 (L1) en de nulgeleider."
    },
    "voltageL2": {
      "val": "Spanning L2",
      "info": "De spanning tussen lijn 2 (L2) en de nulgeleider."
    },
    "voltageL3": {
      "val": "Spanning L3",
      "info": "De spanning tussen lijn 3 (L3) en de nulgeleider."
    },
    "voltage": {
      "val": "Spanning",
      "info": "De spanning tussen lijn 1 (L1) en de nulgeleider."
    },
    "frequency": {
      "val": "Frequentie",
      "info": "De nominale wisselstroom (AC) frequentie."
    },
    "gridParameters": "Parameters van het nutsbedrijf rooster",
    "auxiliaryContactsParameters": "Laadregeling",
    "infoauxiliaryContactsParam": "De systeemcontroller beschikt over vier hulpcontacten voor controle van de belasting. De naam van de belasting geeft aan dat het corresponderende contact is toegewezen aan die belasting. Voor de contacten die niet zijn toegewezen aan een lading wordt 'Niet in gebruik' weergegeven.",
    "infoGridParam": "Netspanning en frequentie worden gemeten aan de netzijde van het Microgrid Interconnect Device (MID). Wanneer het net niet beschikbaar is, is de netspanning en -frequentie 0.",
    "microgridParameters": "Microrooster parameters",
    "infoMicrogridParam": "Microrooster spanning en frequentie worden gemeten aan de laadzijde van het Microgrid Interconnect Device (MID). Als uw MID geopend is, staat uw systeem in de modus Buiten het rooster / Micro rooster.",
    "generatorParameters": "Generator Parameters",
    "infoGeneratorParam": "Microrooster spanning en frequentie worden gemeten aan de laadzijde van het Generator Interconnect Device (GID). Als uw GID gesloten is, staat uw systeem in de modus Buiten het rooster / Micro rooster.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Communicatie Signaal",
    "infoZigbeeSignal": "Stelt de sterkte van de 2,4 Ghz draadloze communicatie met de Gateway voor. Meer balkjes of een hogere dBm-waarde duiden op een sterker signaal.",
    "commStatus": "Communicatiestatus",
    "infoCommSignal": "COMMUNICATIESIGNAAL",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "IQ System Controller communiceert met IQ Gateway via USB-verbinding. Het pictogram laat zien of de USB wel of niet verbonden is en communiceert met IQ Gateway.",
    "commStatusDesc": "IQ Battery communiceert met IQ System Controller via een bedrade verbinding. Het pictogram geeft aan of IQ Battery is verbonden en communiceert met IQ System Controller.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Onbekend"
    },
    "ENCMN_STATE_MISSING": {
      "val": "2,4 GHz communicatiestoring"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "2.4 GHz pairing"
    },
    "ENCMN_STATE_CONNECTED": {
      "val": "2,4 GHz koppeling compleet"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Klaar met het ophalen apparaat informatie"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "Wachten op batterijen om de netstatus te bevestigen"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Systeemcontroller de opdracht geven om EC1-relais te sluiten"
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Onbekend"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "Starten met roosterprofiel update"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Rooster profiel update in uitvoering"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Rooster profiel update voltooid"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Relaisstatus van systeemcontroller ophalen na initialisatie"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Relaisstatus van systeemcontroller interpreteren"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "Systeemcontroller is niet aangesloten op het net."
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "Systeemcontroller is niet aangesloten op het net. Net is beschikbaar"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "Het microrooster is gesynchroniseerd met het rooster. Klaar om op het rooster te gaan"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "Systeemcontroller is aangesloten op het net"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Systeemcontroller de opdracht geven om aan te sluiten op het net"
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "Voorbereiden van de uitvoering van het commando van de gebruiker om van het net af te gaan"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Systeemcontroller de opdracht geven om los te koppelen van het net"
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "Systeemcontroller is op het net. Batterijen ontdekken."
    },
    "ENCMN_STATE_MAX": {
      "val": "Onbekend"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "No micros detected"
    },
    "ENCHG_STATE_READY": {
      "val": "Batterij is operationeel"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Netmodus versturen naar de batterij"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Bijwerken van de reserve State of Charge (SoC) limiet op de batterij"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "Starten met roosterprofiel update"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Rooster profiel update in uitvoering"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Rooster profiel update voltooid"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Ophalen van de hardware- en software-informatie van de batterij"
    },
    "ST_NOP": {
      "val": "Onbekend"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "Systeemcontroller is niet aangesloten op het net. Verbinding maken met generator."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "Systeemcontroller is niet aangesloten op het net. Verbonden met generator."
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "Systeemcontroller is niet aangesloten op het net. Verbinding met generator verbreken."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "EC1 gesloten. Relaistest compleet"
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "EC1 open. Relaistest bezig"
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "GEN-relais gesloten. Relaistest compleet"
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "GEN-relais open. Relaistest bezig"
    },
    "default": {
      "val": "Onbekend"
    },
    "controlState": "Controlestaten",
    "CHECK_BUSES": {
      "val": "Het controleren van bussen en relais",
      "info": "De systeemcontroller is opnieuw ingesteld. Validatie van systeemparameters voor de overgang naar een andere status van het net."
    },
    "CYCLE_RELAYS": {
      "val": "Cyclische relais",
      "info": "Uw systeem doorloopt de verschillende relais van de systeemcontroller om te controleren of de storingen in de relais zijn opgeheven."
    },
    "GRID_CONNECT": {
      "val": "Verbinding maken met Rooster",
      "info": "Uw systeem maakt opnieuw verbinding met het net nadat de systeemcontroller opnieuw is ingesteld."
    },
    "EC1_EC2_CONNECT": {
      "val": "Verbonden met batterijen. NFT verbinden",
      "info": "Uw systeem gaat over naar microgrid. Verbonden met batterijen. De Neutral Forming Transformer (NFT) wordt verbonden."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "Aangesloten op het net. Bezig met verbinden met batterijen",
      "info": "Uw systeem is aangesloten op het net. Batterijen worden nu aangesloten."
    },
    "GRID_OP_FULL": {
      "val": "Netgekoppeld.",
      "info": "Uw systeem werkt in de rooster gekoppelde modus."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Buiten Rooster.",
      "info": "Uw systeem werkt in de microrooster modus."
    },
    "SYNC_TO_GRID": {
      "val": "Synchroniseren met het net",
      "info": "Uw systeem gaat over van microrooster naar op rooster."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Microrooster storing",
      "info": "Het microrooster is ingestort door overbelasting of een systeemfout. Het systeem zal zich snel herstellen."
    },
    "MANUFACTURING_MODE": {
      "val": "Productiemodus",
      "info": "Neem contact op met de klantenservice."
    },
    "RESET": {
      "val": "Systeemcontroller opnieuw ingesteld",
      "info": "Uw systeemcontroller is opnieuw ingesteld. Het systeem zal snel herstellen."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "Op Rooster. NFT openen",
      "info": "Uw systeem is op het Rooster. De Nullasttransformator (NFT) wordt losgekoppeld."
    },
    "MANUAL_OVERRIDE": {
      "val": "Handmatig overschrijven geactiveerd",
      "info": "U heeft het microrooster interconnect device (MID) handmatig gesloten om op het rooster te gaan. Bel de klantenservice als u dit niet met opzet heeft gedaan."
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Onbekend",
      "info": "Neem contact op met de klantenservice."
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Synchronisatie en aansluiting op het rooster"
    },
    "infoControlState": "Controlestaten",
    "faults": "Storing in de systeemcontroller",
    "MID_FUSED": "Uw systeem kan niet overgaan naar de microrooster modus omdat de MID vastzit.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "Neutrale vervormingstransformator (NFT) relais zijn dicht geklemd.",
    "NFT_OPEN": "Uw systeem kan niet overgaan naar de microrooster modus omdat de neutrale vervormingstransformator (NFT)-relais open blijven hangen.",
    "MID_OPEN": "Uw systeem kan niet overgaan naar de rooster verbonden modus omdat de MID open blijft hangen.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Uw systeem is niet operationeel. Het ATS-board (Automatic Transfer Switch) van de systeemcontroller is defect.",
    "ADC_INIT": "Uw systeem is niet operationeel. Het ATS-board (Automatic Transfer Switch) van de systeemcontroller is defect.",
    "I2C_COMM": "Uw systeem is niet operationeel. Het ATS-board (Automatic Transfer Switch) van de systeemcontroller is defect.",
    "NFT_TEMP": "Uw systeem is niet operationeel. De NFT (Neutral Forming Transformer) van de systeemcontroller heeft de temperatuurlimieten overschreden.",
    "ATS_TEMP": "Uw systeem is niet operationeel. Het ATS-board (Automatische transferschakelaar) van de systeemcontroller heeft de temperatuurlimieten overschreden.",
    "E3_TEMP": "Uw systeem is niet operationeel. Het bord van de systeemcontroller heeft de temperatuurlimieten overschreden.",
    "CRC_MISMATCH": "Uw systeem is niet operationeel. Het bord van de systeemcontroller kon niet worden geïnitialiseerd.",
    "V_IMBALANCE": "Uw systeem kan niet overgaan naar de microrooster modus. Een Spanningsonevenwicht tussen L1 en L2 heeft een storing veroorzaakt.",
    "MANUAL_OVR": "Uw systeem staat in de netgekoppelde modus vanwege de handmatige omschakeling van de systeemcontroller.",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "Microgrid Interconnect Device (MID) verbindt (wanneer gesloten) of ontkoppelt (wanneer open) uw huis van het elektriciteitsnet."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Distributed Energy Resource (DER)-relais DER L1 sluit indien gesloten uw Encharges en PV op lijn 1 of 2 aan respectievelijk voor uw woning"
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "EC1_L1": {
      "val": "EC1 L1",
      "info": "Relais EC1 L1 en L2 in gesloten positie verbinden uw batterijen of IQ8 PV naar uw verbruikers in huis. Ze werken lijn aan lijn en hebben geen neutrale positie."
    },
    "EC1_L2": {
      "val": "EC1 L2"
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "IQ Battery L1 en L2 relais sluiten, wanneer gesloten, uw batterijen aan op uw thuisbelastingen. Ze werken van lijn tot lijn en hebben geen neutraal."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "PV L1- en L2-relais verbinden, indien gesloten, uw IQ8 PV met uw belastingen thuis. Deze functioneren lijn voor lijn en hebben geen neutraal."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "PV L1- en L2-relais verbinden, indien gesloten, uw IQ PV met uw belastingen thuis. Deze functioneren lijn voor lijn en hebben geen neutraal."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "NFT L1",
      "info": "NFT is de Neutrale Vormende Transformator. Het zorgt ervoor dat uw systeem kan werken in een buiten rooster modus. Het NFT L1 relais wanneer gesloten start uw NFT op. Het NFT N-relais wanneer het gesloten is, verbindt de nulleider van NFT met uw huisladingen."
    },
    "NFT_N": {
      "val": "NFT N"
    },
    "GID_L1": {
      "val": "GID L1",
      "info": "Als het GID L1 en L2 relais gesloten is, wordt uw Generator aangesloten op de lading van uw huis."
    },
    "GID_L2": {
      "val": "GID L2"
    },
    "NFT_L2": {
      "val": "NFT L2",
      "info": "NFT is de Neutrale Vormende Transformator. Het zorgt ervoor dat uw systeem kan werken in een buiten rooster modus. Het NFT L2 relais wanneer gesloten start uw NFT op. Het NFT N-relais wanneer het gesloten is, verbindt de nulleider van NFT met uw huisladingen."
    },
    "DER1_L1": {
      "val": "DER1 L1",
      "info": "Relais DER1 L1 en L2 in gesloten positie verbinden uw batterijen of IQ8 PV naar uw verbruikers in huis. Ze werken lijn aan lijn en hebben geen neutrale positie."
    },
    "DER1_L2": {
      "val": "DER1 L2"
    },
    "DER2_L1": {
      "val": "DER2 L1",
      "info": "DER2 L1 en L2 relais, indien gesloten, verbindt uw IQ8 PV met de lading van uw huis. Zij werken lijn aan lijn en hebben geen nulleider."
    },
    "DER2_L2": {
      "val": "DER2 L2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "Indien gesloten sluiten deze relais uw ladingen aan op de stroombron"
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "Distributed Energy Resource (DER) relais DER L1, DER L2, DER L3 en DER N, wanneer gesloten, verbinden uw IQ-batterij en IQ-micro-omvormer op lijn 1, 2, 3 en neutraal respectievelijk met uw huis."
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "Distributed Energy Resource (DER) relais DER L1, DER L2 en DER N, wanneer gesloten, verbinden uw IQ-batterij en IQ-micro-omvormer op lijn 1, 2 en neutraal respectievelijk met uw huis."
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "Distributed Energy Resource (DER) relais DER L1 en DER N wanneer gesloten, verbinden uw IQ-batterij en IQ-micro-omvormer respectievelijk online en neutraal met uw huis"
    },
    "open": "Open",
    "closed": "Gesloten"
  }, _defineProperty(_liveVitalStats, "powered", "Aangedreven"), _defineProperty(_liveVitalStats, "notPowered", "Niet Aangedreven"), _defineProperty(_liveVitalStats, "niu", "Niet in gebruik"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "EC1 L1, L2"), _defineProperty(_liveVitalStats, "infoNftL1N", "NFT L1, N"), _defineProperty(_liveVitalStats, "infoGidL1L2", "GID L1, L2"), _defineProperty(_liveVitalStats, "infoNftL2N", "NFT L2, N"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "DER1 L1, L2"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "DER2 L1, L2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "Het verschil tussen de netspanning en de frequentie van het micro rooster wordt waargenomen door de spanningsval over het Microgrid Interconnect Device (MID)."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "Het blokdiagram van de systeemcontroller is alleen ter illustratie."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "Relais van systeemcontroller"), _defineProperty(_liveVitalStats, "bmuWarning", "BMU Waarschuwing"), _defineProperty(_liveVitalStats, "bmuL1Error", "BMU niveau 1 fout"), _defineProperty(_liveVitalStats, "bmuL2Error", "BMU niveau 2 fout"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Batterijcel spanning maximum waarschuwing"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Batterijcel spanning minimum waarschuwing"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Batterijcel spanning onevenwichtigheid waarschuwing"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Batterij FET-schakelaar over spanning waarschuwing"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Batterijcel spanning maximum fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Batterijcel spanning minimum fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Batterijcel temperatuur maximum fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Batterijcel temperatuur minimum fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Ontlading over het stroom fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "Geen BMU communicatie."), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Veldeffect transistor stroom fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Zekering open fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Veldeffect transistor driver fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Spanning Sense lijn open fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Veldeffect transistor temperatuur fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Thermische lijn open fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Voorlading 24V-circuit fout niveau 1"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Fout in batterijcel spanning voorladen Niveau"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Batterijcel spanning maximum fout niveau 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Batterijcel spanning minimum fout niveau 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Batterijcel temperatuur maximum fout niveau 2"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Batterijcel temperatuur minimum fout niveau 2"), _defineProperty(_liveVitalStats, "gridMode", "Rooster Modus"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Rooster gebonden",
    "info": "Batterij is in modus 'Verbonden met net'. In deze tijdelijke toestand zal het geen microgrid vormen wanneer het net niet beschikbaar is.",
    "pcuInfo": "Micro-omvormer is in de netgekoppelde modus. Het zal geen microrooster vormen wanneer het rooster niet beschikbaar is."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "Netgekoppeld.",
    "info": "De batterij staat in de netgekoppelde modus en is in staat een microgrid te vormen wanneer dat nodig is.",
    "pcuInfo": "Micro-omvormer is in de netgekoppelde modus en is in staat om een microrooster te vormen wanneer het nodig is."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Buiten Rooster.",
    "info": "De batterij heeft een microgrid gevormd.",
    "pcuInfo": "Micro-omvormer heeft een microrooster gevormd."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Eiland gedetecteerd",
    "info": "Batterij heeft gedetecteerd dat het net onstabiel of niet beschikbaar is. Deze is bezig om een microgrid te vormen.",
    "pcuInfo": "Micro-omvormer heeft gedetecteerd dat het rooster onstabiel / niet beschikbaar is. Het is bezig met de vorming van het microrooster."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "Microrooster vormen",
    "info": "Batterij is net opnieuw opgestart. Deze heeft gedetecteerd dat het net niet beschikbaar is en is bezig om een microgrid te vormen. Het verminderen van de belasting van verbruikers in huis helpt bij het vormen van een microgrid.",
    "pcuInfo": "Micro-omvormer is net opnieuw opgestart. Het heeft gedetecteerd dat het elektriciteitsnet niet beschikbaar is en is bezig met de vorming van het microrooster. Het verminderen van de thuisbelasting helpt bij de vorming van een microrooster."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Ongeldig",
    "info": "Ongeldige gridmodus ontvangen voor batterij.",
    "pcuInfo": "Ongeldige rooster modus ontvangen voor Micro-omvormer."
  }), _defineProperty(_liveVitalStats, "infoGridModes", "Rooster Modus"), _defineProperty(_liveVitalStats, "ledStatus", "LED Status"), _defineProperty(_liveVitalStats, "phase", "Fase"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "In elke batterij zitten %{pcuLength} IQ8X-BAT-micro-omvormers."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "Een positieve waarde voor het micro-omvormer vermogen (kW) geeft aan dat de accu ontlaadt, terwijl een negatieve waarde voor het vermogen (kW) aangeeft dat de accu wordt opgeladen."), _defineProperty(_liveVitalStats, "infoPcuMicro", "IQ8X-BAT Micro-omvormers"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "IQ8D-BAT Micro-omvormers"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "In elke batterij zitten %{pcuLength} IQ8D-BAT microinverters."), _defineProperty(_liveVitalStats, "pcu", "Micro"), _defineProperty(_liveVitalStats, "enph_oper_state", "Provincie"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Inactief"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "Starten"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Ontdekking via stroomlijn communicatie (PLC) in uitvoering."
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normaal"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normaal (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normaal (barsten)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Werken in constante DC-spanning modus"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normaal (stand-by)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Uitschakelen (beveiligingsfout)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Uitschakelen (rooster fout)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normaal (DCR check)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Onbekend"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Firmware fout"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Uitgeschakeld (host stopzetting)"
  }), _defineProperty(_liveVitalStats, "ac_power", "AC-vermogen"), _defineProperty(_liveVitalStats, "signalStrength", "Signaalsterkte"), _defineProperty(_liveVitalStats, "commOk", "Communicatie Oké"), _defineProperty(_liveVitalStats, "noComm", "Geen communicatie"), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normaal"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Onbekend"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "LED Status",
    "code": {
      "-1": "Onbekend",
      "0": "Fout Vereist Service",
      "1": "BMU L1 Fout",
      "2": "Hoge Temperatuur",
      "3": "DC-schakelaar UIT",
      "4": "Geen communicatie met de Gateway",
      "5": "Communicatie Aangesloten maar niet uitgedaagd",
      "6": "Communicatie aangesloten en uitgedaagd",
      "7": "Upgrade mislukt",
      "8": "BC Update in Uitvoering",
      "9": "BMU Update in Uitvoering",
      "10": "PCU update in Uitvoering",
      "11": "Slaapstand",
      "12": "Opladen",
      "13": "Uitvoering",
      "14": "De capaciteit van de batterij is tussen: 75-100%",
      "15": "De capaciteit van de batterij is tussen: 50-75%",
      "16": "De capaciteit van de batterij is tussen: 25-50%",
      "17": "De capaciteit van de batterij is tussen: 0-25%",
      "18": "Systeem AAN"
    },
    "enpowerRow": {
      "code": {
        "-1": "Onbekend",
        "0": "Systeemcontroller fout (op het net)",
        "1": "Systeemcontroller fout (niet op het net)",
        "2": "Systeemcontroller bevindt zich in de modus voor snelle uitschakeling/handmatige opheffing",
        "3": "Systeemcontroller niet op het net; DER's niet verbonden",
        "4": "Systeemcontroller operationeel, kan geen IQ Batteries detecteren via CAN (op het net)",
        "5": "Systeemcontroller operationeel, kan niet minstens één IQ Battery detecteren via CAN (op het net)",
        "6": "Systeemcontroller operationeel, kan niet minstens één IQ Battery detecteren via CAN (niet op het net)",
        "7": "Systeemcontroller niet op het net: SoC herstel uitvoeren",
        "8": "Systeemcontroller wordt gesynchroniseerd met het net",
        "9": "Systeemcontroller FW upgrade (op het net)",
        "10": "Systeemcontroller FW upgrade (niet op het net)",
        "11": "Systeemcontroller AAN, wordt opgestart",
        "12": "Systeemcontroller AAN en op het net",
        "13": "Systeemcontroller AAN en niet op het net",
        "14": "Systeemcontroller UIT"
      }
    },
    "info": {
      "safetyIssue": "Geen van de LED statussen stelt een veiligheidskwestie aan de orde",
      "title": {
        "flashingRed": "Rood Knipperend",
        "flashingYellow": "Geel Knipperend",
        "softPulseYellow": "Zacht Geel Pulserend",
        "softPulseBlue": "Zacht Blauw Pulserend",
        "softPulseGreen": "Zacht Groen Pulserend",
        "solidRed": "Effen Rood",
        "solidYellow": "Effen Geel",
        "solidBlueOrGreen": "Effen Blauw of Groen",
        "ledOff": "Uit"
      },
      "desc": {
        "flashingRed": "Update mislukt of batterij is in storing. Neem contact op met uw installateur of met de Enphase-ondersteuning.",
        "flashingYellow": "Update in uitvoering.",
        "softPulseYellow": "Slaapstand geactiveerd.",
        "softPulseBlue": "Ontladen.",
        "softPulseGreen": "Opladen.",
        "solidRed": "Opstarten.",
        "solidYellow": "Niet in werking door hoge temperatuur. Zie \"IQ Battery problemen oplossen\" A voor meer informatie.",
        "solidBlueOrGreen": "Inactief. Kleurovergangen tussen blauw en groen naarmate de laadstatus verandert. De oplaadstatus is bijgewerkt in de Enphase app. Zie \"IQ Battery problemen oplossen\" C voor meer informatie.",
        "ledOff": "Niet in werking. Zie \"IQ Battery problemen oplossen\" B voor meer informatie."
      }
    }
  },
  "updatePending": {
    "title": "Het uploaden van gegevens is aan de gang",
    "content": "Uw gateway is bezig met het uploaden van uw systeem gegevens naar de Enphase cloud. Dit gebeurt als de gateway enige tijd offline is geweest. Meestal duurt het 1 uur voor elke dag dat de gateway offline is. Maakt u zich geen zorgen, het bericht zal verdwijnen zodra alle gegevens geüpload zijn.",
    "envoyDataTitle": "Gegevens uploaden",
    "envoyDataContent": "Uw systeem heeft onlangs opnieuw verbinding met internet gemaakt en het duurt even voordat uw gegevens zijn gedownload. Het kan tot een uur duren voor elke dag dat het offline was."
  },
  "bkpConfig": {
    "title": "Back-up Configuratie",
    "0": "Niet geselecteerd",
    "1": "Gedeeltelijke thuisback-up",
    "2": "Volledige thuisback-up"
  },
  "set": "Selecteer",
  "change": "Verandering",
  "allTopics": "Alle onderwerpen",
  "referFriends": {
    "title": "Verwijs een vriend",
    "subTitle_1": "Ontvang een voucher van ",
    "subTitle_2": " én geef er een cadeau ",
    "description_1": "Zowel u als uw vriend of kennis maken aanspraak op een Amazon cadeaubon t.w.v. ",
    "description_2": " indien uw vriend een Enphase zonne-energieopslagsysteem aanschaft en activeert na registratie via de onderstaande link. ",
    "description_3": " indien uw vriend een Enphase zonne-energiesysteem aanschaft en activeert na registratie via de onderstaande link. ",
    "urlHeading": "Uw verwijslink",
    "shareButton": "Deel uw verwijzingslink",
    "copyButton": "Kopiëer uw verwijslink ",
    "termsConditions": "Algemene Voorwaarden",
    "applyTerms": "zijn van toepassing.",
    "toastMessage": "Verwijzingslink gekopieerd naar uw klembord",
    "shareMessage_1": "Hi! Ik heb een nieuw zonnepanelensysteem! Denk jij er ook over na om de overstap naar solar te maken? Ik heb een exclusieve verwijslink die je kunt gebruiken om een Amazon voucher t.w.v. ",
    "shareMessage_2": " te ontvangen bij installatie van een Enphase systeem. Let op: er dient minstens 15 dagen tussen registratie en installatie te zitten.",
    "shareMessageAU_1": "Hey! Getting Enphase solar for my home is one the best investments I've made so I'm sharing the sunshine. If you’re considering ways to lower your electricity bills and protect your pocket, I have a referral link that you can use to receive ",
    "shareMessageAU_2": " when you go solar with Enphase. Check it out:",
    "tncTitle": "Algemene voorwaarden van het Verwijzingsprogramma:",
    "important_title": "Belangrijk",
    "important_subtitle": "u en uw vriend komen alleen in aanmerking voor de voucher indien:",
    "important_1": "Er minstens 15 dagen tussen voltooide registratie en installatie zit. Z.s.m. registreren wordt aangeraden.",
    "important_2": "Het e-mailadres waarmee de verwijzing is ontvangen of geregistreerd wordt gebruikt voor de systeemactivatie.",
    "tnc": {
      "1": "Limiet van 30 verwijzingen per klant.",
      "2": "Verwijzingen moeten de door u gedeelde link gebruiken en op of voor 31 december 2022 via de aangewezen Enphase website hun contactgegevens aan Enphase verstrekken.",
      "3": "Als Enphase of haar installateurs al beschikken over de door de Verwijzing verstrekte e-mail-ID, komt uw Verwijzing niet in aanmerking voor deelname aan dit Verwijzingsprogramma.",
      "4": "U en uw verwijzing komen alleen in aanmerking voor het ontvangen van de cadeaubonnen als uw verwijzing hun Enphase productactivering installeert en voltooit binnen 2 jaar nadat Enphase de informatie van de verwijzing heeft ontvangen op de Enphase site.",
      "5": "Na ontvangst van de kennisgeving van Enphase dat u en uw Verwijzing in aanmerking komen voor de Cadeaukaart, dient u de Cadeaukaart binnen 90 dagen na ontvangst van deze kennisgeving te claimen.",
      "6_One": "Als er geen ",
      "6_Two": " Cadeaukaarten beschikbaar zijn, kan Enphase een andere prijs van gelijke of grotere waarde vervangen.",
      "7": "Het geselecteerde cadeaukaart bedrag geeft een schatting weer van de waarde van de verwijzing ten opzichte van de marketinguitgaven die worden bespaard bij de werving van nieuwe klanten.",
      "8": "Als u of uw Verwijzer zich wil terugtrekken uit het Verwijsprogramma of de beloning voor de Cadeaukaart wil ontvangen, neem dan contact op met de Enphase",
      "9": "Enphase is niet verantwoordelijk voor onleesbare, onjuiste, onvolledige of vertraagde inzendingen, noch voor typografische fouten, problemen bij het uploaden of downloaden van de Verwijzingsinformatie, of voor andere technische storingen van netwerken, het internet, elektronische apparatuur of websites.",
      "10": "Enphase behoudt zich het recht voor om dit Verwijzingsprogramma zonder voorafgaande kennisgeving te wijzigen, op te schorten of te beëindigen.",
      "11": "Dit verwijzingsprogramma is ongeldig waar het verboden is.",
      "12": "Opdat Enphase een verwijzing kan toekennen, moet de unieke link zowel door u als door uw verwijzing worden gebruikt.",
      "13": "Er dient minstens 15 dagen tussen voltooide registratie via de link en de installatie van uw zonnepanelensysteem te zitten.",
      "14": "Het e-mailadres waarmee u de registratie heeft voltooid dient te worden gebruikt voor de activatie van uw systeem."
    }
  },
  "contactPVMaintainer": "Neem contact op met zonne-energie onderhoudsmonteur",
  "contactStorageMaintainer": "Neem contact op met de beheerder van de opslagruimte",
  "pvInstallerDetails": "Details van de zonne-energie installateur",
  "storageInstallerDetails": "Opslag installateur details",
  "customerSupport": "klantenondersteuning",
  "soFarToday": "Tot zover vandaag,",
  "forSelectedPeriod": "Voor de geselecteerde periode,",
  "energyIndependence": {
    "title": "Energie Onafhankelijkheid",
    "subTitle": "Meet uw onafhankelijkheid van het netwerk van de elektriciteitsleverancier",
    "formulaText": "Berekening energieonafhankelijkheid:",
    "formula": "[1-(Imported/Consumed)] * 100%",
    "formulaForGenerator": "[1 - {(Geïmporteerd raster + Geïmporteerd uit generator) / Verbruikt}] * 100%",
    "desc1": "Energie-onafhankelijkheid is een maatstaf voor energiezelfvoorziening. Dit betekent dat u zelf in al uw energiebehoeften kunt voorzien.",
    "unknown": "het is onbekend omdat uw systeem geen verbruiksgegevens heeft gerapporteerd.",
    "0": "al uw energieverbruik wordt geleverd door een externe bron zoals het elektriciteitsnetwerk. Dit betekent uw score voor energie-onafhankelijkheid voor %{periodValue} %{eiValue}%.",
    "100": "niets van uw energieverbruik wordt geleverd door een externe bron zoals het elektriciteitsnetwerk. Dit betekent uw score voor energie-onafhankelijkheid voor %{periodValue} %{eiValue}%.",
    "value": "%{geValue}% van uw energieverbruik wordt geleverd door een externe bron zoals het elektriciteitsnetwerk. Dit betekent uw score voor energieonafhankelijkheid voor %{periodValue} %{eiValue}%.",
    "forTodayPeriod": "vandaag is",
    "forSelectedPeriod": "de geselecteerde periode is",
    "addStorageTitle": "Voeg opslag toe",
    "addStorage": "om uw Energie Onafhankelijkheid te verhogen.",
    "addStorageTitleWB": "Zonne-energie of opslag toevoegen",
    "addStorageWB": "verhoogt uw Energie Onafhankelijkheid.",
    "clarify": "Energie-onafhankelijkheid omvat geen geëxporteerde energie en moet niet worden verward met Net Metering (of Net Energy), wat het verschil is tussen geïmporteerde en geëxporteerde energie"
  },
  "backupHistory": {
    "backupEvents": "Totale Back-up Gebeurtenissen"
  },
  "eventHistory": {
    "totalEvents": "Totale Gebeurtenissen",
    "events": "Item/Gebeurtenis",
    "deviceImpacted": "Apparaat Beïnvloed",
    "recommendedAction": "Aanbevolen Actie",
    "noBackupHistoryFound": "Geen back-up geschiedenis gevonden",
    "eventStatus": "Evenement status"
  },
  "siteActivationStage": {
    "title": " heeft de activering van uw Enphase-systeem gestart, ",
    "learnToUse": "Leer hoe u de Enphase app kunt gebruiken om uw nieuwe Enphase systeem te volgen."
  },
  "sfdcChatBot": {
    "exitConfirmation": "Weet u zeker dat u de chat met ons wilt sluiten?",
    "sfdcChatSubject": "Chat vanuit uw Enphase-apparaat",
    "offlineSupport": "Helaas zijn onze agenten offline. Laat een bericht achter."
  },
  "pushN": {
    "ok": "Oké, ga daarheen",
    "stay": "Blijf hier",
    "permMsg": "U heeft een melding ontvangen voor de site %{siteName}. Ga naar deze site om de melding te bekijken."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "Welke modus moet ik kiezen?",
    "autofillRatePlanExistFAQ": "Waarom wordt mijn tariefplan niet genoemd?",
    "autofillRatePlanMatchFAQ": "Waarom komen mijn gegevens niet overeen met die op mijn rekening?",
    "autofillTariffNote": "Als u moeite heeft met het vinden van de tariefnaam/-code, neem dan contact op met uw energieleverancier voor details.",
    "whtBaslineElecRate": "Wat is uw basistarief voor elektriciteit uitbetalingstarief? ",
    "doElecPayRateVaryWeekends": "Varieert uw elektriciteit uitbetalingstarief in het weekend? ",
    "doElecPayRateVarySeasonaly": "Varieert uw elektriciteit uitbetalingstarief per seizoen? ",
    "elecPayGoesUpWithUsage": "Uw elektriciteit uitbetalingstarief stijgt naarmate uw verbruik toeneemt? ",
    "pRatePeakOffPecakChanges": "Heeft uw elektriciteit uitbetalingstarief piek en daluren? ",
    "ratePerUnitOfSolar": "Wat is uw uitbetalingstarief per opgewekte eenheid zonne-energie? ",
    "payOutRate": "Uitbetalingstarief ",
    "tarifeditorConstants1": "Tariefstructuur van de elektriciteit ",
    "tarifeditorConstants2": "Energiegegevens worden omgerekend in equivalente wisselkoersen. ",
    "tarifeditorConstants3": "Bekijk/bewerken van de tariefstructuur van elektriciteit van uw nutsbedrijf ",
    "tarifeditorConstants4": "U kunt de informatie over het tarief voor de invoer van elektriciteit controleren op uw energierekening onder de rubriek met de details van uw elektrische ladingen. ",
    "tarifeditorConstants5": "Elektriciteit importtarief toevoegen ",
    "tarifeditorConstants6": "Stel de tariefstructuur in waarmee u door uw nutsbedrijf in rekening wordt gebracht voor het importeren van elektriciteit van het net. ",
    "tarifeditorConstants7": "Let op ",
    "tarifeditorConstants8": "De elektriciteitstariefgegevens worden door de Gateway gebruikt om het beste schema voor het opladen en ontladen van de batterij te bepalen wanneer uw batterijprofiel is ingesteld op de modus 'Besparen'. Wanneer deze informatie wordt gewijzigd, verandert het gedrag van het systeem.",
    "tarifeditorConstants9": "De structuur van het elektriciteitstarief is niet toegevoegd ",
    "tarifeditorConstants10": "Elektriciteit importtarief toevoegen ",
    "tarifeditorConstants11": "Selecteer een modus om uw gegevens toe te voegen ",
    "tarifeditorConstants12": "Automatische vulling ",
    "tarifeditorConstants13": "Importeer uw tariefstructuur voor elektriciteit met behulp van de informatie van uw nutsbedrijf ",
    "tarifeditorConstants14": "Handmatig ",
    "tarifeditorConstants15": "Voer handmatig de details van de tariefstructuur van uw elektriciteitsbedrijf in ",
    "tarifeditorConstants16": "Postcode ",
    "tarifeditorConstants17": "Voorziening Naam ",
    "tarifeditorConstants18": "Tarief Naam / Code ",
    "tarifeditorConstants19": "Details van het invoertarief voor elektriciteit ",
    "tarifeditorConstants20": "Standaard Tarief ",
    "tarifeditorConstants21": "Gefaseerd ",
    "tarifeditorConstants22": "Tijdstip van gebruik ",
    "tarifeditorConstants23": "Vast tarief ",
    "tarifeditorConstants24": "Disclaimer ",
    "tarifeditorConstants25": "De gerapporteerde elektrische tarieven zijn gebundelde wijzigingen die alleen op het verbruik gebaseerde tariefcomponenten omvatten. Vaste lasten aanpassingen kredieten stimulansen regio's specifieke en belastingen worden niet in aanmerking genomen. ",
    "tarifeditorConstants26": "Bevestigen & Opslaan ",
    "tarifeditorConstants27": "Elektriciteitstarief Naam ",
    "tarifeditorConstants28": "Basislijn Elektriciteitstarief ",
    "tarifeditorConstants29": "Weet u zeker dat u de details wilt resetten? ",
    "tarifeditorConstants30": "Uw elektriciteitstarief heeft piek- en daltarief? ",
    "tarifeditorConstants31": "Uw elektriciteitstarief stijgt naarmate uw verbruik toeneemt? ",
    "tarifeditorConstants32": "Vast Elektriciteitstarief dat niet varieert. ",
    "tarifeditorConstants33": "Het elektriciteitstarief stijgt naarmate het gebruik toeneemt. ",
    "tarifeditorConstants34": "Varieert uw elektriciteitstarief per seizoen? ",
    "tarifeditorConstants35": "Varieert uw elektriciteitstarief in het weekend? ",
    "tarifeditorConstants36": "Wat is uw basistarief voor elektriciteit? ",
    "tarifeditorConstants37": "Vast Elektriciteitstarief dat niet varieert. ",
    "tarifeditorConstants38": "De structuur van het elektriciteitstarief varieert alleen per seizoen. ",
    "tarifeditorConstants39": "De structuur van de elektriciteitstarief varieert in het weekend. ",
    "tarifeditorConstants40": "De structuur van de elektriciteitstarief varieert per seizoen en in het weekend. ",
    "tarifeditorConstants41": "Het elektriciteitstarief gaat omhoog als het gebruik toeneemt. ",
    "tarifeditorConstants42": "Basislijn elektriciteitstarief: ",
    "tarifeditorConstants43": "De structuur van het elektriciteitstarief varieert alleen per seizoen. ",
    "tarifeditorConstants44": "Elektriciteitstarief heeft piek- en daltarief. ",
    "tarifeditorConstants45": "De structuur van de elektriciteitstarief varieert alleen in het weekend. ",
    "tarifeditorConstants46": "Elektriciteit exporttarief toevoegen ",
    "tarifeditorConstants47": "Voeg de tariefstructuur toe waarmee u wordt betaald voor het exporteren van uw zonne-energie naar het net. ",
    "tarifeditorConstants48": "Selecteer uw plan voor de export van elektriciteit ",
    "tarifeditorConstants49": "Hoe kiest u uw plan voor de export van elektriciteit? ",
    "tarifeditorConstants50": "U kunt deze informatie controleren op uw energierekening onder de rubriek met uw credits en aanpassingen. ",
    "tarifeditorConstants51": "NEM (Netto energiemeting) ",
    "tarifeditorConstants52": "Vink dit aan als u een net meter configuratie bij u thuis heeft. <b style='font-weight: bold;'>Uw tarief voor de invoer van elektriciteit wordt gekopieerd als uw tarief voor de uitvoer van elektriciteit.</b> ",
    "tarifeditorConstants53": "Netto FIT (Netto Invoertarief) ",
    "tarifeditorConstants54": "Vink dit alleen aan als u alleen betaald krijgt voor zonne-energie die vanuit uw huis weer in het net gaat. ",
    "tarifeditorConstants55": "Bruto FIT (Bruto Invoertarief) ",
    "tarifeditorConstants56": "Controleer dit als u betaald krijgt voor elke eenheid elektriciteit die door uw zonnepanelen wordt opgewekt. ",
    "tarifeditorConstants57": "Andere ",
    "tarifeditorConstants58": "Vink dit aan als u op een ander plan staat. ",
    "tarifeditorConstants59": "Gegevens over het exporttarief voor elektriciteit ",
    "tarifeditorConstants60": "Uitbetalingstarief structuur van de elektriciteit ",
    "tarifeditorConstants61": "Export Plan ",
    "tarifeditorConstants62": "Elektriciteit exporttarief bijwerken ",
    "tarifeditorConstants63": "Uw FIT-plan betaalt u tegen een vaste prijs per geëxporteerde eenheid zonne-energie? ",
    "tarifeditorConstants64": "Tijd variërend Tarief ",
    "tarifeditorConstants65": "Elektriciteit uitbetalingstarief heeft piek- en daltarief ",
    "tarifeditorConstants66": "Vast Elektriciteit uitbetalingstarief dat niet varieert ",
    "tec67": "Basislijn leveringstarief elektriciteit",
    "tec68": "Tariefnaam",
    "tec69": "Helaas wordt uw tariefstructuur niet ondersteund voor automatisch invullen. Hier wordt aan gewerkt. In de tussentijd kunt u uw tarief instellen met het handmatige proces.",
    "tec70": "De naam van de elektriciteitsleverancier voor uw postcode kon niet worden gevonden. Stel het tarief handmatig in.",
    "tec71": "Onze excuses, we konden de Tariefgegevens niet ophalen.",
    "tec72": "Selecteer de naam van de elektriciteitsleverancier",
    "tec73": "Zoeken",
    "tec74": "Tariefnaam/code",
    "tec75": "Selecteer tariefnaam/code",
    "tec76": "Stel het tarief handmatig in",
    "tec77": "Probeer het opnieuw",
    "tec78": "Selecteer de oplaadtijd",
    "tec79": "Batterijen uit net opladen",
    "from": "Van",
    "to": "Tot",
    "tec80": "Batterijen uit net opladen is bijgewerkt",
    "try_again": "Probeer het opnieuw.",
    "tec81": "Beoordeel uw ervaring",
    "tec82": "Was deze informatie nuttig en correct?",
    "tec83": "Niet waarschijnlijk",
    "tec84": "Zeer waarschijnlijk",
    "tec85": "Schrijf ons bij vragen of voor meer uitleg.",
    "tec86": "Wilt u niet dat uw batterijen vanuit het net worden opgeladen?",
    "tec87": "Thank you for your valuable feedback",
    "talc": "Probeer het later opnieuw",
    "tec88": "Hoe is uw ervaring met de tariefbewerker?",
    "tec89": "Opmerking",
    "tec90": "Kopieer van Inkooptarief",
    "tec91": "Kopieer uw tariefinstelling van het ingestelde inkooptarief",
    "tec92": "Uitvoertarief elektriciteit",
    "tec93": "Invoertarief elektriciteit",
    "tec94": "Het elektriciteitstarief dat hier wordt getoond is gebundeld volgens de tariefcomponenten hieronder.",
    "tec95": "Beantwoord de vragen hieronder om uw tarieftype in te stellen.",
    "tec96": "Ongeldig tijdsbereik",
    "tec97": "%{time1} - %{time2} is reeds geselecteerd",
    "peak": "Piek",
    "aPeak": "Piek toevoegen",
    "aSeason": "Seizoen toevoegen",
    "season": "Seizoen",
    "eSeason": "Seizoen bewerken",
    "tec98": "Ongeldige invoer. De waarde moet groter zijn dan Niveau %{index}",
    "tec99": "Er is een fout opgetreden, probeer het later opnieuw",
    "tec100": "Het leveringstarief elektriciteit stijgt wanneer het gebruik toeneemt.",
    "tec101": "Tijdgerelateerd tarief",
    "tier": "Niveau",
    "offPeak": "Dalurentarief",
    "tec102": "Invoertarief elektriciteit bewerken",
    "tec103": "handmatige configuratie",
    "tec104": "Automatische vulling tarief",
    "tec105": "Selecteer een modus",
    "tec106": "Selecteer een modus om uw gegevens toe te bewerken",
    "tec107": "selecteer tariefnaam",
    "tec108": "De elektriciteitstariefgegevens worden door de Gateway gebruikt om het beste schema voor het opladen en ontladen van de batterij te bepalen. Wanneer deze informatie wordt gewijzigd, verandert het gedrag van het systeem.",
    "tec109": "De elektriciteitstariefgegevens worden gebruikt om uw energiebesparing door de tijd te berekenen en u gepersonaliseerde aanbevelingen te geven zodat u op de energiekosten kunt besparen.",
    "tec110": "Wat is uw uitbetalingstarief per geëxporteerde eenheid zonne-energie?",
    "tec111": "Invoertarief elektriciteit is toegevoegd",
    "tec112": "Invoertarief elektriciteit is bijgewerkt",
    "tec113": "Invoertarief elektriciteit is teruggezet",
    "tec114": "Uitvoertarief elektriciteit is toegevoegd",
    "tec115": "Uitvoertarief elektriciteit is bijgewerkt",
    "tec116": "Uitvoertarief elektriciteit is teruggezet",
    "rate": "Tarief",
    "tec117": "Vaste uitbetalingsprijs",
    "tec118": "Andere (Gefaseerd )",
    "tec119": "Andere (Tijdstip van gebruik )",
    "tec120": "Andere (Standaard Tarief )",
    "tec121": "Gross FIT",
    "tec122": "Net FIT (Tijdgerelateerd tarief)",
    "tec123": "Net FIT (Standaard Tarief )",
    "tec124": "NEM",
    "tec125": "Vast Elektriciteitstarief dat niet varieert. De structuur van het elektriciteitstarief varieert alleen per seizoen.",
    "tec126": "Vast Elektriciteitstarief dat niet varieert. De structuur van de elektriciteitstarief varieert alleen in het weekend.",
    "tec127": "Vast Elektriciteitstarief dat niet varieert. De structuur van de elektriciteitstarief varieert per seizoen en in het weekend.",
    "tec128": "Vast Elektriciteit uitbetalingstarief dat niet varieert. De structuur van het elektriciteitstarief varieert alleen per seizoen.",
    "tec129": "Vast Elektriciteit uitbetalingstarief dat niet varieert. De structuur van de elektriciteitstarief varieert alleen in het weekend.",
    "tec130": "Vast Elektriciteit uitbetalingstarief dat niet varieert. De structuur van de elektriciteitstarief varieert per seizoen en in het weekend.",
    "tec131": "Elektriciteitstarief heeft piek- en daltarief. De structuur van het elektriciteitstarief varieert alleen per seizoen.",
    "tec132": "Elektriciteitstarief heeft piek- en daltarief. De structuur van de elektriciteitstarief varieert alleen in het weekend.",
    "tec133": "Elektriciteitstarief heeft piek- en daltarief. De structuur van de elektriciteitstarief varieert per seizoen en in het weekend.",
    "tec134": "Elektriciteit uitbetalingstarief heeft piek- en daltarief. De structuur van het elektriciteitstarief varieert alleen per seizoen.",
    "tec135": "Elektriciteit uitbetalingstarief heeft piek- en daltarief. De structuur van de elektriciteitstarief varieert alleen in het weekend.",
    "tec136": "Elektriciteit uitbetalingstarief heeft piek- en daltarief. De structuur van de elektriciteitstarief varieert per seizoen en in het weekend.",
    "tec137": "Het elektriciteitstarief gaat omhoog als het gebruik toeneemt. De structuur van het elektriciteitstarief varieert alleen per seizoen.",
    "tec138": "Het leveringstarief elektriciteit stijgt wanneer het gebruik toeneemt. De structuur van het elektriciteitstarief varieert alleen per seizoen.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Percentagegeschiedenis weergeven",
    "tec141": "Importtarief voor elektriciteit met succes toegevoegd",
    "tec142": "Beoordeel uw ervaring voor het toevoegen van elektriciteitstarief",
    "tec143": "Ontevreden",
    "tec144": "Tevreden",
    "tec145": "Overslaan",
    "tedc0": "Vermogensvergoeding",
    "tedc1": "Vermogensvergoeding hele dag (24 uur)",
    "tedc2": "Uw elektriciteitstarief is inclusief de vermogensvergoeding die maandelijks wordt toegevoegd aan uw elektriciteitsrekening.",
    "tedc3": "Uw elektricitieitstarief is inclusief vraagprijscomponent Tijdens piekuren wordt het maximale verbruik voor ieder %{time}-minuut interval tijdens de maand in rekening gebracht volgens de volgende gegevens",
    "tedc4": "Maximaal verbruik %{time} minuten",
    "tedc5": "Selecteer een tariefstructuur voor elektriciteit",
    "tet1": "Vertel meer over het stroomtarief toevoegen",
    "tet2": "In sommige regio's fluctueert de prijs van elektriciteit gedurende de dag of op basis van uw verbruik. We gebruiken uw elektriciteitstarief om het beste schema te bepalen voor het laden en ontladen van uw batterij wanneer het profiel is ingesteld op Zuinige modus.",
    "tet3": "Aan de slag",
    "tet4": "Tik op Invoertarief elektriciteit toevoegen.",
    "tet5": "Uw gegevens invoeren",
    "tet6": "Gebruik Automatisch invullen of Handmatig om uw tariefgegevens in te voeren. Het kan zijn dat u een actuele elektriciteitsrekening nodig hebt wanneer u het tarief handmatig invoert.",
    "tet7": "Automatisch",
    "tet8": "Selecteer uw nutsbedrijf en abonnementnaam of code uit de vervolgkeuzemenu's. De app zal uw invoertarief elektriciteit automatisch opzoeken.",
    "tet9": "Handmatig",
    "tet10": "Voer de gegevens in ieder veld in; u moet mogelijk een actuele elektriciteitsrekening raadplegen om alle benodigde informatie te verzamelen.",
    "tet11": "Uitvoertarief elektriciteit toevoegen",
    "tet12": "Wanneer u een krediet ontvangt voor het terugsturen van elektriciteit naar het net, voegt u hierna uw uitvoertarief voor elektriciteit toe. Tik op Uitvoertarief elektriciteit toevoegen om aan de slag te gaan; u hebt dezelfde mogelijkheden om uw gegevens automatisch of handmatig in te voeren.",
    "tet13": "Hoe we uw elektriciteitstarief bepalen en toepassen",
    "undefined": "Otro (con niveles)",
    "timeDiffError": "Er moet minimaal 15 minuten zitten tussen de starttijd en eindtijd",
    "periodOverlapError": "Deze periode overlapt met een van de andere periodes",
    "peakConflictError": "Piektarief moet hoger zijn dan het daltarief",
    "isTimeValid": "De starttijd moet vroeger zijn dan de eindtijd"
  },
  "appliance": {
    "info": "Om uw huis gedurende langere tijd van stroom te voorzien tijdens een stroomstoring, raden we u aan uw energieverbruik te minimaliseren en te beheren",
    "desc": "Schakel niet-kritieke thuisladingen uit om de levensduur van de batterij te verlengen.",
    "descSystem2_0AndEncharge": "Beste praktijken tijdens stroomuitval",
    "largeAppliances": "Grote apparaten",
    "useSparingly": "Gebruik spaarzaam",
    "essentialAppliances": "Essentiële apparaten",
    "useNormally": "Gebruik normaal",
    "airConditioner": "Airco",
    "dishwasher": "Vaatwasser",
    "poolPump": "Zwembad pomp",
    "washingMachine": "Wasmachine",
    "electricVehicle": "Electrisch Voertuig",
    "electricDryer": "Elektrische Droger",
    "lights": "Lichten",
    "laptop": "Laptop",
    "television": "Televisie",
    "refrigerator": "Koelkast",
    "wifiRouter": "Wi-Fi Router",
    "microwave": "Magnetron"
  },
  "rootedAlert": {
    "exitBtn": "Afsluiten",
    "proceedBtn": "Doorgaan",
    "agreeBtn": "Ik ga akkoord",
    "warningLabel": "WAARSCHUWING!",
    "warningTextInitial": "Uw toestel lijkt geroot te zijn. Rooten brengt de standaardbeveiliging in gevaar en maakt de gegevens die op uw toestel zijn opgeslagen kwetsbaar. Het wordt niet aanbevolen om de Enphase-app op een geroot apparaat uit te voeren.",
    "warningTextFinal": "Door verder te gaan, begrijp ik en ga ik ermee akkoord dat Enphase niet verantwoordelijk is voor eventuele storingen of gevolgen van het uitvoeren van Enphase-applicaties op dit geroote apparaat."
  },
  "generator": {
    "exerciseModeOverlap1": "De trainingstijd overlapt met uw rusttijd",
    "exerciseModeOverlap2": "tot",
    "exerciseModeOverlap3": "Wilt u verdergaan?",
    "dayInWeek": "Dag in week",
    "time": "Tijd",
    "duration": "Duur",
    "frequency": "Frequentie",
    "save": "Guardar",
    "edit": "EDITAR",
    "cancelRequest": "Cancelar solicitud",
    "activate": "Activar",
    "okayText": "¡OK, entendido!",
    "batteryUnavailable": "<span>Su sistema no tiene batería. ¿Quiere controlar su generador en función de la carga de la batería? <a href='https://estimator.enphaseenergy.com/login' target='_blank'>Agregar Almacenamiento</a></span>",
    "suspendedStateText": "Uw generator is momenteel uitgeschakeld. Schakel uw generator in met de schakelknop bovenaan het scherm om het generatorprofiel te activeren.",
    "suspendedModalHeading": "Uw generator wordt uitgeschakeld.",
    "suspendedModalHeading_1": "Uw generator zal worden ingeschakeld op basis van het geselecteerde profiel.",
    "suspendedModalSubheading": "Om de generator in te schakelen, gebruikt u de knop voor het omschakelen van de generator aan de bovenkant van het scherm.",
    "infoHeadng": "Generador",
    "infoSubheading": "<div><div>Wanneer deze is  <span style='color: #F37320'>ingeschakeld</span>, your generator will turn on and turn off based on the selected profile and grid availability. If your system is On Grid, your generator will be turned off irrespective of profiles selected.</div><div style='margin-top: 10px;'> U kunt uw generator uitschakelen als deze niet in gebruik is, bijvoorbeeld als u op vakantie gaat.<div></div>",
    "advancedSettings": "Geavanceerde instellingen",
    "pendingRequest": "verzoek in behandeling",
    "disabled": "Deshabilitado",
    "disable": "Uitschakelen",
    "enabled": "Habilitado",
    "waiting": "Esperando información",
    "active": "Activo",
    "deviceDetails": "Selecteer een Smart profiel om je %{manufacturer} %{modelNumber} te beheren.",
    "autoStart": "Automatische start",
    "autoStartSubheading": "Gebruik deze optie als u de generator wilt inschakelen zodra uw systeem naar de buiten raster modus overschakelt.",
    "batteryOptimizationSubheading": "Gebruik deze optie als u de generator alleen wilt inschakelen als de acculading onder een bepaald niveau ligt en uw systeem buiten het raster is.",
    "batteryChargeThreshold": "Acculaaddrempel:",
    "lowerLimit": "Ondergrens: ",
    "upperLimit": "Bovengrens: ",
    "start": "Starten: ",
    "stop": "Stop: ",
    "addQuietTime": "Kalme tijd toevoegen",
    "quietTime": "Kalme tijd",
    "quietTimeToggle": "Gebruik het als u uw generator niet wilt inschakelen gedurende deze tijd. Wanneer de accu een kritische limiet bereikt, wordt de generator ingeschakeld, ongeacht de stille tijd.",
    "startTime": "Start Tijd: ",
    "endTime": "Eind Tijd: ",
    "criticalChargeSettings": "Kritische Laadinstellingen:",
    "generatorLoadingToast": "Bevestiging status generator duurt langer dan verwacht. Controleer later opnieuw.",
    "exerciseMode": "Configuración de ejercicio",
    "exerciseModeSubheading": "Dit wordt gebruikt om de generator automatisch op een regelmatig interval te laten draaien om hem in goede conditie te houden.",
    "batteryOptimization": "Start op basis van het batterijniveau",
    "activateBatteryProfile": "U heeft het Autostart profiel geselecteerd. Activeer het profiel \"Starten op basis van batterijniveau\" om de stille tijd toe te voegen",
    "manualMode": "Manuele modus",
    "manualModeDescription": "Uw generator werkt momenteel in handmatige modus. Wijzig uw generatormodus naar auto of neem contact op met uw installateur.",
    "generatorStartLimit": "De startgrens mag niet lager zijn dan 10%",
    "generatorStartStopLimit": "De startgrens en de stopgrens moeten een minimumverschil van 5% hebben",
    "generatorLimitDescription": "Gebruik dit om te voorkomen dat uw generator tijdens specifieke perioden wordt ingeschakeld. De generator wordt ingeschakeld wanneer de batterijlading onder de kritische laadgrens komt.",
    "generatorQuietTime": "Rusttijd",
    "generatorNormalTime": "Tormale tijd",
    "generatorEnableGenerator": "Generator inschakelen",
    "generatorDisableGenerator": "Generator uitschakelen",
    "automatic": "Automatisch",
    "ecoFriendly": "Milieuvriendelijk"
  },
  "sgipStatic": {
    "applyForIncentive": "SGIP-stimulering aanvragen",
    "subheadingSgip": "Systeemeigenaars in Californië, die plannen om of die een Enphase-batterij hebben aangeschaft voor hun huis, kunnen een aanvraag doen voor SGIP",
    "applyNow": "Nu aanvragen",
    "learnMore": "Meer informatie",
    "serviceFee": "* Servicekosten kunnen van toepassing zijn",
    "enphaseRepresentative": "* Een Enphase-vertegenwoordiger kan via telefoon/e-mail contact opnemen",
    "documentsRequired": "De volgende documenten zijn nodig om een SGIP-stimulering aan te vragen:",
    "documentHeading1": "1. Meest recente energierekening (ten minste een rekening uit de laatste 3 maanden)",
    "documentHeading2": "2. Contractdocument",
    "additionalInfo": "* Aanvullende documenten kunnen vereist zijn voordat de uiteindelijke stimulering uitbetaald wordt"
  },
  "activationProgress": {
    "systemActivationInProgress": "Uw systeemactivatie is bezig",
    "completed": "Voltooid",
    "viewDetails": "Gegevens bekijken",
    "activationCompleted": "Activatie is 100% compleet",
    "activationInProgress": "Activatie bezig",
    "devices": "Apparaten",
    "status": "Status",
    "envoy": "Gateway",
    "encharge": "Batterij",
    "enpower": "Systeemcontroller",
    "pvProduction": "PV-productie",
    "cosumptionCT": "Verbruik CT",
    "systemOperational": "Systeem operationeel",
    "reporting": "Rapportage",
    "notReporting": "Niet rapporteren",
    "enabled": "Ingeschakeld",
    "notEnabled": "Niet ingeschakeld",
    "producing": "Produceren",
    "verified": "Geverifieerd",
    "notVerified": "Niet geverifieerd",
    "featuresNowEnable": "De volgende functies zijn nu ingeschakeld",
    "featuresWillBeEnabled": "De volgende functies worden ingeschakeld zodra uw systeemactivatie compleet is:",
    "consumptionMonitoring": "Bewaken verbruik",
    "liveStatus": "Live status",
    "stormGuard": "Stormbewaking",
    "batteryProfileSetting": "Profielinstellingen batterij",
    "gridControl": "Netcontrole"
  },
  "prodIssue_faq_1": "Waarom produceert een van mijn panelen minder dan de andere?",
  "prodIssue_faq_2": "Het is gebruikelijk dat panelen op hetzelfde dak variëren in energieopwekking. Veel factoren kunnen deze variaties veroorzaken, zoals de richting van het paneel, schaduw door schoorstenen of bomen, en andere obstructies.",
  "accountNew": {
    "account": {
      "title": "Uw gegevens",
      "title_alternate": "Persoonsgegevens",
      "save_changes": "Wijzigingen opslaan",
      "name_label": "Naam:",
      "phone_label": "Mobiele nummer:",
      "phone_placeholder": "Telefoonnummer",
      "first_name_placeholder": "Voornaam",
      "last_name_placeholder": "Achternaam",
      "email_placeholder": "E-mailadres",
      "email_label": "E-mail:",
      "change_password": "Wachtwoord wijzigen",
      "current_password": "Huidig wachtwoord:",
      "password_label": "Nieuw wachtwoord:",
      "password2_label": "Nieuw wachtwoord opnieuw invoeren:",
      "password_footnote": "Wachtwoorden moeten minstens 6 tekens lang zijn en minstens 1 cijfer of speciaal teken bevatten.",
      "cancel_change_password": "Wachtwoord niet wijzigen",
      "units_label": "Eenheden:",
      "units_metric": "Metrisch stelsel (°C, km)",
      "units_us": "Imperiaal stelsel (°F, mijl)",
      "locale_label": "Taal",
      "equivalent_label": "Energie-equivalent:",
      "equivalent_display": "Beginnen met",
      "notification_label": "E-mails:",
      "preference_monthly_email": "Stuur me maandoverzichten van de systeemprestaties",
      "preference_enphase_email": "Stuur mij nieuwsbrieven, promoties en enquêtes over producten en services van Enphase",
      "production_issues_email": "Houd mij op de hoogtgti e van systeemproductie of servicekwesties",
      "save_successful": "Uw gegevens zijn opgeslagen.",
      "save_successful_email": "Uw gegevens zijn opgeslagen. Zie de opmerking hieronder met betrekking tot het wijzigen van uw e-mailadres.",
      "save_failed": "Uw gegevens zijn niet opgeslagen.",
      "system_info": "Systeeminformatie voor %{site_name}",
      "system_weather": "Systeemweer",
      "show_system_weather": "Weerfuncties voor deze locatie weergeven",
      "save": "Bewaar"
    },
    "system_preferences": {
      "title": "Systeemvoorkeuren",
      "name_label": "Naam:",
      "public_label": "Openbare systeempagina:",
      "public_text_html": "Maak een openbare pagina voor mijn systeem",
      "public_preview_link": "Voorbeeld openbare pagina",
      "public_help_link": "Meer informatie",
      "public_footnote": "Hiermee schakelt u functies voor sociaal delen in en laat u bezoekers toe op uw systeem.",
      "display_label": "Systeemnaam weergeven als:",
      "save_changes": "Systeemvoorkeuren opslaan",
      "save_location_changes": "Privacyinstellingen opslaan",
      "save_successful": "Uw systeemvoorkeuren zijn opgeslagen.",
      "save_failed": "Systeemvoorkeuren zijn niet opgeslagen."
    },
    "validations": {
      "required": "Dit veld is verplicht.",
      "password_too_short": "Uw wachtwoord moet minstens zes tekens lang zijn en minimaal één cijfer of speciaal teken bevatten.",
      "password_too_long": "Voer maximaal 49 tekens in.",
      "password_similar_to_username": "Uw wachtwoord mag niet hetzelfde zijn als uw e-mailadres.",
      "password_too_weak": "Uw wachtwoord moet minstens zes tekens lang zijn en minimaal één cijfer of speciaal teken bevatten.",
      "password_weak": "Uw wachtwoord moet minstens zes tekens lang zijn en minimaal één cijfer of speciaal teken bevatten.",
      "password_good": "Sterkte van wachtwoord: Goed",
      "password_strong": "Sterkte van wachtwoord: Sterk",
      "password_policy": "Uw wachtwoord moet ten minste %{pwd_min_length}-%{pwd_max_length} tekens lang zijn en %{digit_in_pwd} cijfers, %{uppercase_in_pwd} hoofdletters, %{lowercase_in_pwd} kleine letters, %{special_character_in_pwd} aantal speciale tekens bevatten en alleen (~!@#$%^&*)",
      "equalTo": "Voer nogmaals dezelfde waarde in.",
      "invalid_phone_number": "Voer een geldig mobiel telefoonnummer in.",
      "empty_phone_number": "Voer uw mobiele telefoonnummer in.",
      "email_used": "E-mail ID is al geregistreerd. Probeer het opnieuw met een andere e-mail ID of $cHere om uw wachtwoord opnieuw in te stellen.",
      "emailInvalid": "Vul een geldig e-mailadres in"
    }
  },
  "accountDelete": {
    "deleteAccount": "Account verwijderen",
    "deletePopUpText": "Uw account en bijbehorende persoonlijke gegevens worden verwijderd. Na het verwijderen van het account wordt u uitgelogd. Wil je doorgaan?",
    "deleteCnfText": "Uw account en bijbehorende persoonlijke informatie worden verwijderd, behalve informatie die we moeten bijhouden in verband met uw energiesysteem. Na het verwijderen van het account wordt u uitgelogd. Wil je doorgaan?",
    "yes": "Ja",
    "no": "Nee",
    "verificationCode": "Verificatie code",
    "enterCodeText": "Voer de 4-cijferige code in die naar uw geregistreerde e-mailadres en het mobiele nummer is verzonden.",
    "didntReceive": "Geen code ontvangen?",
    "resend": "Opnieuw verzenden",
    "deleteCnfTextEnlm": "Uw account en bijbehorende persoonlijke informatie worden verwijderd, behalve informatie die we moeten bijhouden in verband met uw energiesysteem. U raakt ook de toegang tot Enlighten Manager kwijt. Na het verwijderen van het account wordt u uitgelogd. Wil je doorgaan?",
    "deleteAdmin": "Uw account kan niet worden verwijderd omdat u een Enphase-beheerder bent",
    "verifyCode": "Code verifiëren",
    "logOutText": "Na verificatie van de code wordt u uitgelogd.",
    "confirmText": "Uw account is gedeactiveerd. We bewaren persoonlijke informatie met betrekking tot uw energiesysteem om uw garantie na te komen en uw systeem te ondersteunen.",
    "ok": "OK ik snap het",
    "activateCnfText": "Uw Enphase-account is niet actief omdat u uw account hebt verwijderd. Wilt u deze opnieuw activeren?",
    "activateText": "E-mail-ID is geregistreerd bij Enphase. Het is echter niet actief omdat het is verwijderd.",
    "click": "Klik ",
    "activateAgain": "hier om het opnieuw te activeren",
    "activateAccount": "Activeer account",
    "emailIDRegistered": "E-mail-ID is geregistreerd bij Enphase. Het is echter niet actief omdat het is verwijderd. $cHere om het opnieuw te activeren.",
    "deleteAccountPopupText": "Als u uw account verwijdert, wordt uw account gedeactiveerd en worden alle persoonlijke gegevens die aan uw account zijn gekoppeld, verwijderd. Aangezien u bent aangesloten bij een Enphase Energy System, zijn we verplicht uw persoonlijke gegevens te bewaren om productgarantie, systeemupgrades en ondersteuning te ondersteunen.",
    "learnMore": "Leer meer",
    "accountdeletion": "Uw account wordt verwijderd. Dit proces kan tot 30 dagen duren en u kunt een nieuw account maken nadat uw eerdere account is verwijderd.",
    "incorrectEmailandPass": "Het e-mailadres en wachtwoord dat u hebt ingevoerd, komen niet overeen met onze gegevens. Probeer het opnieuw.",
    "accountdeletioninfo": "Uw account wordt verwijderd. Het kan tot 30 dagen duren.",
    "WOAccntdeletePopup": "Als u uw account verwijdert, wordt uw account gedeactiveerd en worden alle persoonlijke gegevens die aan uw account zijn gekoppeld, verwijderd.",
    "accountdelReq": "Verzoek om accountverwijdering",
    "verfcodedel": "Uw verificatiecode voor het verwijderen van Enphase-account",
    "accountActvReq": "Verzoek om accountactivering",
    "codedelAccount": "Verificatiecode voor het verwijderen van Enphase-account",
    "codeDuration": "Deze code is slechts 15 minuten geldig.",
    "userDelReq": "Gebruiker heeft gevraagd om de optie voor accountverwijdering in de Enphase-app. Hieronder vindt u de gebruikersgegevens:",
    "requestReceived": "We hebben uw verzoek om uw Enphase-account te activeren ontvangen. Klik hiervoor binnen 7 dagen na ontvangst van deze e-mail op de onderstaande link.",
    "activate": "Activeren",
    "accActivate": "Activeer uw account",
    "optdelaccount": "Uw verificatiecode voor het verwijderen van uw Enphase-account is %{otp}. Deze code is 15 minuten geldig.",
    "emailCheckInstruction": "Controleer uw e-mail voor instructies om het account te activeren."
  },
  "phase": {
    "all": "Driefasige weergave",
    "phaseL": "Fase L",
    "msgOffGrid": "Fasegewijze stroomverbruikgegevens zijn niet beschikbaar als uw system in Zonder Netwerk-modus is."
  },
  "vls": {
    "vlsHeading": "Uitschakelniveau batterij",
    "shutdownLevelLine1": "Bij een storing wordt uw batterij uitgeschakeld om",
    "shutdownLevelLine1-2": "om energie te besparen. Het wordt opnieuw opgestart door de bewaarde energie te gebruiken wanneer het elektriciteitsnet de stroom herstelt of zonnepanelen beginnen met het produceren van energie.",
    "shutdownLevelLine2": "Kies een hoge waarde als u last heeft van slecht weer dat van invloed is op de zonne-energie productie.",
    "vlsWarning": "Het uitschakelniveau van de batterij kan niet meer zijn dan de batterijreserve (%{soc}%)",
    "stormVlsWarning": "Stormwaarschuwing is ingeschakeld voor uw systeem. Zodra de stormwaarschuwing eindigt, wordt de batterijreserve bijgewerkt tot %{soc}% omdat de reserve niet lager kan zijn dan het uitschakelniveau",
    "batteryReserveWarning": "De batterijreserve kan niet lager worden ingesteld dan het uitschakelniveau van de batterij (%{horizontal}%). Verlaag het uitschakelniveau van de batterij via #geavanceerde instellingen# om de batterijreserve te verlagen.",
    "editRequest": "U heeft een actief verzoek. Wacht op bevestiging of annuleer dat verzoek om verder te gaan met de selectie."
  },
  "defaultLocale": {
    "popContent1": "Kies app-taal",
    "popContentBody1": "Wilt u doorgaan met ",
    "popContentBody2": " als uw app-taal?",
    "button1": "Oké, doorgaan",
    "button2": "Kies een andere taal",
    "button3": "Nee, Wijzig naar ",
    "en": "Engels",
    "de": "Duits",
    "es": "Spaans",
    "fr": "Frans",
    "it": "Italiaans",
    "nl": "Nederlands",
    "pl": "Pools",
    "pt": "Portugees",
    "en-AU": "English (AU)"
  },
  "woSolarWStorage": {
    "noArraysTitle": "Geen panelen!",
    "noArraysDesc": "U heeft geen zonnepanelen geïnstalleerd",
    "noAccessConsumptionData": "U hebt geen toegang tot verbruiksgegevens voor deze locatie."
  },
  "drEventsActive": "VR-gebeurtenis: Actief",
  "pleaseGoTo": "Ga naar ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": " om uw notificatievoorkeuren bij te werken.",
  "loadControl": (_loadControl = {
    "enabled": "Inschakelen",
    "disabled": "Uitschakelen",
    "smartEnabled": "Slimme Bediening Ingeschakeld",
    "smartDisabled": "Slimme Bediening uitgeschakeld",
    "offGridBehaviour": "Gedrag Offline",
    "modeDetails": "Details Slimme Bedieningsmodus",
    "newModeDetails": "Details laadcontrolemodus",
    "basicMode": "Basismodus",
    "cannotUse": "%{loadName} niet gebruikt worden",
    "genOnUSe": "%{loadName} gebruikt worden als de generator is ingeschakeld",
    "genMode": "Generatormodus",
    "batteryMode": "Batterijmodus",
    "batteryModePercent": "%{loadName} kan gebruikt worden wanneer de batterij %{lowerSoc}% of meer is opgeladen.",
    "batteryModeSoc": "Als deze minder dan %{lowerSoc}% is opgeladen,kan %{loadName} niet gebruikt worden totdat de batterij weer opgeladen is tot %{upperSoc}%",
    "loadControlHeading": "Controleer de stroomtoevoer naar uw ladingen wanneer niet aangesloten op het net",
    "loadControlSubHeading": "Alle ladingen worden ingeschakeld wanneer ze op het net zijn aangesloten",
    "powered": "Aangedreven",
    "notPowered": "Niet Aangedreven",
    "unknown": "Onbekend",
    "permissionOfIntstaller": "U hebt geen toestemming om instellingen voor dit apparaat te wijzigen. Neem contact op met uw installateur of met de Enphase-klantenservice om hier meer over te weten te komen.",
    "willbePowered": "Uw %{loadName} altijd in deze staat ingeschakeld.",
    "poweredOnOffGrid": "Uw %{loadName} altijd in deze staat ingeschakeld."
  }, _defineProperty(_loadControl, "poweredOnOffGrid", "Uw %{loadName} ingeschakeld op basis van het geselecteerde gedrag wanneer niet aangesloten op het net."), _defineProperty(_loadControl, "continueModal", "Wilt u verdergaan?"), _defineProperty(_loadControl, "infoDetails", "Wanneer slimme bediening is uitgeschakeld of wanneer uw systeem niet is aangesloten op het net, worden de ladingen altijd ingeschakeld."), _defineProperty(_loadControl, "newInfoDetails", "Regel de stroom naar uw ladingen op basis van de energiebron of tijdstip van de dag. U kunt ook de handmatige modus gebruiken als u de stroom naar uw ladingen onmiddellijk wilt regelen."), _defineProperty(_loadControl, "enableSmartComtrol", "Zorg ervoor dat uw stroomschakelaars voor deze apparaten zijn ingeschakeld om deze functionaliteit te kunnen gebruiken."), _defineProperty(_loadControl, "enableToggle", "Activar Slimme Bediening?"), _defineProperty(_loadControl, "disableToggle", "Uitschakelen Slimme Bediening?"), _defineProperty(_loadControl, "apply", "Toepassen"), _defineProperty(_loadControl, "modalPara1", "<div>Wanneer slimme bediening is <span style='color: #F37320'>ingeschakeld</span>, kunt u één van de drie modi kiezen voor gedrag wanneer niet aangesloten op het net.</div>"), _defineProperty(_loadControl, "disabledModalText", "Wanneer slimme is uitgeschakeld voor deze belasting. Wanneer slimme bedieningsfunctie in met behulp van de schakelknop om het Off Grid-gedrag bij te werken"), _defineProperty(_loadControl, "batteryChargeLowerLimit", "De ondergrens van de batterijlading mag niet lager zijn dan 10%"), _defineProperty(_loadControl, "batteryChargeHigherLimit", "Ondergrens batterijlading mag niet hoger zijn dan 90%"), _defineProperty(_loadControl, "loadControlLoadingToast", "Bevestiging van de %{loadName} status duurt langer dan verwacht. Controleer later nogmaals."), _defineProperty(_loadControl, "loadControlTakingLonger", "Bevestiging van de laadstatus duurt langer dan verwacht. Controleer later nogmaals."), _defineProperty(_loadControl, "batteryChargeLowerHigherLimit", "De ondergrens en de bovengrens van de batterijlading moeten een verschil van minimaal 5% hebben"), _defineProperty(_loadControl, "mode", "modus"), _defineProperty(_loadControl, "lcMainHeading", "Regel de stroom naar uw belastingen"), _defineProperty(_loadControl, "basic", "basis"), _defineProperty(_loadControl, "scheduled", "gepland"), _defineProperty(_loadControl, "advanced", "geavanceerd"), _defineProperty(_loadControl, "manual", "handmatig"), _defineProperty(_loadControl, "notSelected", "Niet geselecteerd"), _defineProperty(_loadControl, "poweredWhen", "Ingeschakeld wanneer de batterijlading hoger is dan"), _defineProperty(_loadControl, "poweredGenOn", "Wordt voorzien van stroom als generator aan staat"), _defineProperty(_loadControl, "poweredBetweenTime", "Ingeschakeld tussen %{startTime} en %{endTime}"), _defineProperty(_loadControl, "onceDisconnected", "Eenmaal losgekoppeld van de stroombron, wordt de lading niet gevoed tenzij de batterij tot 100% is opgeladen."), _defineProperty(_loadControl, "alwaysPowered", "Altijd ingeschakeld"), _defineProperty(_loadControl, "neverPowered", "Nooit ingeschakeld"), _defineProperty(_loadControl, "minDiff", "Er moet minimaal 15 minuten verschil zitten tussen de starttijd en de eindtijd."), _defineProperty(_loadControl, "startLessThanEnd", "Starttijd moet eerder zijn dan de eindtijd"), _defineProperty(_loadControl, "notValidTime", "Starttijd en Eindtijd moeten tussen %{startTime} en %{endTime} liggen."), _defineProperty(_loadControl, "completed", "%{loadName} modus met succes bijgewerkt."), _defineProperty(_loadControl, "notCompleted", "Uw verzoek kan niet worden voltooid. Probeer later nogmaals"), _defineProperty(_loadControl, "completedAll", "Loads updated successfully."), _defineProperty(_loadControl, "emptyLoadControls", "Geen laadcontrole gevonden"), _defineProperty(_loadControl, "allowedWarning", "Zorg er bij het wijzigen van dit tijdsbestek voor dat uw zonne-energieproductie voldoende is om uw verbruik gedurende dit tijdsbestek te ondersteunen."), _defineProperty(_loadControl, "advancedMode", {
    "subtitle": "De lading controleren met:",
    "notPowered": "Ingeschakeld wanneer de lading hoger is dan ",
    "batterySocDesc1": "Niet ingeschakeld wanneer de lading lager is dan ",
    "batterySocDesc2": "Alleen ingeschakeld nadat de batterij is opgeladen tot ",
    "batterySocDesc3": " (zelfs als de generator aan staat)",
    "notAvailable": "Niet beschikbaar",
    "onGridGenPowered": "Aangedreven",
    "offGridGenPowered": "Wordt voorzien van stroom als generator aan staat"
  }), _loadControl),
  "app_info": _defineProperty({
    "update_available": "App-update beschikbaar",
    "already_updatec": "Uw app is bijgewerkt",
    "update_now": "Werk nu bij",
    "latest_update": "Laatst bijgewerkt",
    "update_history": "Updategeschiedenis",
    "show_more": "Meer weergeven"
  }, "show_more", "Meer minder"),
  "s1": "Help mij een profiel te selecteren",
  "s2": "Meer informatie over batterijprofielen",
  "s3": "Doe mij een suggestie voor een profiel",
  "s4": "De batterijlading is groter dan de reserve",
  "s5": "Energy Independence na piekuren:",
  "s6": "Tijdens daluren laden uw zonnepanelen eerst uw batterij voordat er stroom aan het huis wordt geleverd. Een overschot aan zonne-energie wordt teruggestuurd naar het net om uw energierekening te verlagen.",
  "s7": "Als uw huis meer stroom nodig heeft dan uw zonnepanelen produceren, wordt elektriciteit van het net gebruikt.",
  "s8": "Gedrag van het systeem tijdens piekuren",
  "s9": "Uw elektriciteitsrekeningen verlagen",
  "s10": "In sommige regio's fluctueert de prijs van elektriciteit gedurende de dag, waarbij de elektriciteit duurder wordt tijdens piekuren wanneer er veel vraag is naar elektriciteit.",
  "s11": "Uw huis gebruikt de batterij om te voorkomen dat u elektriciteit tegen een hogere prijs koopt. Als uw huis meer stroom nodig heeft dan de batterij kan leveren, wordt daarna eerst zonne-energie gebruikt en als laatst netstroom. Overtollige energie wordt geëxporteerd naar het elektriciteitsnet.",
  "s12": "s Nachts, wanneer uw zonnepanelen niets produceren, gebruikt uw huis elektriciteit uit de batterij tot het reserveladingsniveau is bereikt.",
  "s13": "Elektriciteit wordt vanuit het netwerk geïmporteerd wanneer er geen zonne-energie beschikbaar is en uw huis meer stroom nodig heeft dan de batterij kan leveren.",
  "s14": "Uw huis van stroom voorzien met groene energie",
  "s15": "Uw huis geeft prioriteit aan het gebruik van groene energie. Gedurende de dag draait het huis op zonne-energie en daarna op de batterij. Overtollige energie wordt geëxporteerd naar het elektriciteitsnet. Gedurende de nacht draait het huis op de batterij.",
  "s16": "Elektriciteit wordt vanuit het netwerk geïmporteerd wanneer uw huis meer stroom nodig heeft dan het zonnesysteem en de batterij samen kunnen leveren.",
  "s17": "Batterij is volledig opgeladen",
  "s18": "Gedrag van het systeem tijdens daluren",
  "s19": "Uw panelen voorzien eerst uw batterij van stroom en daarna uw huis. Een overschot aan energie wordt gestuurd naar het net.",
  "s20": "s Nachts of wanneer u meer stroom nodig heeft dan uw zonnepanelen produceren, gebruikt uw huis elektriciteit van het net. Uw batterij wordt nooit gebruikt, behalve bij een stroomstoring.",
  "s21": "Tik op een profiel om naar de bijbehorende pagina te gaan.",
  "s22": "Veeg naar links of rechts voor meer informatie.",
  "s23": "Uw batterijen worden ook na piekuren ontladen.",
  "s24": "Elektriciteit wordt vanuit het netwerk geïmporteerd wanneer er geen zonne-energie beschikbaar is en uw huis meer stroom nodig heeft dan de batterij kan leveren.",
  "s25": "Gedrag van het systeem tijdens daluren",
  "s26": "Over stroom beschikken tijdens stroomstoringen",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "Dit is de geschatte geldbesparing van uw systeem op basis van de productie van zonne-energie. Dit wordt berekend op basis van het ingevoerde elektriciteitstarief.",
      "noTeriffMsg": "Voeg elektriciteitstarief toe om uw besparingen te kennen",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Aan de slag",
      "billingCycle": {
        "more": "meer dan deze tijd in de vorige factureringscyclus",
        "less": "minder dan deze tijd in de vorige factureringscyclus",
        "same": "Ongeveer hetzelfde als deze tijd in de vorige factureringscyclus"
      },
      "calendarMonth": {
        "more": "meer dan deze tijd vorige maand",
        "less": "minder dan deze tijd vorige maand",
        "same": "Ongeveer hetzelfde als vorige maand rond deze tijd"
      },
      "day": {
        "more": "meer dan deze tijd vorige dag",
        "less": "minder dan deze tijd vorige dag",
        "same": "Ongeveer hetzelfde als deze tijd vorige dag",
        "significantMore": "Aanzienlijk hoger dan de vorige dag"
      },
      "week": {
        "more": "meer dan deze tijd vorige week",
        "less": "minder dan deze tijd vorige week",
        "same": "Ongeveer hetzelfde als vorige week om deze tijd"
      },
      "year": {
        "more": "meer dan vorig jaar rond deze tijd",
        "less": "minder dan vorig jaar rond deze tijd",
        "same": "Ongeveer hetzelfde als vorig jaar rond deze tijd"
      },
      "editElectricity": "ELEKTRICITEITSTARIEF BEWERKEN",
      "viewSavingsBased": "Bekijk besparingen op basis van",
      "calendarMonthTitle": "Kalendermaand",
      "calendarMonthDesc": "Periode van de 1e van de maand tot de laatste dag van de maand",
      "noExportRate": "Voeg %{exportCTA} toe om uw totale besparingen te bekijken",
      "exportRate": "Exporttarief"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "Kan geen lokale verbinding maken",
    "limitedAppFunctionality": "Beperkte app functionaliteit",
    "needHelpGatewayWifi": "Hulp nodig bij het configureren van de gateway Wifi-verbinding",
    "howToConnectGatewayNetwork": "Hoe u een verbinding kunt maken met het gateway netwerk",
    "connectGatewayToWifi": "Gateway verbinden met een Wifi-netwerk",
    "connectLocally": "LOKALE VERBINDING MAKEN",
    "checkNetworkConnection": "Controleer uw netwerkverbinding.",
    "noInternetModalSubText1": "Controleer uw netwerkverbinding. In de tussentijd kunt u de huidige status van het systeem bekijken.",
    "noInternetModalSubText2": "Controleer uw netwerkverbinding. In de tussentijd kunt u, als u zich in de buurt van uw systeem bevindt, lokaal verbinding maken met de Gateway om de huidige status te bekijken.",
    "refereshing": "Vernieuwen",
    "pullToReferesh": "Trek om te vernieuwen",
    "connectionStatus": "Uw telefoon is nu lokaal verbonden met het gateway netwerk.",
    "connectivityErrorMsg1": "Zorg ervoor dat uw telefoon en gateway op hetzelfde netwerk zitten",
    "connectivityErrorMsg2": 'Gateway was onlangs verbonden met het %{wifiName} netwerk',
    "connectivityErrorMsg3": "U kunt u telefoon ook verbinden met de Wifi van de gateway door de AP-modus in te schakelen op uw gateway",
    "connecting": "Uw telefoon probeer lokaal te verbinden met de gateway om live status te bekijken.",
    "viewLiveStatus": "Bekijk live status",
    "pleaseTryAgainInSomeTime": "Probeer het over een tijdje opnieuw.",
    "connectedLocally": "Lokaal verbonden",
    "ssidNotMatchedError": "U heeft uw mobiele telefoon niet verbonden met het juiste gateway netwerk. Verbind uw mobiele telefoon met dit gateway netwerk: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Gateway netwerken voor deze site",
      "message": "Verbind uw mobiele telefoon alleen met het netwerk van een van de gateways van deze site. Hieronder volgen de gateway netwerken voor deze site:",
      "buttonText": "Oké, ik begrijp het!"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "U heeft uw mobiele telefoon niet verbonden met het huidige gateway netwerk. Verbind uw mobiele telefoon alleen met het netwerk van een van de gateways van deze site.",
    "configureButtonMultiEnvoyMsg": "U heeft uw mobiele telefoon niet verbonden met het juiste gateway netwerk. Verbind uw mobiele telefoon alleen met het netwerk van een van de gateways van deze site. Hieronder volgen de gateway netwerken voor deze site:",
    "listOfGatewayNetworks": "Lijst met gateway netwerken voor deze site",
    "configureWifiMultiEnvoyMsg": "Om de Wifi te configureren voor gateway (serienummer: XXXX) verbindt uw mobiel met de AP-modus van deze gateway. U bent momenteel verbonden met de AP-modus van de gateway (serienummer:XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "Hoe te verbinden met de Wifi van de gateway",
      "okGotIt": "Oké, ik begrijp het",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "",
      "subText1": "Maak lokaal verbinding met het gateway netwerk als u uw systeeminstellingen wilt wijzigen.",
      "subText2": 'Zorg ervoor dat uw telefoon en gateway op hetzelfde netwerk zitten %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(gateway was onlangs verbonden met het \"%{lastConnection}\" netwerk)",
      "subText3": "In alternativa, connettere il cellulare alla rete Wi-Fi del gateway abilitando la modalità AP sul gateway",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Recente Wifi-verbindingen van gateways",
      "gatewayPrefix": "Gateway serienummer.",
      "gatewayBtn": "Gateway Wifi-netwerken voor deze site",
      "alternetively": "U kunt ook uw telefoon verbinden met een van de gateway netwerken door de AP modus op uw gateway in te schakelen."
    },
    "isTouPopupMsg": "De spaarmodus kan niet worden geactiveerd, omdat deze alleen werkt als u beschikt over Net Energie Meten (NEM) en uw elektriciteitstarief varieert met de gebruiksduur (ToU). Het elektriciteitstarief instellen of bijwerken is alleen mogelijk als uw telefoon is verbonden met internet.",
    "configWifiToGateway": "CONFIGUREER WI-FI VOOR UW GATEWAY",
    "phoneNtConnectedToGateway": "Uw telefoon is niet verbonden met gateway",
    "chooseWifiNetwork": "Kies een wifi-netwerk dat u wilt gebruiken met uw gateway.",
    "learnWifiConfigToGatway": "Leer hoe u wifi voor uw gateway configureert",
    "step": "Stap",
    "connectPhoneToGateway": "Verbind uw telefoon met gateway",
    "connectToGatewayNetwork": "Maak verbinding met het netwerk van de gateway om Wi-Fi voor uw gateway te configureren",
    "gatewayNtReachable": "Uw gateway is niet bereikbaar",
    "pleaseEnsure": "Zorg ervoor dat:",
    "gatewayAPModeOn": "Gateway's AP-modus is ingeschakeld",
    "phoneInCloseProximity": "Telefoon bevindt zich in de buurt van de gateway",
    "mobileDataOff": "Mobiele data (mobiele data) is uitgeschakeld",
    "searchingGateway": "Zoeken naar gateway-netwerk…",
    "devicePluggedIn": "Zorg ervoor dat uw apparaat in de buurt is, is aangesloten en de AP-modus is ingeschakeld",
    "connectingTo": "Verbinden met",
    "reflectedInApp": "Dit kan een paar minuten duren voordat dit wordt weergegeven in de app",
    "connectionFailed": "Kan geen verbinding maken met het netwerk van de gateway",
    "connectedToGateway": "Telefoon is verbonden met gateway"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Gateway verbinden met wifi"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Kies een wifi-netwerk waarmee u uw gateway wilt verbinden."), _defineProperty(_offline, "scanNetwork", "Wi-Fi-netwerk scannen"), _defineProperty(_offline, "enterPassword", "Voer het wachtwoord in voor"), _defineProperty(_offline, "join", "Meedoen"), _defineProperty(_offline, "gatewayConnected", "Gateway is succesvol verbonden met %{selectedWifi}"), _defineProperty(_offline, "disconnectPhoneFromGateway", "U kunt nu uw telefoon loskoppelen van uw gateway-netwerk en deze verbinden met uw wifi/uw mobiele data inschakelen"), _defineProperty(_offline, "failedToConnect", "Kan niet verbinden"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "Zorg ervoor dat uw gateway is aangesloten op een stroombron en dat u zich in de buurt van uw gateway bevindt."), _defineProperty(_offline, "routerIsOn", "Zorg ervoor dat uw wifi-router is ingeschakeld en dat u zich in de buurt van uw wifi-router bevindt"), _defineProperty(_offline, "unableToDisplayNetworks", "Kan wifi-netwerken niet weergeven"), _defineProperty(_offline, "errorDisplayingNetworks", "Er is een fout opgetreden bij het weergeven van wifi-netwerken vanwege een aantal technische problemen. Probeer het opnieuw."), _defineProperty(_offline, "errorInConnectingToWifi", "Er is een fout opgetreden bij het verbinden met het wifi-netwerk. Probeer het later opnieuw of maak verbinding met een ander netwerk."), _defineProperty(_offline, "unableToConnect", "Niet in staat te verbinden"), _defineProperty(_offline, "pairGateway", "Koppel de gateway met je telefoon via bluetooth."), _offline),
  "tutorial": {
    "back": "Terug",
    "apMode": "Hoe de AP-modus in te schakelen",
    "step1": "Stap 1 van 3",
    "step2": "Stap 2 van 3",
    "step3": "Stap 3 van 3",
    "powerOnGateway": "Gateway inschakelen",
    "title2": "Druk op de AP-modusknop",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Ga aan de slag",
    "next": "Volgende stap",
    "prev": "Vorige stap",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "Dat is het!",
    "step1of2": "Step 1 of 2",
    "step2of2": "Step 2 of 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Laten we proberen de gateway met uw telefoon te verbinden. Zorg ervoor dat u zich in de buurt van uw gateway bevindt en dat uw mobiele mobiele data is uitgeschakeld"
  }
};
module.exports = mobile;